// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/mks_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/microsoftid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/mksapp/down-arrow-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/editicon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/common/loaderblue.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/mkspropmanagment/cloud-upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/check-circle-green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/cancel-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/download-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/skill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/skilldev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/mksapp/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/mksapp/help.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/minusicon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/add-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/asc-arrow-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/desc-arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/default-sort-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/mksapp/plus-icon-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/mks_logo-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/mksapp/custom-checkbox-checkmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/mksapp/left-double-arrow-icon-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/mksapp/chat-icon-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/prompt-suggetion.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/copy-content.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/user-dashboard-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/chat-dashboard-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../images/session-dashboard-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/location-dashboard-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../images/mksapp/circle-stop-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../images/mksapp/regenerate-icon-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/mksapp/icon-send-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../images/mksapp/copy-icon-line-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/mksapp/thumbs-up-line-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/mksapp/thumbs-down-line-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/mksapp/edit-outline-icon-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/rightpannel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/checklist.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/mksapp/left-expand-icon-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/pdf.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../images/rightpanel-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../images/common/waving-hand-emoji.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/bookmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../images/mksapp/background-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../images/mksapp/folder-plus-icon-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../images/mksapp/search-icon-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../images/mksapp/chatbubble-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../images/mksapp/chatbubble-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../images/common/mks_search_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../images/common/close-circle-outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/mksapp/eye-icon-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/share-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/mkspropmanagment/comments-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/mkspropmanagment/eyewhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../images/mksapp/favourite-icon-inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../images/mksapp/favourite-icon-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/mksapp/down-arrow_154710.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../images/mksapp/solid-plus-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../images/mksapp/reports-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../images/mksapp/service-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/mksapp/to-do-list-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/mksapp/checkmark-circle-outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/mksapp/checkmark-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/mksapp/statusnow-msngr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/mksapp/statusnow-info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/tr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../images/logout-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../images/mkspropmanagment/home.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../images/mkspropmanagment/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("../images/mkspropmanagment/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("../images/mkspropmanagment/close-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("../images/img-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("../images/xls.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("../images/html-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("../images/tiff-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("../images/ppt-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("../images/word-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("../images/des-file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("../images/private-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("../images/public-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("../images/star-border.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("../images/cancel-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("../images/menuwhite.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("../images/menu_open.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("../images/menu-blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("../images/attach-file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("../images/trashicon-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("../images/follow-up-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("../images/trashicon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("../images/follow-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("../images/mks_logo-blue-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("../images/mks_logo-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("../images/mkspropmanagment/homegreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("../images/gridlist.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("../images/gridlist-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("../images/mksapp/dot-bg-1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  font-family: sans-serif;
}

body {
  margin: 0;
}

.margin-model {
  margin-top: 10px;
}

.margin-bottom {
  margin-bottom: 10px;
}

.item-video {
  margin-top: 15px;
}

.item-video iframe {
  border-radius: 6px;
}

.release-container {
  max-width: 1800px;
  /* margin: auto; */
  padding: 10px 30px 40px 20px;
}

.release-header h1 {
  font-size: 32px;
}

.version {
  color: #1a73e8;
}

.release-video {
  margin: 30px 0;
}

.release-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.release-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upcoming-grid {
  /* display: grid; */
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}

.upcoming-card {
  background: white;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.upcoming-release-no-records {
  margin-top: 20px;
  text-align: center;
  background: #f5f6fe;
  min-height: 300px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
}

.upcoming-image {
  width: 100%;
  height: 480px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
}

.badge {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  color: white;
}

.feature {
  background: #28a745;
}

.improvement {
  background: #007bff;
}

.bugfix {
  background: #dc3545;
}

.teaser img {
  width: 100%;
  border-radius: 8px;
  margin-top: 20px;
}

.model-dropdown {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  position: absolute;
  right: 78px;
  top: 4px;
}

.model-card {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #ffffff;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  vertical-align: baseline;
  display: inline-block;
}

audio:not([controls]) {
  height: 0;
  display: none;
}

[hidden],
template {
  display: none;
}

a {
  background-color: #0000;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  margin: 0.67em 0;
  font-size: 2em;
}

mark {
  color: #000;
  background: #ff0;
}

small {
  font-size: 80%;
}

sub,
sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

hr {
  box-sizing: content-box;
  height: 0;
}

pre {
  overflow: auto;
  white-space: normal;
}

code,
kbd,
pre,
samp {
  font-family: monospace;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input {
  line-height: normal;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: none;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

legend {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
}

optgroup {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

@font-face {
  font-family: webflow-icons;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

[class^="w-icon-"],
[class*=" w-icon-"] {
  speak: none;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  font-family: webflow-icons !important;
}

.w-icon-slider-right:before {
  content: "";
}

.w-icon-slider-left:before {
  content: "";
}

.form-config-box .custom-dropdown {
  min-width: 100%;
}

.dropdown-button-span {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.w-icon-nav-menu:before {
  content: "";
}

.disabled-dropdown {
  background-color: #f2f2f2;
}

.w-icon-arrow-down:before,
.w-icon-dropdown-toggle:before {
  content: "";
}

.w-icon-file-upload-remove:before {
  content: "";
}

.w-icon-file-upload-icon:before {
  content: "";
}

* {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  color: #333;
  background-color: #fff;
  min-height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

img {
  vertical-align: middle;
  max-width: 100%;
  display: inline-block;
}

html.w-mod-touch * {
  background-attachment: scroll !important;
}

.w-block {
  display: block;
}

.w-inline-block {
  max-width: 100%;
  display: inline-block;
}

.w-clearfix:before,
.w-clearfix:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-clearfix:after {
  clear: both;
}

.w-hidden {
  display: none;
}

.w-button {
  color: #fff;
  line-height: inherit;
  cursor: pointer;
  background-color: #3898ec;
  border: 0;
  border-radius: 0;
  padding: 9px 15px;
  text-decoration: none;
  display: inline-block;
}

.w-button-disabled {
  background-color: #81b9ec !important;
}

input.w-button {
  -webkit-appearance: button;
}

html[data-w-dynpage] [data-w-cloak] {
  color: #0000 !important;
}

.w-code-block {
  margin: unset;
}

pre.w-code-block code {
  all: inherit;
}

.w-optimization {
  display: contents;
}

.w-webflow-badge,
.w-webflow-badge * {
  z-index: auto;
  visibility: visible;
  box-sizing: border-box;
  float: none;
  clear: none;
  box-shadow: none;
  opacity: 1;
  direction: ltr;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  font-style: inherit;
  font-variant: inherit;
  text-align: inherit;
  letter-spacing: inherit;
  -webkit-text-decoration: inherit;
  text-decoration: inherit;
  text-indent: 0;
  text-transform: inherit;
  text-shadow: none;
  font-smoothing: auto;
  vertical-align: baseline;
  cursor: inherit;
  white-space: inherit;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  background: none;
  border: 0 #0000;
  border-radius: 0;
  width: auto;
  min-width: 0;
  max-width: none;
  height: auto;
  min-height: 0;
  max-height: none;
  margin: 0;
  padding: 0;
  list-style-type: disc;
  transition: none;
  display: block;
  position: static;
  inset: auto;
  overflow: visible;
  transform: none;
}

.w-webflow-badge {
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 0 0 1px #0000001a, 0 1px 3px #0000001a;
  visibility: visible !important;
  z-index: 2147483647 !important;
  color: #aaadb0 !important;
  opacity: 1 !important;
  background-color: #fff !important;
  border-radius: 3px !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  padding: 6px !important;
  font-size: 12px !important;
  line-height: 14px !important;
  text-decoration: none !important;
  display: inline-block !important;
  position: fixed !important;
  inset: auto 12px 12px auto !important;
  overflow: visible !important;
  transform: none !important;
}

.w-webflow-badge>img {
  visibility: visible !important;
  opacity: 1 !important;
  vertical-align: middle !important;
  display: inline-block !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 10px;
  font-weight: bold;
}

h1 {
  margin-top: 20px;
  font-size: 38px;
  line-height: 44px;
}

h2 {
  margin-top: 20px;
  font-size: 32px;
  line-height: 36px;
}

h3 {
  margin-top: 20px;
  font-size: 24px;
  line-height: 30px;
}

h4 {
  margin-top: 10px;
  font-size: 18px;
  line-height: 24px;
}

h5 {
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
}

h6 {
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
}

blockquote {
  border-left: 5px solid #e2e2e2;
  margin: 0 0 10px;
  padding: 10px 20px;
  font-size: 18px;
  line-height: 22px;
}

figure {
  margin: 0 0 10px;
}

figcaption {
  text-align: center;
  margin-top: 5px;
}

ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
  padding-left: 40px;
}

.w-list-unstyled {
  padding-left: 0;
  list-style: none;
}

.w-embed:before,
.w-embed:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-embed:after {
  clear: both;
}

.w-video {
  width: 100%;
  padding: 0;
  position: relative;
}

.w-video iframe,
.w-video object,
.w-video embed {
  border: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

button,
[type="button"],
[type="reset"] {
  cursor: pointer;
  -webkit-appearance: button;
  border: 0;
}

.btn-add-promt {
  float: right;
  width: 115px;
}

.w-form {
  margin: 0 0 15px;
}

.w-form-done {
  text-align: center;
  background-color: #ddd;
  padding: 20px;
  display: none;
}

.w-form-fail {
  background-color: #ffdede;
  margin-top: 10px;
  padding: 10px;
  display: none;
}

label {
  margin-bottom: 5px;
  font-weight: bold;
  display: block;
}

.chart-row-view {
  display: flex;
  gap: 20px;
}

.chart-display-width {
  width: 50%;
}

.chart-button-display {
  padding: 6px 21px;
  background: transparent;
  border: 1px solid #ededed;
  border-radius: 5px;
}

.chart-div-display {
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  gap: 15px;
  justify-content: center;
}

.filter-display-boarder {
  background: #f5f5f5;
  padding: 16px;
  text-align: center;
  border-radius: 10px;
}

#maps_control_1 {
  border: 1px solid #ccc;
  margin-top: 19px;
}

.chart-active-button {
  background: #053a64;
  color: #fff;
}

.chart-left-border-radius {
  border-radius: 5px 0 0 5px;
}

.chart-right-border-radius {
  border-radius: 0 5px 5px 0;
}

.section-wrapper-graphs {
  overflow-y: auto;
  min-height: calc(100vh - 200px);
}

.table-chat-view:has(> table) {
  white-space: normal !important;
}

.table-chat-view table {
  width: 100%;
  margin: 8px 0;
}

.table-chat-view table thead th,
.table-chat-view table tbody td {
  padding: 3px 5px;
  border-bottom: 1px solid #ccc;
}

.w-input,
.w-select {
  color: #333;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #ccc;
  width: 100%;
  height: 38px;
  margin-bottom: 10px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.42857;
  display: block;
}

.w-input::placeholder,
.w-select::placeholder {
  color: #999;
}

.w-input:focus,
.w-select:focus {
  border-color: #3898ec;
  outline: 0;
}

.chat-button-visibility {
  opacity: 0.5 !important;
}

/* .disabled-parent {
  pointer-events: none !important;
} */

.disabled-element {
  cursor: not-allowed !important;
}

.disabled-delete {
  opacity: 0.5;
  /* Optional: Add additional styles to convey disabled state */
  background-color: #f2f2f2;
  color: #999;
  cursor: not-allowed;
}

.disabled-div {
  pointer-events: none;
  opacity: 0.5;
  /* Optional: Add additional styles to convey disabled state */
  /* background-color: #f2f2f2; */
  color: #999;
  cursor: not-allowed;
}

.error-text {
  color: red;
  font-size: 10px;
  display: block;
  margin-top: 4px;
  position: absolute;
  bottom: -17px;
}

.input-wrapper {
  position: relative;
}

.input-date-text {
  border: 1px solid #e5e5e5;
  padding: 4px;
  border-radius: 5px;
  width: 100%;
}

.suggest-line-disabled-div {
  pointer-events: none;
  opacity: 0.5;
  /* Optional: Add additional styles to convey disabled state */
  /* background-color: #f2f2f2; */
  color: #fff;
  cursor: not-allowed;
}

.disabled-btn {
  background-color: #f2f2f2;
  color: #999;
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
}

.w-input[disabled],
.w-select[disabled],
.w-input[readonly],
.w-select[readonly],
fieldset[disabled] .w-input,
fieldset[disabled] .w-select {
  cursor: not-allowed;
}

.w-input[disabled]:not(.w-input-disabled),
.w-select[disabled]:not(.w-input-disabled),
.w-input[readonly],
.w-select[readonly],
fieldset[disabled]:not(.w-input-disabled) .w-input,
fieldset[disabled]:not(.w-input-disabled) .w-select {
  background-color: #eee;
}

textarea.w-input,
textarea.w-select {
  height: auto;
}

.w-select {
  background-color: #f3f3f3;
}

.w-select[multiple] {
  height: auto;
}

.w-form-label {
  cursor: pointer;
  margin-bottom: 0;
  font-weight: normal;
  display: inline-block;
}

.w-radio {
  margin-bottom: 5px;
  padding-left: 20px;
  display: block;
}

.w-radio:before,
.w-radio:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-radio:after {
  clear: both;
}

.w-radio-input {
  float: left;
  margin: 3px 0 0 -20px;
  line-height: normal;
}

.w-file-upload {
  margin-bottom: 10px;
  display: block;
}

.w-file-upload-input {
  opacity: 0;
  z-index: -100;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
  overflow: hidden;
}

.w-file-upload-default,
.w-file-upload-uploading,
.w-file-upload-success {
  color: #333;
  display: inline-block;
}

.w-file-upload-error {
  margin-top: 10px;
  display: block;
}

.w-file-upload-default.w-hidden,
.w-file-upload-uploading.w-hidden,
.w-file-upload-error.w-hidden,
.w-file-upload-success.w-hidden {
  display: none;
}

.w-file-upload-uploading-btn {
  cursor: pointer;
  background-color: #fafafa;
  border: 1px solid #ccc;
  margin: 0;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: normal;
  display: flex;
}

.w-file-upload-file {
  background-color: #fafafa;
  border: 1px solid #ccc;
  flex-grow: 1;
  justify-content: space-between;
  margin: 0;
  padding: 8px 9px 8px 11px;
  display: flex;
}

.w-file-upload-file-name {
  font-size: 14px;
  font-weight: normal;
  display: block;
}

.w-file-remove-link {
  cursor: pointer;
  width: auto;
  height: auto;
  margin-top: 3px;
  margin-left: 10px;
  padding: 3px;
  display: block;
}

.btn-delete-prompt {
  padding-right: 5px;
}

.w-icon-file-upload-remove {
  margin: auto;
  font-size: 10px;
}

.error-msg {
  margin: 0;
  padding: 8px;
  font-size: 11px;
}

.w-file-upload-error-msg {
  color: #ea384c;
  padding: 2px 0;
  display: inline-block;
}

.w-file-upload-info {
  padding: 0 12px;
  line-height: 38px;
  display: inline-block;
}

.w-file-upload-label {
  cursor: pointer;
  background-color: #fafafa;
  border: 1px solid #ccc;
  margin: 0;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: normal;
  display: inline-block;
}

.btn-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadspinner {
  margin-right: 5px;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.w-icon-file-upload-icon,
.w-icon-file-upload-uploading {
  width: 20px;
  margin-right: 8px;
  display: inline-block;
}

.w-icon-file-upload-uploading {
  height: 20px;
}

.w-container {
  max-width: 940px;
  margin-left: auto;
  margin-right: auto;
}

.w-container:before,
.w-container:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-container:after {
  clear: both;
}

.w-container .w-row {
  margin-left: -10px;
  margin-right: -10px;
}

.w-row:before,
.w-row:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-row:after {
  clear: both;
}

.user-role-row {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr 100px;
  padding: 5px 10px;
  border-top: 1px solid #ccc;
  align-items: center;
}

.w-row .w-row {
  margin-left: 0;
  margin-right: 0;
}

.w-col {
  float: left;
  width: 100%;
  min-height: 1px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
}

.w-col .w-col {
  padding-left: 0;
  padding-right: 0;
}

.w-col-1 {
  width: 8.33333%;
}

.w-col-2 {
  width: 16.6667%;
}

.w-col-3 {
  width: 25%;
}

.w-col-4 {
  width: 33.3333%;
}

.w-col-5 {
  width: 41.6667%;
}

.w-col-6 {
  width: 50%;
}

.w-col-7 {
  width: 58.3333%;
}

.w-col-8 {
  width: 66.6667%;
}

.w-col-9 {
  width: 75%;
}

.w-col-10 {
  width: 83.3333%;
}

.w-col-11 {
  width: 91.6667%;
}

.w-col-12 {
  width: 100%;
}

.w-hidden-main {
  display: none !important;
}

.login-form-wrapper {
  grid-column-gap: 30px;
  grid-row-gap: 30px;
  text-align: center;
  background-color: #fff;
  border-radius: 0 20px 20px 0;
  flex-flow: column;
  flex: 0 1 auto;
  align-items: center;
  width: 40%;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  padding: 5% 6%;
  display: flex;
  justify-content: center;
}

.skills-tabs .ai-collection-grid {
  background: #f5f5f5;
}

.skills-tabs .ai-collection-grid.light {
  padding: 20px;
  border-radius: 10px;
}

.form-wrapper {
  width: 70%;
}

/* --------------Start of Prompt Table  csss--------- */

.custom-div-table {
  padding: 10px;
}

.div-table-header {
  background-color: #0062ff;
  color: white;
}

.div-table-body {
  border: 1px solid #e5e5e5;
  max-height: 180px;
  overflow-y: auto;
  border-radius: 5px !important;
}

.chat-bottom-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.chat-sort {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}

.chat-order-select {
  background: #f5f7f8;
  border: 0;
  font-size: 12px;
  padding: 6px 6px;
  border-radius: 5px;
}

.div-table-row {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}

.div-table-cell {
  padding: 12px;
  border-right: 1px solid #ddd;
  text-align: left;
}

.div-table-cell:last-child {
  border-right: none;
  /* Remove border from the last cell */
}

.div-table-body .div-table-row:nth-child(even) {
  background-color: #f3f3f3;
  /* Alternating row color */
}

.div-table-body .div-table-row:hover {
  background-color: #f1f1f1;
  /* Hover effect */
}

.div-table-header .div-table-cell {
  color: #fff;
  padding: 5px 10px;
}

.prompt-down-arrow {
  position: absolute;
  right: 7px;
  cursor: pointer;
  top: 6px;
}

.upperchartbox {
  position: absolute;
  bottom: 65px;
  background: #fff;
  margin: 0 20px;
  box-shadow: 2px 2px 10px #e5e5e5;
  right: 0;
  left: 0;
  z-index: 1;

  /* max-height: 300px;
  overflow-y: auto; */
}

.upperchartbox-wide {
  padding: 10px;
}

.upperchartbox-home {
  position: absolute;
  top: 52px;
  background: #fff;
  box-shadow: 2px 2px 10px #e5e5e5;
  right: 0;
  left: 0;
  z-index: 1;
}

.dark-theme .upperchartbox-home {
  color: #000;
}

.dark-theme .upperchartbox-home .prompt-tabs-link.w--current {
  border-bottom-color: #053a64;
  color: #053a64;
}

.chatpromp .skill-filter-wrapper {
  padding: 10px;
  border: 0;
}

.prompt-head {
  font-weight: 500;
}

.chatprompt-block {
  position: relative;
}

.center {
  text-align: center;
}

.empty-row {
  text-align: center;

  grid-template-columns: 1fr !important;
}

.auto-chat-row,
.chat-table-lis-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.chat-table-lis-row {
  /* font-size: 11px; */
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.auto-chat-row {
  border-bottom: 1px solid #cccccc;
  padding-bottom: 6px;
  margin-bottom: 5px;
  font-weight: 600;
  position: relative;
}

.auto-chat-row.auto-col-3,
.chat-table-lis-row.auto-col-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

.auto-chat-row.auto-col-5,
.chat-table-lis-row.auto-col-5 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
}

.empty-row .div-table-cell {
  text-align: center;
}

/* ------------- end of prompt table ----css */

.text-left {
  text-align: left;
  margin-bottom: 25px;
}

.full-width {
  width: 100%;
}

.recent-comments .full-width {
  width: 92%;
}

.submit-button {
  border-radius: 5px;
  font-size: 16px;
}

.text-left label {
  font-size: 16px;
}

.login-form-logo {
  width: 60%;
  justify-content: center;
  display: flex;
  align-items: center;
}

.input-field {
  border-radius: 5px;
}

.flex-end {
  justify-content: flex-end;
}

.login-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 220px;
  height: 120px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.login-form-wrapper h1 {
  margin: 0;
}

.auth-logo-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 140px;
  height: 45px;
  background-size: 130px;
  background-repeat: no-repeat;
}

.autl-logo-link button {
  display: flex;
  background-color: transparent;
  align-items: center;
  font-size: 14px;
  gap: 10px;
  width: 100%;
  justify-content: center;
  padding: 14px;
  border-radius: 5px;
  /* border: 1px solid #e5e5e5; */
}

.right-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  transform: rotate(270deg);
}

.edit-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 19px;
  height: 19px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.edit-button-icon {
  display: flex;
  gap: 3px;
  align-items: center;
  border-right: 1px solid #ccc;
  padding-right: 11px;
}

.trash-button-icon {
  display: flex;
  gap: 3px;
  align-items: center;
}

.trash-button-icon .trash-icon::after {
  display: none;
}

.light-theme .use-skill-row-wrap .trash-button-icon {
  filter: brightness(0.5);
}

.dark-theme .user-table-row {
  color: #000;
}

.dark-theme .trash-button-icon.light-gray-button a {
  color: #000;
}

.dark-theme .trash-button-icon.light-gray-button.trash-icon {
  filter: invert(1);
}

.skill-detaill-right-full .trash-icon:hover::before {
  display: none;
}

.edit-button-icon a {
  color: #053a64;
  text-decoration: none;
}

.trash-button-icon a {
  color: #5f5a5a;
  text-decoration: none;
}

.auth-logo-link .azure-btn {
  display: flex;
  background-color: #00567d;
  align-items: center;
  font-size: 14px;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
  padding: 14px;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
}

.auth-logo-link .login-small-text {
  color: #fff;
  font-weight: 500;
}

.text-label {
  font-weight: 700;
  color: #00567d;
  font-size: 18px;
  text-transform: uppercase;
}

.auth-logo-link {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.login-small-text {
  /* border-right: 1px solid #e5e5e5; */
  height: 100%;
  display: flex;
  align-items: center;
  /* padding-right: 22px; */
  font-weight: 800;
  color: #00567d;
  font-size: 18px;
}

.autl-logo-link {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  font-weight: 600;
}

.loader {
  display: none;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  background-position: 50% 50vh !important;
  background-size: 50px !important;
  background-repeat: no-repeat !important;
}

.loader.show {
  display: block !important;
  position: fixed;
  cursor: progress !important;
  z-index: 99999;
}

.loader-base {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  /* background: red; */
  z-index: 99;
}

.overlay-loading {
  width: 100%;
  height: 100%;
  /* background-image: url(../images/common/loaderblue.gif) !important; */
  background-position: center !important;
  background-size: 50px !important;
  background-repeat: no-repeat !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  position: fixed;
  cursor: progress !important;
  z-index: 99999;
  align-items: center;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #fffdfd63;
}

.loader-dot {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #509cdb;
}

/* .loader-dot2{
  animation-delay: 0s;
  
}

.loader-dot3{
  animation-delay: 0.5s;
 
}

.loader-dot4{
  animation-delay: 1s;
  
}
.loader-wrap{
  width: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
@keyframes circleMove {
  0% {
    transform: rotate(0deg) translateX(10px);
  }
  100% {
     transform: rotate(360deg) translateX(10px);
  }
} */

.loader-dot1 {
  visibility: hidden;
}

/* .loader-dot1, .loader-dot2, .loader-dot3, .loader-dot4{
  animation: ani 2s linear infinite;
} */
.loader-dot2 {
  background-color: hsl(203, 100%, 27%);
  animation: movebottom 3.5s infinite;
  animation-delay: 0.2s;
}

.loader-dot3 {
  background-color: #6f94bb;
  top: 26px;
  animation: moveleft 3.5s infinite;
  animation-delay: 0.4s;
}

.buttonpopup {
  position: relative;
}

.loader-dot4 {
  background-color: #a0b6d3;
  top: 26px;
  left: -26px;
  animation: movetop 3.5s infinite;
  animation-delay: 0.6s;
}

.loader-wrap {
  width: 117px;
  position: relative;
  right: -51px;
}

.pagination-custom {
  display: flex;
  justify-content: flex-end;
}

.dark-theme .create-skill-left .skill-update-box .prompt-title {
  color: #000;
}

.pagination-custom a {
  color: black;
  float: left;
  padding: 5px 14px;
  text-decoration: none;
  transition: background-color 0.3s;
  border: 1px solid #ddd;
  margin: 0 4px;
  border-radius: 5px;
  font-size: 12px;
}

.flex {
  display: flex;
}

.pagination-custom a.active {
  background-color: #053a64;
  color: white;
  border: 1px solid #053a64;
  border-radius: 5px;
}

.pagination-custom a:hover:not(.active) {
  background-color: #ddd;
}

.loader-text {
  position: absolute;
  top: 56px;
  width: 100%;
  right: 54px;
  font-weight: 600;
  color: #00558a;
  font-size: 12px;
  font-family: Poppins, sans-serif;
  background: #ffffff;
  padding: 5px;
}

.loader-text.login-text-loader {
  background: transparent;
  color: #fff;
}

.dropbox-wrapper {
  border: 2px dashed #ccc;
  padding: 5px;

  text-align: center;
}

.dropbox-wrapper-main {
  padding: 6px 40px;
}

.f-10 {
  font-size: 10px;
}

.flex-line {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.uplod-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  width: 25px;
  height: 25px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.success-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  width: 32px;
  height: 32px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.error-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  width: 32px;
  height: 32px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.dark-theme .download-text .download-arrow {
  filter: brightness(8);
}

/* .import-section > button {
  position: absolute;
  right: 0;
  top: 10px;
} */
.description-rows {
  display: flex;
  flex-flow: column;
  max-height: calc(100vh - 460px);
  overflow-y: auto;
}

.linkcss {
  font-weight: 400;

  margin-bottom: 0;
  text-align: center;
}

.bluelink {
  color: #0063ff;
  margin-right: 4px;
  cursor: pointer;
}

.dark-theme .bluelink {
  color: #5194ff;
}

textarea.chat-input-field.w-input.home-chat-field.scrollinput {
  margin: 0 0 0 -10px;
  padding: 10px 5px 10px 10px;
}

.flex-line .prompt-img {
  margin: 4px auto;
  max-width: 50px;
  height: 50px;
  cursor: pointer;
}

.download-text {
  display: flex;
  cursor: pointer;
}

.light-text {
  font-size: 12px;
  color: #807c7c;
  margin-bottom: 0;
}

.import-prompt-box {
  padding: 20px 40px 0 40px;
}

.download-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 20px;
  height: 20px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.user-text h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
}

.user-breif {
  display: flex;
  gap: 10px;
}

.user-image {
  border-radius: 100%;
  overflow: hidden;
}

.small-text {
  font-size: 12px;
}

.small-text-anchor {
  font-size: 12px;
  color: blue;
  cursor: pointer;
  text-decoration: none;
}

.unread-notif {
  background: #f7f7f7;
  color: #0092ff;
}

.user-breif.selected {
  border: 1px solid #0063ff;
}

.user-name-box.user-profile-initial {
  background-color: #7fb0ff;
}

.error-rows {
  padding: 0;
  list-style: none;
  color: #e74c3c;
  font-size: 12px;
  max-height: calc(100vh - 413px);
  overflow-y: auto;
}

.import-section {}

@keyframes movebottom {
  0% {
    top: 0px;
  }

  40% {
    top: 26px;
    left: 0px;
  }

  80% {
    top: 26px;
    left: -26px;
  }

  100% {
    top: 0px;
    left: 0px;
  }
}

@keyframes moveleft {
  0% {
    top: 26px;
    left: 0px;
  }

  40% {
    top: 26px;
    left: -26px;
  }

  80% {
    top: 0px;
    left: 0px;
  }

  100% {
    top: 26px;
    left: 0px;
  }
}

@keyframes movetop {
  0% {
    top: 26px;
    left: -26px;
  }

  40% {
    top: 0px;
    left: 0px;
  }

  80% {
    top: 26px;
    left: 0px;
  }

  100% {
    top: 26px;
    left: -26px;
  }
}

/* .dark-theme .loader-dot {
  background-color: #80CE1A;
} */

/* .dark-theme .loader-dot2 {
  background-color: #5f9c0f;
  animation: movebottomgreen 3.5s infinite;
  animation-delay: 0.2s;
}

.dark-theme .loader-dot3 {
  background-color: #78c219;
  top: 26px;
  animation: moveleftgreen 3.5s infinite;
  animation-delay: 0.4s;
}

.dark-theme .loader-dot4 {
  background-color: #b4f164;
  top: 26px;
  left: -26px;
  animation: movetopgreen 3.5s infinite;
  animation-delay: 0.6s;
}

.dark-theme .loader-wrap {
  width: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  position: relative;
} */

.dark-theme .workspace-dashboard.flex-end {
  background-color: #053a64;
}

.dark-theme .loader-text {
  background-color: transparent;
  color: #fff;
}

.dark-theme .login-form-wrapper .submit-button.w-button.full-width {
  color: #fff;
}

@keyframes movebottomgreen {
  0% {
    top: 0px;
  }

  40% {
    top: 26px;
    left: 0px;
  }

  80% {
    top: 26px;
    left: -26px;
  }

  100% {
    top: 0px;
    left: 0px;
  }
}

@keyframes moveleftgreen {
  0% {
    top: 26px;
    left: 0px;
  }

  40% {
    top: 26px;
    left: -26px;
  }

  80% {
    top: 0px;
    left: 0px;
  }

  100% {
    top: 26px;
    left: 0px;
  }
}

@keyframes movetopgreen {
  0% {
    top: 26px;
    left: -26px;
  }

  40% {
    top: 0px;
    left: 0px;
  }

  80% {
    top: 26px;
    left: 0px;
  }

  100% {
    top: 26px;
    left: -26px;
  }
}

/*********skilldetail**************/

.skill-detail-wrapper {
  display: flex;
  padding: 0 40px 20px;
}

.skill-heading h2 {
  font-size: 24px;
  margin: 0;
}

.skill-detail-left {
  padding: 0 20px 0 0;
  width: 75%;
  grid-column-gap: 20px;
  background-color: #fff;
  flex-flow: column;
  display: flex;
  position: relative;
  grid-row-gap: 20px;
  border-radius: 10px 0 0 10px;
}

.skill-detaill-right {
  width: 25%;
  padding: 20px;
  grid-column-gap: 20px;
  background-color: #f5f5f5;
  flex-flow: column;
  display: flex;
  position: relative;
  grid-row-gap: 20px;
  border-radius: 10px;
}

.skill-detaill-right-full {
  width: 25%;
}

.use-skill-row-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 13px;
  gap: 10px;
}

.skill-detaill-right-full h3 {
  margin: 0;
}

.skill-detaill-right-section {
  padding: 20px;
  grid-column-gap: 20px;
  background-color: #f5f5f5;
  flex-flow: column;
  display: flex;
  position: relative;
  grid-row-gap: 20px;
  border-radius: 10px;
}

.skill-full-wrap {
  padding: 0 40px 20px;
}

.skill-subheading {
  margin: 0;
  font-size: 18px;
  padding-bottom: 10px;
}

.skill-flex-col {
  display: flex;
  gap: 15px;
  border-top: 1px solid #e5e5e5;
  padding-top: 24px;
}

.skill-card-small {
  width: 100%;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 10px 12px;
}

.skill-block-header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.version-link .col-text:hover {
  background: #1459c7;
}

.use-skill-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  width: 18px;
  height: 24px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.dropchat-wrap .search-input-field {
  border: 0;
  background: transparent;
}

.dropchat-wrap .search-input-field:focus {
  background-color: transparent;
}

.use-skill {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 11px;
  gap: 5px;
  color: #000;
}

.use-skill-icon.active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.skill-icon-block {
  width: 58px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.skill-detaill-right h3 {
  font-size: 16px;
  margin: 0;
}

.skill-subtitle {
  font-size: 12px;
  color: #053a64;
  font-weight: 600;
}

.skill-subtitle-info {
  font-weight: 500;
  font-size: 13px;
}

.skill-card-small p {
  margin: 0;
}

.skill-update-box {
  display: flex;
  gap: 20px;
  width: 100%;
  background: #f5f5f5;
  padding: 16px;
  border-radius: 10px;
}

.contact-detail {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
}

.skill-icon-circle {
  width: 40px;
  height: 40px;
  background: #e5e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}

.skill-desc p {
  font-size: 13px;
}

.skill-desc,
.skill-tags,
.skill-contact-detail {
  padding-bottom: 18px;
}

.skill-tags {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 10px;
}

.skill-contact-detail {
  padding-top: 20px;
}

.skill-contact-person {
  display: flex;
  gap: 20px;
  width: 100%;
  background: #f5f5f5;
  padding: 16px;
  border-radius: 10px;
}

.contact-detail-box {
  display: flex;
  gap: 15px;
  flex-direction: column;
}

.version-col {
  display: flex;
  gap: 20px;
  background: #f5f5f5;
  padding: 14px;
  border-radius: 10px;
  flex-wrap: wrap;
}

.col-text {
  color: #053a64;
  font-weight: 600;
  font-size: 12px;
}

.version-link .col-text {
  color: #fff;
  text-decoration: none;
  display: block;
  background-color: #0063ff;
  padding: 2px 15px;
  border-radius: 5px;
}

.version-link .col-text:hover {
  color: #fff;
}

.skill-tags .skill-keyword {
  font-size: 11px;
}

.skill-col {
  width: 100%;
}

.breadcrumb {
  display: flex;
  align-items: center;
  padding: 20px 40px 0;
}

.breadcrumb a {
  display: flex;
  text-decoration: none;

  align-items: center;
}

.home-link::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
  opacity: 0.6;
}

.normal-link::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
  opacity: 0.6;
}

.normal-link:last-child::after {
  display: none;
}

.breadcrumb a.normal-link {
  color: #ada3a3;
  font-size: 13px;
}

.breadcrumb a.normal-link:last-child::after {
  display: none;
}

.infotext::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
}

.use-skill-row {
  width: 100%;
}

.use-skill-row .button {
  width: 100%;
  font-size: 12px;
  text-align: center;
}

.infotext {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 5px;
}

/********custom dropdown********/

.custom-dropdown .dropdown-menu-custom li label {
  display: flex;
  gap: 10px;
  font-weight: 400;
  font-size: 12px;
}

.custom-dropdown .dropdown-menu-custom {
  background-color: #f5f7f8;
  color: #7a7a7a;
}

.down-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.justify-between {
  justify-content: space-between;
}

.dropdown-nav {
  color: #fff;
  font-size: 12px;
  padding-left: 30px;
}

.dropdown-nav a.dropdown-item {
  color: #fff;
  text-decoration: none;
}

.dropdown-item {
  word-break: auto-phrase;
  padding: 4px 10px;
  white-space: normal;
  display: flex;
  gap: 5px;
}

.dash-menu.open .dropdown-nav {
  position: absolute;
  top: 24px;
  z-index: 2;
  background: #053a64;
  color: #fff;
  border: 1px solid #e5e5e3;
  left: 50px;
  width: 200px;
  padding-left: 0;
  border-radius: 7px;
}

.menu-icon-nested {
  width: 18px;
  height: 18px;
}

.light-theme .dash-menu .dropdown-label .down-arrow {
  filter: invert(1);
}

.light-theme .dash-menu .dropdown-label:hover .down-arrow {
  filter: invert(0);
}

.dash-menu.open .dropdown-item {
  font-size: 10px;
  padding: 2px 10px;
}

.dash-menu.open .dropdown-item:hover::after {
  display: none;
}

.dash-menu.open .dropdown-items {
  position: relative;
}

.dash-menu.open .down-arrow {
  display: none;
}

.dash-menu.open .flex-links {
  width: auto;
}

.dropdown-nav a.dropdown-item:hover {
  background-color: #ffffff;
  color: #053a64;
  border-radius: 40px;
}

.dropdown-item:hover .menu-icon-nested {
  filter: invert(1);
}

.down-arrow-white {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.upperchartbox-wide .down-arrow {
  z-index: 10;
}

.custom-dropdown .dropdown-button {
  padding: 9px 3px 9px 9px;
  border: 0;
  background-color: #f5f7f8;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  color: #7a7a7a;
  justify-content: space-between;
}

.form-config-box .dropdown-button {
  background-color: #ffffff;
  padding: 6px;
  border: 1px solid #e5e5e5;
}

.form-config-box .custom-dropdown .dropdown-menu-custom {
  background-color: #ffffff;
  box-shadow: 1px 14px 10px #e5e5e5;
  border: 0;
  border-radius: 0 0px 5px 5px;
}

.dark-theme .form-config-box .custom-dropdown .dropdown-menu-custom {
  box-shadow: 1px 14px 10px #042947;
}

.dark-theme .no-users-found {
  color: #053a64;
}

.dropdown-with-button {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: flex-end;
}

.dropdown-with-button .prompt-title-wrap {
  width: 200px;
}

.bot-configuration {}

.bot-configuration h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.bot-configuration .form-group {
  display: flex;
  align-items: center;
  gap: 20px;
}

.form-group .form-config-box {
  width: 100%;
}

.form-group .form-config-box label {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  line-height: 14px;
  margin-bottom: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.description-wrap {
  display: flex;
  gap: 15px;
}

.form-config-box-check {
  width: 100%;
  display: flex;
  gap: 6px;
}

.checkbox-row {
  max-width: 57%;
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  line-height: 14px;
}

.variable-input {
  display: flex;
  align-items: center;
  gap: 10px;
  /* Adds space between inputs and buttons */
  margin-bottom: 17px;
  /* Adds space between each row */
}

.variable-input input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 200px;
  /* Adjust width as needed */
}

.variable-input button {
  border: none;
  background: white;
  border-radius: 100%;
  cursor: pointer;
  padding: 0;
}

.variable-input button:hover {
  box-shadow: 2px 2px 10px #d0caca;
}

.button-wrap-row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.all-variavle-inputs {
  max-height: 200px;
  overflow-y: auto;
}

.minus-icon-white {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  width: 24px;
  height: 24px;
  background-size: cover;
  display: block;
}

.container-no-records {
  text-align: center;
  background: #f5f6fe;
  min-height: 300px;
  height: 75%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
}

.plus-icon-white-bot {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  width: 24px;
  height: 24px;
  background-size: cover;
  display: block;
  cursor: pointer;
}

.plusbtn:hover {
  background-color: #3d8b40;
}

.btn-save-bot {
  padding: 3px 3px 3px 5px;
  background-color: #007bff;
  color: rgba(255, 255, 255, 0.942);
  text-align: center;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-block;
  min-width: 80px;
}

.btn-save-bot:hover {
  background-color: #0056b3;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transform: translateY(0px);
}

.btn-save-bot:active {
  background-color: #004085;
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.btn-save-bot:disabled {
  background-color: #66b0ff;
  color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
  transform: none;
  box-shadow: none;
}

/* UserGrid.css */

.user-table-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 9px;
  font-size: 12px;
  border-bottom: 1px solid #d9d9d9;
}

.user-table-header {
  font-weight: 600;
  border-bottom: 1px solid #ccc;
  padding: 10px 9px 5px 9px;
  background: #f3f3f3;
}

.user-table-list {
  background: #fff;
  border-radius: 7px;
  border: 1px solid #e5e5e5;
}

.light-gray-button {
  background: #e6e6e6;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 500;
  padding: 5px 15px;
}

.user-table-row .user-col {
  width: 100%;
  display: flex;
  align-items: center;
}

.user-col.auto-width {
  max-width: 40px;
  align-items: center;
  display: flex;
}

.light-gray-button .trash-icon:hover::before {
  display: none;
}

.top-bar {
  display: flex;
  justify-content: space-between;
}

.delete-btn,
.add-btn {
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  color: white;
}

.text-style {
  min-height: 35px;
  margin-bottom: 0;
  padding: 10px 30px 10px 10px;
  font-size: 11px;
  border: 1px solid #e5e5e5;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}

.mt-2 {
  margin-top: 0.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.top-bar .search-cross-icon-common {
  max-width: 300px;
  width: 100%;
}

/* .add-btn {
  background-color: green;
} */

.pagination {
  margin-top: 10px;
}

.pagination button {
  margin-right: 5px;
  padding: 5px 10px;
}

.pagination .active {
  background-color: blue;
  color: white;
}

/* UserModal.css */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 300px;
  text-align: center;
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.dark-theme .create-skill-window .prompt-title {
  color: #000;
}

/* 
Start of CSS related to Sorting
*/
.sort-button.sorting-ascending {
  display: block;
}

.sort-button.sorting-descending {
  display: block;
}

.sorting-ascending {
  width: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) !important;
  background-position: 6px;
  background-repeat: no-repeat;
  color: white;
  background-size: 12px;
  height: 30px;
  cursor: pointer;
}

.sorting-descending {
  width: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) !important;
  background-position: 6px;
  background-repeat: no-repeat;
  background-size: 12px;
  height: 30px;
  cursor: pointer;
}

/* .survey-list-wrapper-sort-column {
  cursor: pointer;
} */
.sort-button {
  background-color: transparent;
  border-bottom-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.sort-button-hide {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 0 !important;
  position: absolut !important;
  white-space: nowrap !important;
  width: 1px !important;
}

.sort-new-column {
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  line-height: 15px;
}

.sort-new-column .sort-button {
  /* position: absolute; */
  display: block;
}

.sort-button {
  width: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-position: 6px;
  background-repeat: no-repeat;
  background-size: 12px;
  height: 24px;
  cursor: pointer;
}

.sort-column {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

.unsort-column {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-top: 5px;
}

.unsort-column-nomargin {
  display: flex;
  align-items: center;
  font-weight: bold;
}

/* 
End of CSS related to Sorting
*/

@media screen and (max-width: 991px) {
  .w-container {
    max-width: 728px;
  }

  .w-hidden-main {
    display: inherit !important;
  }

  .w-hidden-medium {
    display: none !important;
  }

  .w-col-medium-1 {
    width: 8.33333%;
  }

  .w-col-medium-2 {
    width: 16.6667%;
  }

  .w-col-medium-3 {
    width: 25%;
  }

  .w-col-medium-4 {
    width: 33.3333%;
  }

  .w-col-medium-5 {
    width: 41.6667%;
  }

  .w-col-medium-6 {
    width: 50%;
  }

  .w-col-medium-7 {
    width: 58.3333%;
  }

  .w-col-medium-8 {
    width: 66.6667%;
  }

  .w-col-medium-9 {
    width: 75%;
  }

  .w-col-medium-10 {
    width: 83.3333%;
  }

  .w-col-medium-11 {
    width: 91.6667%;
  }

  .w-col-medium-12 {
    width: 100%;
  }

  .w-col-stack {
    width: 100%;
    left: auto;
    right: auto;
  }
}

.w-widget {
  position: relative;
}

.w-widget-map {
  width: 100%;
  height: 400px;
}

.w-widget-map label {
  width: auto;
  display: inline;
}

.w-widget-map img {
  max-width: inherit;
}

.w-widget-map .gm-style-iw {
  text-align: center;
}

.w-widget-map .gm-style-iw>button {
  display: none !important;
}

.w-widget-twitter {
  overflow: hidden;
}

.w-widget-twitter-count-shim {
  vertical-align: top;
  text-align: center;
  background: #fff;
  border: 1px solid #758696;
  border-radius: 3px;
  width: 28px;
  height: 20px;
  display: inline-block;
  position: relative;
}

.w-widget-twitter-count-shim * {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

.w-widget-twitter-count-shim .w-widget-twitter-count-inner {
  text-align: center;
  color: #999;
  font-family: serif;
  font-size: 15px;
  line-height: 12px;
  position: relative;
}

.w-widget-twitter-count-shim .w-widget-twitter-count-clear {
  display: block;
  position: relative;
}

.w-widget-twitter-count-shim.w--large {
  width: 36px;
  height: 28px;
}

.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 18px;
}

.w-widget-twitter-count-shim:not(.w--vertical) {
  margin-left: 5px;
  margin-right: 8px;
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large {
  margin-left: 6px;
}

.w-widget-twitter-count-shim:not(.w--vertical):before,
.w-widget-twitter-count-shim:not(.w--vertical):after {
  content: " ";
  pointer-events: none;
  border: solid #0000;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  left: 0;
}

.w-widget-twitter-count-shim:not(.w--vertical):before {
  border-width: 4px;
  border-color: #75869600 #5d6c7b #75869600 #75869600;
  margin-top: -4px;
  margin-left: -9px;
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {
  border-width: 5px;
  margin-top: -5px;
  margin-left: -10px;
}

.w-widget-twitter-count-shim:not(.w--vertical):after {
  border-width: 4px;
  border-color: #fff0 #fff #fff0 #fff0;
  margin-top: -4px;
  margin-left: -8px;
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {
  border-width: 5px;
  margin-top: -5px;
  margin-left: -9px;
}

.w-widget-twitter-count-shim.w--vertical {
  width: 61px;
  height: 33px;
  margin-bottom: 8px;
}

.w-widget-twitter-count-shim.w--vertical:before,
.w-widget-twitter-count-shim.w--vertical:after {
  content: " ";
  pointer-events: none;
  border: solid #0000;
  width: 0;
  height: 0;
  position: absolute;
  top: 100%;
  left: 50%;
}

.w-widget-twitter-count-shim.w--vertical:before {
  border-width: 5px;
  border-color: #5d6c7b #75869600 #75869600;
  margin-left: -5px;
}

.w-widget-twitter-count-shim.w--vertical:after {
  border-width: 4px;
  border-color: #fff #fff0 #fff0;
  margin-left: -4px;
}

.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 22px;
}

.w-widget-twitter-count-shim.w--vertical.w--large {
  width: 76px;
}

.w-background-video {
  color: #fff;
  height: 500px;
  position: relative;
  overflow: hidden;
}

.login-logo-img {
  margin-bottom: 10px;
}

.plus-icon-white {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.add-user-button-top {
  background-color: #0062ff;
  padding: 10px;
  border-radius: 100%;
  cursor: pointer;
}

.login-main-text {
  font-size: 47px;
  font-weight: 700;
  color: #1f5078;
  line-height: 55px;
}

.w-background-video>video {
  object-fit: inherit;
  z-index: -100;
  background-position: 50%;
  background-size: cover;
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  top: -100%;
  bottom: -100%;
  left: -100%;
  right: -100%;
}

.login-bg-video {
  z-index: 1;
  border-radius: 20px 0 0 20px;
  flex: 1 1;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.w-background-video>video::-webkit-media-controls-start-playback-button {
  -webkit-appearance: none;
  display: none !important;
}

.w-background-video--control {
  background-color: #0000;
  padding: 0;
  position: absolute;
  bottom: 1em;
  right: 1em;
}

.w-background-video--control>[hidden] {
  display: none !important;
}

.w-slider {
  text-align: center;
  clear: both;
  -webkit-tap-highlight-color: #0000;
  tap-highlight-color: #0000;
  background: #ddd;
  height: 300px;
  position: relative;
}

.w-slider-mask {
  z-index: 1;
  white-space: nowrap;
  height: 100%;
  display: block;
  position: relative;
  left: 0;
  right: 0;
  overflow: hidden;
}

.w-slide {
  vertical-align: top;
  white-space: normal;
  text-align: left;
  width: 100%;
  height: 100%;
  display: inline-block;
  position: relative;
}

.w-slider-nav {
  z-index: 2;
  text-align: center;
  -webkit-tap-highlight-color: #0000;
  tap-highlight-color: #0000;
  height: 40px;
  margin: auto;
  padding-top: 10px;
  position: absolute;
  inset: auto 0 0;
}

.w-slider-nav.w-round>div {
  border-radius: 100%;
}

.w-slider-nav.w-num>div {
  font-size: inherit;
  line-height: inherit;
  width: auto;
  height: auto;
  padding: 0.2em 0.5em;
}

.w-slider-nav.w-shadow>div {
  box-shadow: 0 0 3px #3336;
}

.w-slider-nav-invert {
  color: #fff;
}

.w-slider-nav-invert>div {
  background-color: #2226;
}

.w-slider-nav-invert>div.w-active {
  background-color: #222;
}

.w-slider-dot {
  cursor: pointer;
  background-color: #fff6;
  width: 1em;
  height: 1em;
  margin: 0 3px 0.5em;
  transition: background-color 0.1s, color 0.1s;
  display: inline-block;
  position: relative;
}

.w-slider-dot.w-active {
  background-color: #fff;
}

.w-slider-dot:focus {
  outline: none;
  box-shadow: 0 0 0 2px #fff;
}

.w-slider-dot:focus.w-active {
  box-shadow: none;
}

.w-slider-arrow-left,
.w-slider-arrow-right {
  cursor: pointer;
  color: #fff;
  -webkit-tap-highlight-color: #0000;
  tap-highlight-color: #0000;
  -webkit-user-select: none;
  user-select: none;
  width: 80px;
  margin: auto;
  font-size: 40px;
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.w-slider-arrow-left [class^="w-icon-"],
.w-slider-arrow-right [class^="w-icon-"],
.w-slider-arrow-left [class*=" w-icon-"],
.w-slider-arrow-right [class*=" w-icon-"] {
  position: absolute;
}

.w-slider-arrow-left:focus,
.w-slider-arrow-right:focus {
  outline: 0;
}

.w-slider-arrow-left {
  z-index: 3;
  right: auto;
}

.w-slider-arrow-right {
  z-index: 4;
  left: auto;
}

.menunav {
  width: 100%;
  position: relative;
}

.w-icon-slider-left,
.w-icon-slider-right {
  width: 1em;
  height: 1em;
  margin: auto;
  inset: 0;
}

.w-slider-aria-label {
  clip: rect(0 0 0 0);
  border: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.w-slider-force-show {
  display: block !important;
}

.w-dropdown {
  text-align: left;
  z-index: 900;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;
  position: relative;
}

.w-dropdown-btn,
.w-dropdown-toggle,
.w-dropdown-link {
  vertical-align: top;
  color: #222;
  text-align: left;
  white-space: nowrap;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  text-decoration: none;
  position: relative;
}

.w-dropdown-toggle {
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  padding-right: 40px;
  display: inline-block;
}

.w-dropdown-toggle:focus {
  outline: 0;
}

.w-icon-dropdown-toggle {
  width: 1em;
  height: 1em;
  margin: auto 20px auto auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.w-dropdown-list {
  background: #ddd;
  min-width: 100%;
  display: none;
  position: absolute;
}

.w-dropdown-list.w--open {
  display: block;
}

.w-dropdown-link {
  color: #222;
  padding: 10px 20px;
  display: block;
}

.w-dropdown-link.w--current {
  color: #0082f3;
}

.w-dropdown-link:focus {
  outline: 0;
}

.w-lightbox-backdrop {
  cursor: auto;
  letter-spacing: normal;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  visibility: visible;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  color: #fff;
  text-align: center;
  z-index: 2000;
  opacity: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-tap-highlight-color: transparent;
  background: #000000e6;
  outline: 0;
  font-family: Helvetica Neue, Helvetica, Ubuntu, Segoe UI, Verdana, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.2;
  list-style: disc;
  position: fixed;
  inset: 0;
  -webkit-transform: translate(0);
}

.w-lightbox-backdrop,
.w-lightbox-container {
  -webkit-overflow-scrolling: touch;
  height: 100%;
  overflow: auto;
}

.w-lightbox-content {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.w-lightbox-view {
  opacity: 0;
  width: 100vw;
  height: 100vh;
  position: absolute;
}

.w-lightbox-view:before {
  content: "";
  height: 100vh;
}

.w-lightbox-group,
.w-lightbox-group .w-lightbox-view,
.w-lightbox-group .w-lightbox-view:before {
  height: 86vh;
}

.w-lightbox-frame,
.w-lightbox-view:before {
  vertical-align: middle;
  display: inline-block;
}

.button-use-promp {
  display: flex;
  align-items: center;
  gap: 10px;
}

.w-lightbox-figure {
  margin: 0;
  position: relative;
}

.w-lightbox-group .w-lightbox-figure {
  cursor: pointer;
}

.w-lightbox-img {
  width: auto;
  max-width: none;
  height: auto;
}

.w-lightbox-image {
  float: none;
  max-width: 100vw;
  max-height: 100vh;
  display: block;
}

.w-lightbox-group .w-lightbox-image {
  max-height: 86vh;
}

.w-lightbox-caption {
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #0006;
  padding: 0.5em 1em;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.w-lightbox-embed {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
}

.w-lightbox-control {
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
  width: 4em;
  transition: all 0.3s;
  position: absolute;
  top: 0;
}

.w-lightbox-left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  display: none;
  bottom: 0;
  left: 0;
}

.w-lightbox-right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  display: none;
  bottom: 0;
  right: 0;
}

.w-lightbox-close {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: 18px;
  height: 2.6em;
  right: 0;
}

.w-lightbox-strip {
  white-space: nowrap;
  padding: 0 1vh;
  line-height: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto hidden;
}

.w-lightbox-item {
  box-sizing: content-box;
  cursor: pointer;
  width: 10vh;
  padding: 2vh 1vh;
  display: inline-block;
  -webkit-transform: translate3d(0, 0, 0);
}

.w-lightbox-active {
  opacity: 0.3;
}

.w-lightbox-thumbnail {
  background: #222;
  height: 10vh;
  position: relative;
  overflow: hidden;
}

.w-lightbox-thumbnail-image {
  position: absolute;
  top: 0;
  left: 0;
}

.w-lightbox-thumbnail .w-lightbox-tall {
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
}

.w-lightbox-thumbnail .w-lightbox-wide {
  height: 100%;
  left: 50%;
  transform: translate(-50%);
}

.w-lightbox-spinner {
  box-sizing: border-box;
  border: 5px solid #0006;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  margin-left: -20px;
  animation: 0.8s linear infinite spin;
  position: absolute;
  top: 50%;
  left: 50%;
}

.w-lightbox-spinner:after {
  content: "";
  border: 3px solid #0000;
  border-bottom-color: #fff;
  border-radius: 50%;
  position: absolute;
  inset: -4px;
}

.w-lightbox-hide {
  display: none;
}

.w-lightbox-noscroll {
  overflow: hidden;
}

.mobile-header .user-profile-menu {
  color: #fff;
  border: 0;
}

.mobile-header .dash-header {
  padding: 0;
  border: 0;
}

@media (min-width: 768px) {
  .skill-select-charts {
    min-width: 330px;
  }

  .dash-menu.open .left-menu-nav-wrapper a {
    position: relative;
  }

  .dash-menu.open .left-menu-nav-wrapper a:hover::after {
    content: attr(data-title);
    position: absolute;
    left: 54px;
    color: #000;
    font-size: 11px;
    line-height: 13px;
    background: #fff;
    border: 1px solid #e5e5e5;
    padding: 3px 9px;
    border-radius: 5px;
    z-index: 1;
    top: 4px;
    white-space: nowrap;
  }

  .dash-menu.open .left-menu-nav-wrapper .dropdown-label:hover::after {
    content: attr(data-title);
    position: absolute;
    left: 54px;
    color: #000;
    font-size: 11px;
    line-height: 13px;
    background: #fff;
    border: 1px solid #e5e5e5;
    padding: 3px 9px;
    border-radius: 5px;
    z-index: 1;
    top: 4px;
  }

  .dash-menu.open .menunav {
    position: relative;
  }

  .dash-menu.open .menu-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    width: 32px;
  }

  .dash-menu.open .left-menu-link {
    flex-flow: column;
    padding: 5px;
  }

  .dash-menu.open .menu-icon {
    width: 27px;
  }

  .dash-menu.open .toggle-menu-desk {
    transform: rotate(180deg);
  }

  .dash-menu.open .left-menu-header {
    justify-content: center;
  }

  .dash-body.expand {
    width: 100%;
  }

  .dash-menu.open {
    width: 70px;
  }

  .dash-menu.open .menu-link-text {
    display: none;
  }

  .mobile-header,
  .hide-on-desk {
    display: none;
  }

  .w-lightbox-content {
    height: 96vh;
    margin-top: 2vh;
  }

  .w-lightbox-view,
  .w-lightbox-view:before {
    height: 96vh;
  }

  .w-lightbox-group,
  .w-lightbox-group .w-lightbox-view,
  .w-lightbox-group .w-lightbox-view:before {
    height: 84vh;
  }

  .w-lightbox-image {
    max-width: 96vw;
    max-height: 96vh;
  }

  .w-lightbox-group .w-lightbox-image {
    max-width: 82.3vw;
    max-height: 84vh;
  }

  .w-lightbox-left,
  .w-lightbox-right {
    opacity: 0.5;
    display: block;
  }

  .w-lightbox-close {
    opacity: 0.8;
  }

  .w-lightbox-control:hover {
    opacity: 1;
  }
}

.w-lightbox-inactive,
.w-lightbox-inactive:hover {
  opacity: 0;
}

.w-richtext:before,
.w-richtext:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-richtext:after {
  clear: both;
}

.w-richtext[contenteditable="true"]:before,
.w-richtext[contenteditable="true"]:after {
  white-space: initial;
}

.w-richtext ol,
.w-richtext ul {
  overflow: hidden;
}

.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,
.w-richtext .w-richtext-figure-selected[data-rt-type="video"] div:after,
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,
.w-richtext .w-richtext-figure-selected[data-rt-type="image"] div {
  outline: 2px solid #2895f7;
}

.w-richtext figure.w-richtext-figure-type-video>div:after,
.w-richtext figure[data-rt-type="video"]>div:after {
  content: "";
  display: none;
  position: absolute;
  inset: 0;
}

.w-richtext figure {
  max-width: 60%;
  position: relative;
}

.w-richtext figure>div:before {
  cursor: default !important;
}

.w-richtext figure img {
  width: 100%;
}

.w-richtext figure figcaption.w-richtext-figcaption-placeholder {
  opacity: 0.6;
}

.w-richtext figure div {
  color: #0000;
  font-size: 0;
}

.w-richtext figure.w-richtext-figure-type-image,
.w-richtext figure[data-rt-type="image"] {
  display: table;
}

.w-richtext figure.w-richtext-figure-type-image>div,
.w-richtext figure[data-rt-type="image"]>div {
  display: inline-block;
}

.w-richtext figure.w-richtext-figure-type-image>figcaption,
.w-richtext figure[data-rt-type="image"]>figcaption {
  caption-side: bottom;
  display: table-caption;
}

.w-richtext figure.w-richtext-figure-type-video,
.w-richtext figure[data-rt-type="video"] {
  width: 60%;
  height: 0;
}

.w-richtext figure.w-richtext-figure-type-video iframe,
.w-richtext figure[data-rt-type="video"] iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.w-richtext figure.w-richtext-figure-type-video>div,
.w-richtext figure[data-rt-type="video"]>div {
  width: 100%;
}

.w-richtext figure.w-richtext-align-center {
  clear: both;
  margin-left: auto;
  margin-right: auto;
}

.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image>div,
.w-richtext figure.w-richtext-align-center[data-rt-type="image"]>div {
  max-width: 100%;
}

.w-richtext figure.w-richtext-align-normal {
  clear: both;
}

.w-richtext figure.w-richtext-align-fullwidth {
  text-align: center;
  clear: both;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.w-richtext figure.w-richtext-align-fullwidth>div {
  padding-bottom: inherit;
  display: inline-block;
}

.w-richtext figure.w-richtext-align-fullwidth>figcaption {
  display: block;
}

.w-richtext figure.w-richtext-align-floatleft {
  float: left;
  clear: none;
  margin-right: 15px;
}

.w-richtext figure.w-richtext-align-floatright {
  float: right;
  clear: none;
  margin-left: 15px;
}

.w-nav {
  z-index: 1000;
  background: #ddd;
  position: relative;
}

.w-nav:before,
.w-nav:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-nav:after {
  clear: both;
}

.w-nav-brand {
  float: left;
  color: #333;
  text-decoration: none;
  position: relative;
}

.w-nav-link {
  vertical-align: top;
  color: #222;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  text-decoration: none;
  display: inline-block;
  position: relative;
}

.w-nav-link.w--current {
  color: #0082f3;
}

.w-nav-menu {
  float: right;
  position: relative;
}

[data-nav-menu-open] {
  text-align: center;
  background: #c8c8c8;
  min-width: 200px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  overflow: visible;
  display: block !important;
}

.w--nav-link-open {
  display: block;
  position: relative;
}

.w-nav-overlay {
  width: 100%;
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  overflow: hidden;
}

.w-nav-overlay [data-nav-menu-open] {
  top: 0;
}

.w-nav[data-animation="over-left"] .w-nav-overlay {
  width: auto;
}

.w-nav[data-animation="over-left"] .w-nav-overlay,
.w-nav[data-animation="over-left"] [data-nav-menu-open] {
  z-index: 1;
  top: 0;
  right: auto;
}

.w-nav[data-animation="over-right"] .w-nav-overlay {
  width: auto;
}

.w-nav[data-animation="over-right"] .w-nav-overlay,
.w-nav[data-animation="over-right"] [data-nav-menu-open] {
  z-index: 1;
  top: 0;
  left: auto;
}

.w-nav-button {
  float: right;
  cursor: pointer;
  -webkit-tap-highlight-color: #0000;
  tap-highlight-color: #0000;
  -webkit-user-select: none;
  user-select: none;
  padding: 18px;
  font-size: 24px;
  display: none;
  position: relative;
}

.w-nav-button:focus {
  outline: 0;
}

.w-nav-button.w--open {
  color: #fff;
  background-color: #c8c8c8;
}

.w-nav[data-collapse="all"] .w-nav-menu {
  display: none;
}

.w-nav[data-collapse="all"] .w-nav-button,
.w--nav-dropdown-open,
.w--nav-dropdown-toggle-open {
  display: block;
}

.w--nav-dropdown-list-open {
  position: static;
}

.highlight {
  color: #6664ff;
}

.recent-comments {
  display: flex;

  justify-content: flex-start;
  text-align: left;
  margin-bottom: 10px;
  flex-flow: column;
  padding: 8px;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-right: 6px;
}

.new-comment,
.reply-comment {
  display: flex;
  gap: 10px;
}

.reply-comment {
  margin-left: 32px;
  position: relative;
  padding-left: 15px;
  margin-left: 18px;
}

.light-coment-bg {
  background: #fff;
}

.comment-actions {
  display: flex;
  font-size: 10px;
  gap: 20px;
}

.comment-action {
  cursor: pointer;
}

.replied::before {
  content: "";
  background: #e5e5e5;
  height: 88%;
  width: 1.5px;
  position: absolute;
  top: 24px;
  left: 11px;
}

.reply-comment.replied::after {
  content: "";
  background: #e5e5e5;
  height: 100%;
  width: 1.5px;
  position: absolute;
  top: 15px;
  left: -7px;
}

.reply-comment::before {
  content: "";
  background: #e5e5e5;
  height: 2.5px;
  width: 19px;
  position: absolute;
  top: 14px;
  left: -6px;
}

.reply-input {
  border: 1px solid #e5e5e5;
  font-size: 12px;
}

.replied {
  position: relative;
}

.bold-name {
  font-weight: 600;
  font-size: 13px;
}

.user-comment-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.coment-section {
  background: #f5f5f5;
  padding: 10px;
}

.modal-content.comment-modal {
  background: #f5f5f5;
}

.delete-prompt-modal .modal-content {
  max-width: 350px;
  padding: 0;
}

.delete-prompt-modal .modal-block {
  max-width: 350px;
}

.prompts-action-wrapper .modal-content {
  background: #f5f5f5;
}

.text-box {
  display: flex;
  width: 100%;
}

.textwrap {
  width: 100%;
  border: 1px solid #e5e5e5;
  min-height: 40px;
  resize: none;
}

.commentdate {
  font-size: 10px;
  color: #b1a7a7;
  display: flex;
  gap: 7px;
}

.top-close {
  position: absolute;
  right: 11px;
  top: 7px;
  cursor: pointer;
}

.comment-header {
  margin-top: 0;
  font-size: 20px;
  line-height: 25px;
  margin-bottom: 14px;
}

.user-coment {
  font-size: 12px;
  word-break: auto-phrase;
  word-wrap: break-word;
}

.user-table-body {
  max-height: calc(100vh - 350px);
  overflow-y: auto;
}

.no-users-found {
  padding: 10px;
  text-align: center;
}

.reply-comment .user-coment {
  margin-bottom: 10px;
}

.submit-btn {
  background: #053a64;
  color: #fff;
  padding: 10px 21px;
  border-radius: 0 5px 5px 0;
}

@media screen and (max-width: 991px) {
  .w-nav[data-collapse="medium"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="medium"] .w-nav-button {
    display: block;
  }
}

@media screen and (max-width: 479px) {
  .chat-event-btn-wrapper {
    inset: auto auto 132px !important;
  }

  .w-nav[data-collapse="tiny"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="tiny"] .w-nav-button {
    display: block;
  }
}

.w-tabs {
  position: relative;
}

.w-tabs:before,
.w-tabs:after {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-tabs:after {
  clear: both;
}

.w-tab-menu {
  position: relative;
}

.w-tab-link {
  vertical-align: top;
  text-align: left;
  cursor: pointer;
  color: #222;
  background-color: #ddd;
  padding: 9px 30px;
  text-decoration: none;
  display: inline-block;
  position: relative;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
  cursor: pointer;
}

.w-tab-link.w--current {
  background-color: #c8c8c8;
}

.w-tab-link:focus {
  outline: 0;
}

.w-tab-content {
  display: block;
  position: relative;
}

.w-tab-pane {
  display: none;
  position: relative;
}

.w--tab-active {
  display: block;
}

@media screen and (max-width: 479px) {
  .w-tab-link {
    display: block;
  }
}

.w-ix-emptyfix:after {
  content: "";
}

@keyframes spin {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.w-dyn-empty {
  background-color: #ddd;
  padding: 10px;
}

.w-dyn-hide,
.w-dyn-bind-empty,
.w-condition-invisible {
  display: none !important;
}

.wf-layout-layout {
  display: grid;
}

.w-code-component>* {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

:root {
  --black: black;
  --mks-primary: #226194;
  --mks-primary-dark: #053a64;
  --white: white;
  --mks-blue: #0062ff;
  --border-grey: #f0f0f0;
  --darkbg: #161822;
  --slate-gray: #a4b4c2;
  --mks-blue-light: #e7f4ff;
  --dark-bg-2: #20212c;
  --border-color: #ffffff1a;
  --purple-font: #6664ff;
  --green: #00ff91;
  --purple: #6f00ff;
  --mks-green: #00d672;
}

.w-layout-hflex {
  flex-direction: row;
  align-items: flex-start;
  display: flex;
}

.w-layout-grid {
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.w-checkbox {
  margin-bottom: 5px;
  padding-left: 20px;
  display: block;
}

.w-checkbox:before {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-checkbox:after {
  content: " ";
  clear: both;
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-checkbox-input {
  float: left;
  margin: 4px 0 0 -20px;
  line-height: normal;
}

.w-checkbox-input--inputType-custom {
  border: 1px solid #ccc;
  border-radius: 2px;
  width: 12px;
  height: 12px;
}

.w-checkbox-input--inputType-custom.w--redirected-checked {
  background-color: #3898ec;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-color: #3898ec;
}

.w-checkbox-input--inputType-custom.w--redirected-focus {
  box-shadow: 0 0 3px 1px #3898ec;
}

.flexbox {
  background-color: #dce1ee;
  flex-flow: column;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  font-family: Poppins, sans-serif;
  display: flex;
}

.workspace-dashboard {
  background-color: #053a64;
  background-position: 0 0, 50%;
  background-size: auto, auto;
  height: 100%;
  max-height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 2px 20px #3e67be33;
}

.workspace-dashboard.flex-end {
  padding: 15px;
}

.dash-menu {
  border-right: 1px none var(--black);
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 20%;
  max-height: 100%;
  display: flex;
  padding: 0 10px;
}

.dash-body {
  background-color: #fff;
  background-position: 0 0, 50%;
  background-repeat: repeat, repeat;
  background-size: auto, auto;
  border-radius: 10px;
  flex-flow: column;
  width: 80%;
  display: flex;
  overflow: hidden;
}

.left-menu-header {
  border-bottom: 1px solid #c9c9c9;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 0 13px;
  display: flex;
}

img.upload-icon {
  border-radius: 100%;
  max-width: 40px;
  max-height: 40px;
  height: 40px;
  width: 100%;
  cursor: pointer;
}

.dropdown-items {
  flex-flow: column;
}

.red {
  color: red;
}

.w-full {
  width: 100%;
}

.flex-links {
  display: flex;
  gap: 10px;
  width: 100%;
  cursor: pointer;
}

.left-menu-link:hover .down-arrow {
  filter: invert(1);
}

.dash-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 40px;
  border-bottom: 1px solid #e5e5e5;
  gap: 10px;
}

.dash-header h1 {
  font-size: 27px;
  font-weight: 400;
  color: #053a64;
  line-height: 39px;
  margin: 0;
}

.menu-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 0%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 85px;
  min-height: 40px;
}

.close-panel-button {
  background-color: var(--mks-primary);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 7px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  width: 19px;
  height: 33px;
  display: none;
}

.close-panel-button:hover {
  background-color: var(--mks-primary-dark);
}

.left-menu-nav-wrapper {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  flex-flow: column;
  flex: 1 1;
  width: 100%;
  padding-right: 10px;
  display: flex;
  padding: 10px 0;
}

.left-menu-link {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  color: #fff;
  border-radius: 4px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 7px 10px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  display: flex;
}

.left-menu-link:hover {
  background-color: #ffffff;
  color: #053a64;
  border-radius: 40px;
}

.left-menu-link.w--current .menu-icon {
  filter: invert(1);
}

.left-menu-link:hover .menu-icon {
  filter: invert(1);
}

.left-menu-link.w--current {
  background-color: #ffffff;
  color: #053a64;
  border-radius: 40px;
}

.menu-icon {
  width: 22px;
}

.dash-page-header {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px 25px;
  display: flex;
}

.dash-page-header.light-bg {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  padding-left: 60px;
  padding-right: 60px;
}

.h1 {
  color: #81a5c2;
  margin-top: 10px;
  font-size: 32px;
  font-weight: 300;
  line-height: 39px;
}

.color-span {
  color: #053a64;
  font-weight: 500;
}

.paragraph {
  color: var(--mks-primary-dark);
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
}

.dash-section.p20 {
  padding: 20px;
  background-color: #f5f5f5;
}

.paragraph.medium {
  font-size: 0.9rem;
}

.paragraph.large {
  font-size: 1rem;
}

.paragraph.small {
  font-size: 0.7rem;
  margin-bottom: 15px;
}

.dash-section {
  grid-column-gap: 20px;
  background-color: #fff;
  border-radius: 10px;
  flex-flow: column;

  display: flex;
  position: relative;
  grid-row-gap: 20px;
}

.dash-section.light-bg {
  background-color: #fff;
  padding: 15px 20px;
}

.chat-tablink {
  color: #afacac;
  background-color: transparent;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 12px;
  font-weight: 500;
}

.chat-tablink.w--current {
  opacity: 1;
  color: #ffffff;
  background-color: #053a64;
}

.chat-tab-menu {
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  background-color: #a1acdd40;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  padding: 5px;
  display: flex;
}

.chat-tablink {
  border-radius: 100px;
}

.chat-tabs.w-tabs {
  display: flex;
  flex-direction: column;
}

.chat-tab-pane {}

.utility-page-wrap {
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: 100%;
  height: 100vh;
  max-height: 100%;
  display: flex;
}

.utility-page-content {
  text-align: center;
  flex-direction: column;
  width: 260px;
  display: flex;
}

.utility-page-form {
  flex-direction: column;
  align-items: stretch;
  display: flex;
}

.chat-flex {
  display: flex;
  gap: 10px;
}

.chat-select {
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 3px 6px;
  font-size: 13px;
}

.chat-select:focus-visible {
  outline: 0;
}

.chat-form-wrapper {
  margin-bottom: 0;
}

.chat-field-wrapper {
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  justify-content: flex-start;
  align-items: flex-end;
  display: flex;
  width: 100%;
  padding-top: 10px;
}

.chat-button {
  background-color: var(--mks-blue);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-position: 14px;
  background-repeat: no-repeat;
  background-size: 23px;
  border-radius: 7px;
  padding-left: 44px;
  padding-right: 15px;
  font-size: 11px;
}

.chat-input-field {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  margin-bottom: 0;
  background: #f7f7f7;
}

.prompt-icon {
  display: flex;
  gap: 10px;
}

.prompt-icon::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  width: 18px;
  height: 18px;
  background-size: 100%;
  background-repeat: no-repeat;
  display: block;
}

.pl20 {
  padding: 0 20px;
}

.h2 {
  color: var(--mks-primary-dark);
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 19px;
  font-weight: 500;
  line-height: 27px;
}

.h-flex {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  justify-content: flex-start;
  align-items: center;
}

.h-flex.head-wrapper {
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}

.h-flex.head-wrapper.input-workspace {
  position: absolute;
  right: 0;
  padding: 8px 10px 8px 24px;
  width: calc(100% - 140px);
}

.flex-workspace {
  display: flex;
  align-items: center;
}

.text-link {
  color: var(--white);
  background-color: #6664ff4a;
  border-radius: 6px;
  padding: 5px 18px;
  font-size: 12px;
  text-decoration: none;
}

.ai-collection-grid {
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: start;
}

.ai-collection-link-block {
  grid-column-gap: 6px;
  grid-row-gap: 6px;
  background: #ffffff;
  border-radius: 11px;
  flex-flow: column;
  justify-content: space-between;
  padding: 10px;
  text-decoration: none;
  display: flex;
  box-shadow: 2px 2px 53px #ededed;
  /* cursor: pointer; */
}

.numeric-input::-webkit-outer-spin-button,
.numeric-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.numeric-input[type="number"] {
  -moz-appearance: textfield;
  width: 100px;
}

.h3 {
  color: var(--mks-primary);
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.3rem;
}

.center-grid {
  grid-template-columns: 1fr;
  text-align: center;
  margin-top: 20px;
}

.skill-center-grid {
  grid-template-columns: 1fr;
  text-align: center;
}

.center-grid-search {
  grid-template-columns: 1fr;
  text-align: center;
}

.center-align-text {
  grid-template-columns: 1fr;
  text-align: center;
  margin-top: 12px;
  border-radius: 5px 5px 5px 5px;
}

.h3.small {
  font-size: 12px;
  line-height: 1.2rem;
  width: 79%;
}

.ai-collection-info-block {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  background-color: #fff;
  border-radius: 10px;
  flex-flow: column;
  flex: 1 1;
  display: flex;
  position: relative;
  cursor: pointer;
  justify-content: space-between;
}

.numeric-input-box {
  width: 100px !important;
}

.ai-block-header {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  justify-content: flex-start;
  align-items: center;
  height: 48px;
  margin-bottom: 10px;
  display: flex;
  border-bottom: 1px solid #e5e5e5;
}

.ai-block-header .h3.small,
.normal-link.long-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
}

.breadcrumb {
  position: relative;
}

.ai-block-header .h3.small.long-title:hover::before {
  content: "";
  width: 0;
  height: 0;
  border-right: 11px solid transparent;
  border-left: 11px solid transparent;
  border-bottom: 11px solid #f6f6f6;
  border-top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  position: absolute;
  top: 33px;
  bottom: auto;
}

.ai-block-header .h3.small.long-title:hover::after {
  content: attr(data-title);
  position: absolute;
  left: 0px;
  color: #000;
  font-weight: 400;
  font-size: 9px;
  line-height: 16px;
  background: #f7f7f7;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
  width: auto;
  top: 41px;
  height: max-content;
  right: 0;
  white-space: normal;
  word-break: break-all;
}

.normal-link.long-title:hover::before {
  content: "";
  width: 0;
  height: 0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  border-right: 11px solid #f6f6f6;
  right: 0;
  left: 504px;
  position: absolute;
  top: 23px;
  bottom: auto;
}

.normal-link.long-title:hover::after {
  content: attr(data-title);
  position: absolute;
  left: 513px;
  color: #000;
  font-weight: 400;
  font-size: 9px;
  line-height: 16px;
  background: #f7f7f7;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
  width: 250px;
  top: 23px;
  height: max-content;
  right: 0;
  white-space: normal;
  display: block;
  opacity: 1;
  word-break: break-all;
}

.ai-block-icon {
  width: 30px;
  height: 30px;
}

.copy-clipboard {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  width: 18px;
  height: 18px;
  background-size: 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  position: absolute;
  right: -22px;
  top: 9px;
}

.keyword-block {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.skill-keyword {
  color: var(--mks-primary);
  white-space: nowrap;
  background-color: #22619424;
  border-radius: 24px;
  padding: 4px 10px;
  font-size: 8px;
  font-weight: 500;
  line-height: 12px;
}

.button {
  background-color: var(--mks-blue);
  color: var(--white);
  border-radius: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 10px;
  font-weight: 500;
}

.button-newchat-disabled {
  background-color: var(--border-grey);
  color: #bdbdbd;
  border-radius: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 7px;
  border-radius: 5px;
  cursor: default;
}

.aligned-margin {
  margin: 0 7px;
}

.button.text {
  color: var(--mks-blue);
  background-color: #6664ff00;
  border-radius: 5px;
}

.button.text:hover {
  background-color: #a4b4c23d;
}

.button.icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-position: 15px;
  background-repeat: no-repeat;
  background-size: 12px;
  padding-left: 40px;
}

.new-chatbutton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 8px 0;
  border-radius: 5px;
  cursor: pointer;
}

.plusimg {
  width: 12px;
}

.ai-button-wrapper {
  justify-content: space-between;
  align-items: center;
  padding: 7px 9px 7px;
  display: flex;
  border-radius: 5px;
  background-color: #f5f5f5;
}

.check-icon {
  width: 15px;
  height: 15px;
}

.skill-checkbox-wrapper {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  display: flex;
}

.dashboard-wrapper {
  flex-flow: column;
  padding-bottom: 40px;
  display: flex;
  overflow: auto;
  height: 80vh;
}

.dashboard-wrapper-full {
  flex-flow: column;
  padding-bottom: 10px;
  display: flex;
  overflow: auto;
  height: 100vh;
}

.chat-terminal-wrapper {
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  flex-flow: row;
  min-height: calc(100% - 92px);
  max-height: 100%;
  display: flex;
  /* overflow: hidden; */
  position: relative;
}

.chat-terminal-header {
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  background-color: #a1acdd40;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  padding: 5px;
  display: flex;
}

.chat-box-wrapper {
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  flex-flow: column;
  flex: 1 1;
  padding-top: 10px;
  display: flex;
}

.chat-history {
  grid-column-gap: 10px;
  grid-row-gap: 10px;

  flex-flow: column;

  display: flex;
}

.chatbox {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  flex-flow: column;
  flex: 1 1;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 70px;
  padding-left: 25px;
  padding-right: 25px;
  display: flex;
  position: relative;
  overflow: auto;
}

.chatprompt-block {
  margin-bottom: 0;
  padding: 20px 0;
}

.chat-msg {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  border-radius: 10px;
  /* justify-content: space-between; */
  width: 100%;
  padding: 12px 5px 12px 20px;
  display: flex;
}

.chat-bottom-line {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.chat-msg.user .chat-icon-text {
  border-radius: 20px 0;
  background: #e2e6ed;
  margin-right: 0;

  word-break: auto-phrase;
  word-wrap: break-word;
}

.chat-msg.reply {
  /* background-color: #fff; */
  align-items: flex-start;
}

.prompt-mobile-wrap {
  display: flex;
  gap: 20px;
  width: 100%;
}

.chat-msg.user {
  flex-flow: row-reverse;
  align-items: baseline;
}

.not-sent-icon {
  display: flex;
  background: red;
  color: #fff;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  min-width: 18px;
}

.chat-user-icon {
  border-radius: 1000px;
  width: 30px;
  height: 30px;
  min-width: 30px;
}

.msg-text {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  flex-flow: column;
  flex: 1 1;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 12px;
  display: flex;
}

.msg-icon-wrapper {
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  padding-left: 4px;
  padding-right: 4px;
  display: flex;
}

.chat-icon-text {
  display: flex;
  gap: 10px;
  flex-flow: column;
  background: #f2f4f8;
  padding: 10px;
  border-radius: 0 20px;
  margin-right: 63px;
  word-break: break-all;
  position: relative;
}

.chat-text {
  color: var(--darkbg);
  margin-bottom: 0;
  font-size: 11px;
  line-height: 17px;
  word-break: break-word;
}

.chat-text p {
  display: inline;
}

.chat-text li {
  list-style-position: inside;
}

.chat-user-img {
  border-radius: 100px;
  width: 100%;
}

.msg-time {
  color: var(--mks-primary-dark);
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
}

.terminal-button {
  background-color: var(--border-grey);
  color: #bdbdbd;
  border-radius: 5px;
  padding-left: 36px;
  padding-right: 36px;
  font-size: 12px;
  font-weight: 500;
}

.terminal-button:hover {
  font-weight: 500;
}

.terminal-button.w--current {
  background-color: var(--mks-primary-dark);
  color: #fff;
}

.chat-event-button {
  background-color: #053a64;
  border-radius: 5px;
  font-size: 12px;
}

.user-img-dashbord-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  width: 80px;
  height: 80px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.chats-img-dashbord-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  width: 80px;
  height: 80px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.session-img-dashbord-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  width: 80px;
  height: 80px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.location-img-dashbord-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  width: 80px;
  height: 80px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.overview-dash-wrap {
  display: flex;
  gap: 15px;
  align-items: center;
}

.overview-card {
  width: 100%;
  border: 1px solid #e5e5e5;
  padding: 13px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #e5e5e5;
  display: flex;
  gap: 20px;
  align-items: center;
}

.large-font {
  font-size: 43px;
  font-weight: 600;
  color: #053a64;
  line-height: 45px;
}

.small-font {
  font-size: 13px;
  color: #666;
}

.overview-text {
  display: flex;
  flex-flow: column;
  gap: 5px;
}

.chat-event-button:hover {
  background-color: #467299;
}

.chat-event-button.stop-generate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-position: 10px;
  background-repeat: no-repeat;
  background-size: auto;
  padding-left: 36px;
}

.chat-event-button.regenarate {
  background-color: var(--slate-gray);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-position: 16px;
  background-repeat: no-repeat;
  background-size: 14px;
  padding-left: 40px;
}

.chat-event-button.regenarate:hover {
  background-color: #a4b4c2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}),
    linear-gradient(#fff0 84%, #83909e);
  background-position: 16px, 0 0;
  background-repeat: no-repeat, repeat;
  background-size: 14px, auto;
}

.chat-event-btn-wrapper {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-content: center;
  align-items: center;
  padding: 7px;
  display: flex;
  position: fixed;
  inset: auto auto 133px;
}

.prompt-skill {
  position: relative;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.gap-3 {
  gap: 1rem;
}

.prompt-skill:hover::after {
  content: attr(data-title);
  position: absolute;
  left: 54px;
  color: #000;
  font-size: 11px;
  line-height: 13px;
  background: #fff;
  border: 1px solid #e5e5e5;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
}

.chatprompt-form {
  background-color: var(--white);
  border-radius: 10px;
  justify-content: flex-start;
  align-items: flex-end;
  padding-left: 20px;
  display: flex;
  position: relative;
}

.chatprompt-button {
  background-color: var(--mks-blue);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 17px;
  border-radius: 7px;
  width: 40px;
  height: 40px;
  padding: 0;
  position: relative;
}

.chatprompt-button:hover {
  background-color: #115fdd;
}

.chatprompt-field {
  border: 1px solid #fff;
  border-radius: 5px;
  flex: 1 1;
  min-height: 40px;
  margin-bottom: 0;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 29px;
  padding-right: 29px;
}

.chatprompt-field:active {
  background-color: #eee;
  border-color: #fff;
}

.chatprompt-field:focus {
  background-color: #dbdff5;
  border-color: #fff;
}

.chatprompt-field-label {
  background-color: var(--mks-primary-dark);
  color: #fff;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-bottom: 0;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  position: relative;
  width: 120px;
  cursor: pointer;
}

.full-height {
  height: 100%;
}

.full-height.auto {
  height: auto;
}

.skill-info-wrapper {
  position: absolute;
  bottom: 52px;
  width: 250px;
  background: #f6f6f6;
  color: #000;
  padding: 10px;
  border-radius: 10px;
  left: 112px;
  z-index: 4;

  transition: 0.3s;
}

.skill-info-wrapper.top-position {
  top: 60px;
  bottom: auto;
}

.skill-mention {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;
}

.chat-down-triangle {
  width: 0;
  height: 0;
  border-right: 11px solid transparent;
  border-left: 11px solid transparent;
  border-top: 11px solid #f6f6f6;
  right: 0;
  left: 0;
  margin: 0 auto;
  position: absolute;
  /* top: 4px; */
  bottom: -11px;
}

.skill-info-wrapper.top-position .chat-down-triangle {
  width: 0;
  height: 0;
  border-right: 11px solid transparent;
  border-left: 11px solid transparent;
  border-bottom: 11px solid #f6f6f6;
  border-top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  position: absolute;
  top: -10px;
  bottom: auto;
}

.hoverteaxt {
  width: 100%;
  display: flex;
}

.skill-desc-popup {
  font-size: 11px;
  line-height: 15px;
}

.chat-icon-link {
  opacity: 0.45;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 13px;
  width: 20px;
  min-width: 10px;
  height: 20px;
  cursor: pointer;
}

.home-chat-field {
  margin-left: -10px;
  border-radius: 0 6px 6px 0;
  height: 40px;
}

.chat-icon-link:hover {
  opacity: 1;
}

.chat-icon-link.thumbs-up {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.chat-icon-link.thumbs-dwn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.chat-icon-link.edit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.expand-history-btn {
  cursor: pointer;
  background-color: #e2e9f0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 18px;
  border-radius: 3px;
  width: 25px;
  height: 25px;
  margin-bottom: 5px;
}

.expand-history-btn.rotate {
  transform: rotate(180deg);
}

.expand-checklist-btn {
  cursor: pointer;
  background-color: #e2e9f0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 18px;
  border-radius: 3px;
  width: 25px;
  height: 25px;
  margin-bottom: 5px;
}

.control-section {
  height: 75vh;
  overflow: auto;
}

.pdf-expand {
  cursor: pointer;
  background-color: #e2e9f0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 3px;
  width: 25px;
  height: 30px;
  position: absolute;
  left: -25px;
  transform: rotate(180deg);
}

.pdf-error-message {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  /* Ensures some space even if container is small */
  background-color: #fff4f4;
  border: 1px solid #f5c2c7;
  border-radius: 8px;
  color: #842029;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  padding: 16px 24px;
  margin: 12px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.pdf-error-message p {
  margin: 0;
  line-height: 1.5;
}

.pdf-full-expand {
  width: 737px;
  position: fixed;
  right: 20px;
  transition: 0.3s;
  top: 22px;
  background: #fff;
  height: calc(100vh - 57px);
  box-shadow: 2px 2px 10px #b5b2b2;
}

.pdf-full-expand.hide .pdfview.overlap {
  display: none;
}

.pdf-full-expand.hide {
  width: auto;
  position: static;
  height: auto;
}

.pdf-full-expand.hide .pdf-expand {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  box-shadow: none;
  transform: rotate(0deg);
  top: 61px;
  right: 0;
  left: auto;
}

.expand-history-btn.hide {
  display: none;
}

.chat-history.pdfhide {
  display: none;
}

.expand-checklist-btn.hide {
  display: none;
}

.expand-history-btn.left-shift {
  left: -30px;
  transform: rotate(0);
}

.chat-section {
  position: relative;
  padding: 7px 0 0 0;
  width: 53px;
}

.userchat {
  font-size: 12px;
  padding: 10px 0;
}

.chat-section .chat-history-sec {
  display: none;
}

.chat-section.auto .chat-history-sec {
  display: block;
}

.recent-history {
  padding: 10px 0;
  margin-bottom: 10px;
  max-height: calc(100vh - 210px);
  overflow: auto;
}

.limit-skill-display {
  grid-area: 1 / span 4;
}

.checkbox-list {
  display: none;
}

.checkbox-list.show {
  width: 310px;
  padding: 17px;
  height: 100%;
  box-shadow: 2px 2px 10px #d7cccc;
  display: block;
}

.checkrow {
  display: flex;
  gap: 10px;
}

.toggle-areas {
  display: flex;
  justify-content: flex-end;
  flex-flow: column;
  align-items: flex-end;
  margin: 5px;
  position: absolute;
  left: -41px;
}

.chat-right {
  position: absolute;
  right: 0;
  height: 100%;
  background: #fff;
  top: 0;
}

.chat-history-sec {
  padding: 20px;
  height: 100%;
  box-shadow: 2px 2px 10px #d7cccc;

  display: none;
}

.chat-history-sec.show {
  display: block;
  width: 284px;
}

.pdfview.overlap {
  position: absolute;
  width: 733px;
  right: 0px;
  height: calc(100vh - 300px);
  max-height: calc(100vh - 300px);
  transition: 0.3s;
  z-index: 1;
}

.inner-tab-content {
  padding: 10px 30px 20px 30px;
  max-height: calc(100vh - 131px);
  overflow-y: auto;
}

.prompt-tabs.w-tabs.hide {
  display: none;
}

.text-wrap h3 {
  margin: 0;
  font-size: 14px;
}

.text-wrap p {
  font-size: 12px;
}

.pdfview.hide {
  display: none;
}

.inner-tab-content .text-wrap {
  word-wrap: break-word;
}

.chat-section.auto {
  width: 25%;
}

.chat-history.hide {
  display: none;
}

.expand-history-btn:hover {
  background-color: var(--mks-primary);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.userintro {
  display: flex;
  align-items: center;
  gap: 10px;
}

.userintro p {
  margin-bottom: 0;
}

.wavy-hand {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  width: 25px;
  background-size: 100%;
  height: 30px;
  background-repeat: no-repeat;
  background-position: center;
}

.bookmark-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  width: 25px;
  background-size: 100%;
  height: 25px;
  background-repeat: no-repeat;
  background-position: center;
}

.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  gap: 8px;
}

.flex-start .down-arrow {
  cursor: pointer;
}

.down-arrow.rotate {
  transform: rotate(180deg);
}

.history-box {
  text-align: center;
  display: none;
}

.history-box.show {
  display: block;
  padding-left: 21px;
}

.recent-history-title {
  border-radius: 5px;
  padding: 5px 8px;
  text-align: left;
}

.font-bold {
  font-weight: 600;
  font-size: 11px;
  margin-left: 7px;
}

.recent-history-title:hover {
  background: #f5f5f5;
  cursor: pointer;
}

.history-box p {
  margin-bottom: 0;
}

.button-newchat-disabled img {
  filter: invert(0.3);
}

.collapse-div {
  font-size: 12px;
  margin-bottom: 15px;
}

.h4 {
  color: var(--mks-primary-dark);
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.button-wrapper {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.canvas-wrap canvas {
  width: 100%;
}

.icon-button {
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  background-color: var(--mks-blue);
  color: var(--white);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-position: 15%;
  background-repeat: no-repeat;
  background-size: 14px;
  border-radius: 40px;
  flex: 1 1;
  justify-content: center;
  align-items: center;
  padding: 0.6rem 0 0.6rem 20px;
  font-size: 10px;
  font-weight: 500;
  text-decoration: none;
  display: flex;
}

.button:hover,
.icon-button.add:hover {
  background-color: #0d4eb7;
}

.prompt-action-icon:hover {
  filter: drop-shadow(2px 2px 4px #226194);
}

.icon-button.light {
  color: var(--darkbg);
  background-color: #e7f4ff;
}

.ai-collection-link-block:hover {
  box-shadow: 2px 2px 23px #b9b2b2;
}

.icon-button.light.add-folder {
  background-color: var(--mks-blue-light);
  color: var(--mks-primary-dark);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.icon-button.light.add-folder:hover {
  background-color: #e3effa;
}

.icon-button.add {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-size: 12px;
}

.btn-icon {
  width: 12px;
  height: 12px;
}

.search-history {
  margin-bottom: 0;
  display: flex;
}

.search-btn {
  background-color: var(--white);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 15px;
  border-radius: 5px;
  width: 30px;
  height: 30px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: -35px;
  padding-left: 0;
  padding-right: 0;
}

.search-btn:hover {
  background-color: var(--border-grey);
}

.search-input-field {
  color: var(--dark-bg-2);
  border: 1px solid #d4d4d4;
  border-radius: 5px;
  margin-bottom: 0;
  padding-right: 35px;
}

.search-input-field::placeholder {
  font-size: 11px;
}

.history-block-wrapper {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  flex-flow: column;
  display: flex;
}

.chat-history-link-block {
  opacity: 0.45;
  color: var(--mks-primary-dark);
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  background-position: 9px;
  background-repeat: no-repeat;
  background-size: 14px;
  border-radius: 5px;
  justify-content: flex-start;
  align-items: center;
  padding: 11px 10px 11px 30px;
  text-decoration: none;
  display: flex;
}

.chat-history-link-block:hover {
  background-color: #f2f4f8;
}

.chat-history-link-block.w--current {
  opacity: 1;
  background-color: #f2f4f8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.chat-history-link-block.is-active {
  background-color: #f2f4f8;
}

.left-user-settings {
  position: relative;
  justify-content: end;
  display: flex;
}

.left-user-settings {
  padding-bottom: 0;
}

.user-profile-menu {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  color: #000;
  border-top: 1px solid #fff3;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  font-size: 12px;
  text-decoration: none;
  display: flex;
}

.dash-header h1 span {
  color: #0063ff;
}

.user-profile-initial {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #80ce1a;
  border-radius: 50%;
  width: 37px;
  height: 37px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.user-profile-initial:hover {
  background-color: #80ce1a;
}

.user-update-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0665ff;
  border-radius: 50%;
  width: 37px;
  height: 37px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.user-update-prompt:hover {
  background-color: #0665ff;
}

.left-bottom-menu-nav {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  border-bottom: 1.3px solid #000;
  flex-flow: column;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
}

.custom-example.search-input-field {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 10px;
}

.user-dot-menu {
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  opacity: 0.5;
  flex-flow: column;
  margin-left: auto;
  padding: 12px 15px;
  display: flex;
  cursor: pointer;
}

.user-menu-dot {
  background-color: #000;
  border-radius: 100px;
  width: 4px;
  height: 4px;
}

.welcome-wrapper {
  grid-column-gap: 6px;
  grid-row-gap: 6px;
  text-align: center;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 15px 33px;
  display: flex;
}

.hi-icon {
  width: 20px;
}

.check-contain.font-display-streaming {
  font-weight: 400;
  font-size: 17px;
}

.check-contain.font-display-streaming .checkmark-check {
  top: 0;
}

.check-contain.font-display-streaming p {
  font-size: 17px;
  margin-left: 8px;
  font-weight: 500;
}

.welcome-h-flex {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  justify-content: center;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 500;
}

.prompt-sample-wrapper {
  grid-column-gap: 11px;
  grid-row-gap: 11px;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 17px;
  padding-bottom: 17px;
  display: flex;
}

.sample-prompts {
  color: var(--mks-primary-dark);
  background-color: #eaedf09e;
  background-image: linear-gradient(#0000 88%, #dce2e7);
  border: 1px solid #e8ebec;
  border-top-color: #fff;
  border-radius: 100px;
  padding: 8px 20px;
  font-size: 12px;
  text-decoration: none;
}

.sample-prompts:hover {
  background-color: #dae4ec9e;
}

.section-wrapper {
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  flex-flow: column;
  padding: 20px 40px;
  display: flex;
}

.skill-icon-block .ai-block-icon {
  width: 50px;
  height: 50px;
}

.skill-filter-wrapper {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  border-bottom: 1.5px solid var(--border-grey);
  background-color: var(--white);
  margin-bottom: 0;
  padding: 17px 0px;
  display: flex;
  border-radius: 10px;
}

.prompts-tabs-content .skill-filter-wrapper {
  padding: 17px 0;
}

.skill-filter-field {
  border: 1px solid var(--border-color);
  color: #7a7a7a;
  background-color: #f5f7f8;
  border-radius: 5px;
  flex: 1 1;
  min-height: 35px;
  margin-bottom: 0;
  padding: 10px 30px 10px 10px;
  font-size: 11px;
  display: flex;
}

.skill-filter-field::placeholder {
  color: #7a7a7a;
}

.skill-filter-form {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  flex: 1 1;
  display: flex;
  /* display: grid;
    grid-template-columns: 21% 20% 25% 30%; */
}

.prompts-tabs-content .search-cross-icon-common {
  width: 290px;
}

.tabs-menu.h-flex.head-wrapper {
  padding-top: 0;
  padding-bottom: 0;
}

.input-search-box {
  margin-right: 12px;
  position: relative;
}

.search-tile-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  position: absolute;
  right: 5px;
  top: 0;
  cursor: pointer;
  background-repeat: no-repeat;
  width: 18px;
  height: 37px;
  background-position: center;
}

.search-tile-icon-common {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  position: absolute;
  top: 0;
  right: 8px;
  cursor: pointer;
  background-repeat: no-repeat;
  width: 18px;
  height: 37px;
  background-position: center;
}

.search-cross-icon-common {
  position: relative;
}

.search-tile-box {
  background-repeat: no-repeat;
  background-position: 99% 50%;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 7px 30px 7px 10px;
  width: 100%;
  outline: none;
}

.cross-tile-box {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  background-repeat: no-repeat;
  background-position: 99% 50%;
  border-radius: 5px;
  padding: 7px 10px;
  width: 100%;
  outline: none;
  position: absolute;
  right: 4px;
  top: 11px;
  cursor: pointer;
  top: 0;
  height: 37px;
}

.cross-tile-box-workspace {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  background-repeat: no-repeat;
  background-position: 98% 50%;
  border-radius: 5px;
  padding: 7px 10px;
  /* width: 100%; */
  outline: none;
  position: absolute;
  right: 4px;
  top: 11px;
  cursor: pointer;
  top: 0;
  height: 37px;
}

.cross-tile-box-common {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  background-repeat: no-repeat;
  background-position: 99% 50%;
  border-radius: 5px;
  padding: 7px 10px;
  outline: none;
  position: absolute;
  right: 4px;
  top: 11px;
  cursor: pointer;
  top: 0;
  height: 37px;
}

.flex-col .pagination-container .pagination-wrapper {
  padding-bottom: 0;
}

.prompt-tabs-link {
  color: var(--slate-gray);
  background-color: #ddd0;
  border-bottom: 2px solid #0000;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
}

.prompt-tabs-link.w--current {
  border-bottom-color: var(--mks-primary-dark);
  color: var(--mks-primary-dark);
  background-color: #fff0;
}

.prompts-tabs-content {
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  flex-flow: column;
  display: flex;
}

.user-tabs-content {
  grid-column-gap: 20px;
  grid-row-gap: 10px;
  margin-top: 10px;
  flex-flow: column;
  display: flex;
}

.prompt-creator-block {
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  font-size: 12px;
}

.custom-div-table {
  border-radius: 0;
}

.prompt-user-block {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  display: flex;
}

.prompt-user-img {
  background-color: #0665ff;
  border-radius: 100px;
  width: 24px;
  height: 24px;
  overflow: hidden;
}

.prompt-user-name {
  color: var(--mks-primary-dark);
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
}

.collection-views-block {
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  color: var(--mks-primary-dark);
  justify-content: flex-end;
  align-items: center;
  padding-right: 2px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  display: flex;
}

.views-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 18px;
  height: 18px;
}

.share-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 18px;
  height: 18px;
}

.thumbs-up-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 15px;
  height: 15px;
}

.comment-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 18px;
  height: 18px;
}

.view-active-background .views-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 18px;
  height: 18px;
}

.prompt-grid-row {
  display: grid;
  gap: 10px;
  grid-template-columns: 65% 1fr 1fr 1fr;
  border-bottom: 1px solid #e5e5e5;
  padding: 6px;
  font-size: 12px;
}

.view-prompt-col {
  display: flex;
  align-items: center;
  gap: 10px;
}

.thumbs-up-col {
  display: flex;
  align-items: center;
  gap: 10px;
}

.view-active-background {
  background-color: #053a64;
  border-radius: 30px;
}

.prompts-action-wrapper {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  display: flex;
}

.share-action-wrapper {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  display: flex;
}

.favourite-button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  background-position: 50% 0;
  background-repeat: no-repeat;
  background-size: contain;
  width: 20px;
  height: 25px;
  margin-right: 5px;
  position: absolute;
  inset: 0% 5px auto auto;
  top: -11px;
}

/* .favourite-button:hover,
.favourite-button:active,
.favourite-button:focus,
.favourite-button:visited {
  background-image: url("../images/mksapp/favourite-icon-active.svg");
} */

.favourite-button-active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  background-position: 50% 0;
  background-repeat: no-repeat;
  background-size: contain;
  width: 20px;
  height: 25px;
  margin-right: 5px;
  position: absolute;
  inset: 0% 5px auto auto;
  top: -11px;
}

.prompt-action-link {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  color: var(--mks-primary-dark);
  justify-content: flex-start;
  align-items: center;
  font-size: 11px;
  line-height: 12px;
  text-decoration: none;
  display: flex;
  cursor: pointer;
}

.prompt-action-icon {
  width: 20px;
  height: 20px;
}

.appdash-wrapper {
  flex-flow: column;
  flex: 1 1;
  padding-bottom: 15px;
  display: flex;
}

.accordian-body {
  flex-flow: column;
  display: flex;
}

.service-list-wrapper {
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  flex-flow: column;
  padding: 5px;
  display: flex;
}

.draggable-button {
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  padding: 3px;
  display: flex;
}

.app-group-heading {
  color: #000;
  border-bottom: 1px solid #ddd;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 53px;
  display: flex;
  gap: 10px;
}

.custom-application {
  cursor: pointer;
  line-height: normal;
}

.custom-application img {
  filter: invert(1);
}

.wrkspace-section-wrap .dash-section.p20 {
  padding-top: 0;
}

.task-block {
  background-color: #f7f7f7;
  border: 1px solid #fff0;
  border-radius: 0;
  justify-content: flex-start;
  align-items: center;
  margin-top: -5px;
  padding-right: 3px;
  display: flex;
}

.task-block:hover {
  z-index: 1;
  background-color: #f9fcff;
  border: 1px solid #c1d0e2;
  border-radius: 4px;
  position: relative;
}

.servicenow-list-block {
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  border: 1px solid #fff;
  border-radius: 4px;
  flex-flow: column;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 9px;
  line-height: 12px;
  text-decoration: none;
  display: flex;
}

.servicenow-list-block:hover {
  background-color: #f9fcff;
  border: 1px solid #dfdfdf;
  text-decoration: none;
}

.app-grid-wrap-block {
  border-radius: 10px;
  flex-flow: column;
  display: flex;
  overflow: hidden;
}

.servicenow-text {
  color: #000;
  font-weight: 600;
}

.report-label {
  padding-top: 6px;
  padding-bottom: 6px;
  font-weight: 700;
  line-height: 12px;
}

.report-label.head {
  font-weight: 600;
}

.reports-list-wrapper {
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  background-color: #fff;
  flex-flow: column;
  flex: 1 1;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  width: 100%;
  padding: 5px;
  display: flex;
}

.accordian-arrow-icon {
  opacity: 0.55;
  background-color: #e4eaf0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 12px;
  border-radius: 3px;
  width: 22px;
  height: 22px;
}

.accordian-arrow-icon:hover {
  opacity: 1;
  background-color: #e0e6ec;
}

.right-list-block {
  flex-flow: column;
  display: flex;
  overflow: auto;
}

.task-day {
  color: #891a1c;
  font-size: 8px;
  font-weight: 600;
  line-height: 14px;
}

.task-day.tomorrow,
.task-day.today {
  color: #008a20;
}

.servcnow-status {
  justify-content: space-between;
  align-items: flex-end;
  display: flex;
}

.task-label {
  white-space: normal;
  flex: 1 1;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 9px;
  font-weight: 600;
  line-height: 12px;
}

.text-link-2 {
  color: #006aff;
  padding-left: 7px;
  padding-right: 7px;
  font-size: 9px;
  font-weight: 600;
  text-decoration: none;
}

.my-workspace-wrapper {
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: 82%;
  overflow-y: auto;
}

.add-btn {
  opacity: 0.55;
  background-color: #e4eaf0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 12px;
  border-radius: 3px;
  width: 22px;
  height: 22px;
}

.add-btn:hover {
  opacity: 1;
  background-color: #e0e6ec;
}

.dragbutton-inactive {
  display: none;
}

.app-right-heading {
  justify-content: flex-start;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 12px;
  display: flex;
}

.servnow-head-row {
  grid-column-gap: 4px;
  grid-row-gap: 4px;
  border-bottom: 1px solid #d6d6d6;
  grid-template-rows: auto;
  grid-template-columns: 2fr auto auto;
  align-content: center;
  place-items: center stretch;
}

.app-left-col {
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  border-radius: 15px;
  flex-flow: column;
  flex: 1 1;
  padding: 20px 40px;
  display: flex;
  overflow: auto;
}

.accordian-label-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
}

.accordian-label-icon.reports {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  background-size: contain;
}

.accordian-label-icon.service {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  border-radius: 5px;
}

.accordian-label-icon.to-do {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}

.servnow-status {
  color: #000;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  line-height: 15px;
}

.servnow-status.in-progress {
  color: #eea300;
  background-color: #ffeed4;
}

.servnow-status.closed {
  color: #891a1c;
  background-color: #ffdfdf;
}

.servnow-status.open {
  color: #008a20;
  background-color: #c4ffd0;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 8px;
  line-height: 15px;
}

.app-link-tile {
  z-index: 1;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  color: #000;
  text-align: center;
  cursor: grab;
  background-color: #fff;
  border: 1px solid #d2deed;
  border-radius: 8px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 19px 6px;
  text-decoration: none;
  transition: box-shadow 0.4s;
  display: flex;
  position: relative;
}

.app-link-tile:hover {
  z-index: 1;
  border-style: dashed;
  border-color: #333f4e59;
  text-decoration: none;
  position: relative;
  box-shadow: 0 0 50px 20px #0d2f4e1c;
}

.taskchkbox {
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-left: 4px;
  padding-right: 4px;
  display: flex;
}

.right-list-wrapper {
  flex-flow: column;
  display: flex;
  overflow: hidden;
}

.app-right-col {
  background-color: var(--white);
  border-radius: 0 15px 15px 0;
  flex-flow: column;
  flex: 0 1 auto;
  width: 32%;
  min-width: 32%;
  height: 100%;
  padding: 20px 5px;
  display: flex;
  overflow: hidden;
}

.app-right-col.hide {
  display: none;
}

.app-logo-icon {
  justify-content: center;
  align-items: center;
  width: 50px;
  min-width: 50px;
  height: 50px;
  min-height: 50px;
  margin-bottom: 5px;
  padding: 3px;
  display: flex;
}

.app-logo-icon.wide {
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 100px;
  display: flex;
}

.tasks-wrapper {
  flex-flow: column;
  flex: 1 1;
  width: 100%;
  margin-bottom: 0;
  padding: 7px 5px;
  display: flex;
  overflow: hidden;
}

.view-link-block {
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.w-layout-grid:has(.app-group-norecordfound) {
  grid-template-columns: 1fr;
  text-align: center;
}

.list-wrapper {
  background-color: #fff;
  flex-flow: column;
  flex: 0 1 auto;
  display: flex;
}

.app-links-grid {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  padding-bottom: 20px;
}

.applist-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.applist-row .app-logo-icon {
  min-height: auto;
  height: auto;
  width: 27px;
  min-width: 26px;
  margin-bottom: 0;
  padding: 0;
}

.paragraph.small {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 90px;
  word-break: break-word;
}

.applist-view {
  display: flex;
  flex-flow: column;
  gap: 8px;
  max-height: 290px;
  overflow-y: auto;
}

.app-logo-icon img {
  object-fit: contain;
  width: 50px;
  height: 50px;
}

.multifile-row {
  display: flex;
  flex-wrap: wrap;
}

.applist-view .app-logo-icon img {
  object-fit: contain;
  width: 20px;
  height: 20px;
}

.applist-view .check-contain {
  padding-left: 15px;
}

.app-list .popup-btn-container {
  justify-content: center;
  margin-top: 34px;
}

.accordian-heading {
  cursor: pointer;
  border-top: 1px solid #7080dd3b;
  border-bottom: 0.5px solid #7080dd3b;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 9px;
  font-weight: 700;
  display: flex;
}

.app-name-label {
  color: #00567d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.task-checkbox {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  border-color: #fff;
  border-radius: 20px;
  width: 20px;
  max-width: 14px;
  height: 20px;
  max-height: 14px;
  margin-top: 0;
  margin-left: 0;
  margin-right: 7px;
  padding: 0;
}

.task-checkbox.w--redirected-checked {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  background-size: contain;
  border-color: #fff;
}

.task-checkbox.w--redirected-focus {
  box-shadow: 0 0 3px 1px #00ff19;
}

.tasks-wrapper-form {
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  flex-flow: column;
  display: flex;
}

.servnow-label {
  color: var(--mks-primary-dark);
  font-size: 10px;
  font-weight: 500;
  line-height: 27px;
}

.reports-block {
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  flex-flow: column;
  grid-template-rows: auto;
  grid-template-columns: 0.9fr 0.7fr 0.4fr;
  grid-auto-columns: 1fr;
  justify-content: flex-start;
  place-items: center stretch;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 9px;
  font-weight: 600;
  line-height: 17px;
  display: grid;
}

.reports-block:hover {
  background-color: #f9fcff;
  border: 1px solid #e7e3e3;
}

.reports-block.head-row {
  color: #8a8a8a;
  border-bottom: 1px solid #dfdfdf;
  border-radius: 0;
}

.reports-block.head-row:hover {
  background-color: #fff;
  border: 1px solid #fff;
  border-bottom-color: #dfdfdf;
}

.app-grid-wrapper {
  background-color: #fff;
  border-radius: 10px;
  overflow: auto;
}

.servnow-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 17px;
  height: 18px;
}

.servnow-icon.info {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}

.accordiian-heading-block {
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.app-category-label {
  cursor: pointer;
  font-size: 10px;
  line-height: 14px;
}

.wrkspace-section-wrap {
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  flex-flow: column;
  display: flex;
}

/* Logout Popup code Start here*/
.popup-menu {
  position: absolute;
  background-color: white;
  border-radius: 4px;
  padding: 5px;
  z-index: 1000;
  min-width: 150px;
  width: 100%;
  right: 0;
  box-shadow: 2px 2px 10px #d5d1d1;
  top: 54px;
}

.full-name-row {
  background: #053a64;
  color: #fff;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 5px;
}

.left-user-settings .popup-row:hover {
  background: #053a64;
  color: #fff;
}

.popup-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 0 8px;
}

.left-user-settings .popup-row {
  padding: 3px 5px;
  border-radius: 4px;
  cursor: pointer;
}

.left-user-settings .popup-row:hover a {
  color: #fff;
}

.left-user-settings .popup-row:hover .logout-icon {
  filter: invert(1);
}

.popup-menu a {
  background-color: transparent;
  text-decoration: none;
  color: #041f35;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.full-name-text {
  display: flex;
  align-items: center;
  gap: 5px;
}

.full-name-text::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  width: 18px;
  height: 18px;
  background-size: cover;
  display: block;
}

.add-prompt-text {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  width: 12px;
  height: 12px;
  background-size: cover;
  display: block;
  margin-right: 10px;
}

.skill-create-tags .suggestions.mks-suggestion-prompt {
  max-height: 150px;
  overflow-y: auto;
}

.popup-row {
  margin-top: 10px;
}

.prompt-popup-menu .popup-row {
  font-size: 12px;
  margin: 0;
  padding: 4px 7px;
}

.prompt-popup-menu .popup-row:hover {
  background-color: #e5e5e5;
}

.prompt-popup-menu .popup-row a {
  color: #000;
  text-decoration: none;
}

/* .popup-arrow {
  border-bottom: 10px solid #e5e5e5;
  border-left: 10px solid #0000;
  border-right: 10px solid #0000;
  height: 0;
  top: 44px;
  position: absolute;
  right: 11%;
  width: 0;
} */

.popup-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  height: 22px;
  top: 37px;
  position: absolute;
  right: 0;
  width: 33px;
}

.popup-menu button:hover {
  background-color: #0056b3;
}

.medium-font {
  font-size: 27px;
  margin-bottom: 0;
}

.subtext {
  font-size: 12px;
}

.prompt-popup-menu {
  position: absolute;
  background-color: white;
  border-radius: 4px;
  z-index: 1000;
  width: 100%;
  top: 35px;
  padding: 0;
  width: 100%;
  right: 0;
  box-shadow: 2px 2px 10px #d5d1d1;
}

user-profile-menu w-inline-block {
  position: relative;
}

.ai-collection-grid {
  padding-bottom: 10px;
}

.prompt-user-img {
  color: #fff;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 12px;
}

/* .w-dropdown-list.w--open {
  display: block;
}

.user-dd-list.w--open {
  align-items: flex-end;
  background-color: #0000;
  display: flex;
  flex-direction: column;
  padding-top: 19px;
  right: 0;
}

.w-dropdown-list {
  background: #ddd;
  display: none;
  min-width: 100%;
  position: absolute;
}

.dd-triangle {
  border-bottom: 10px solid #fff;
  border-left: 10px solid #0000;
  border-right: 10px solid #0000;
  height: 0;
  margin-top: -10px;
  position: absolute;
  right: 7px;
  width: 0;
}

.dd-link-wrapper {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px 10px #bfbaba;
  padding: 6px;
}

.user--dd-link.w-inline-block {
  display: flex;
}

.w-inline-block {
  display: inline-block;
  max-width: 100%;
}

.user--dd-link {
  border-radius: 4px;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  padding: 10px 15px;
  text-align: right;
  text-decoration: none;
  white-space: nowrap;
}

.main-menu, .user--dd-link {
  align-items: center;
  display: flex;
}

a {
  background-color: initial;
}

.dd-link-seperator {
  background-color: #ececec;
  height: 1px;
  margin-bottom: 3px;
  margin-top: 3px;
}

.user--dd-link.w-inline-block {
  display: flex;
}

.w-inline-block {
  display: inline-block;
  max-width: 100%;
}

.user--dd-link {
  border-radius: 4px;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  padding: 10px 15px;
  text-align: right;
  text-decoration: none;
  white-space: nowrap;
}
.dd-link-icon.logout {
  background-image: url(https://cdn.prod.website-files.com/66438c9…/667ca37…_logout-icon.svg);
}
.dd-link-icon {
  background-image: url(https://cdn.prod.website-files.com/66438c9…/667ca37…_reset-password-icon.svg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 15px;
  margin-right: 10px;
  width: 15px;
} */

.resource-add {
  display: flex;
  align-items: center;
  gap: 50px;
}

.loader-map {
  text-align: center;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  height: 300px;
  gap: 17px;
}

.loader-text.loader-map-text-display {
  width: 200px;
  text-align: center;
  right: 18px;
}

.loader-map-text {
  color: #053a64;
  font-weight: 500;
}

.loader2 {
  width: 35px;
  aspect-ratio: 1;
  --_g: no-repeat radial-gradient(circle closest-side, #1680d3 90%, #0000);
  background: var(--_g) 0 0, var(--_g) 0 100%, var(--_g) 100% 100%;
  background-size: 40% 40%;
  animation: l11 1s infinite linear;
}

@keyframes l11 {
  25% {
    background-position: 100% 0, 0 100%, 100% 100%;
  }

  50% {
    background-position: 100% 0, 0 0, 100% 100%;
  }

  75% {
    background-position: 100% 0, 0 0, 0 100%;
  }

  100% {
    background-position: 100% 100%, 0 0, 0 100%;
  }
}

.logout-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 15px;
  margin-right: 10px;
  width: 15px;
}

/* Logout Popup code End here*/

/********breadcrumb***********/
.breadcrumb {
  display: flex;
  align-items: center;
  padding: 20px 40px 0;
  gap: 4px;
}

.breadcrumb a {
  display: flex;
  text-decoration: none;

  align-items: center;
}

.home-link::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
  margin-top: -5px;
}

.home-link::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
}

/* .normal-link::after {
  content: '';
  background: url(../images/mkspropmanagment/chevron-right.svg);
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
} */

.breadcrumb .normal-link {
  color: #565151;
  font-size: 13px;
}

/* .breadcrumb a.normal-link:last-child::after {
  display: none;
} */

.breadcrumb a.visited {
  color: #4a63ff;
  font-size: 13px;
  gap: 4px;
}

.breadcrumb a.visited:hover {
  color: #3147d3;
}

.linkclass {
  color: #3147d3;
  line-height: 19px;
  /* text-decoration: underline; */
  cursor: pointer;
  margin-top: 3px;
  /* list-style-type: decimal; */
}

.linkclassText {
  color: #3147d3;
  /* text-decoration: underline; */
  cursor: pointer;
  margin-top: 3px;
  list-style-type: decimal;
  cursor: pointer;
}

.linkclassTextLast {
  color: #3147d3;
  /* text-decoration: underline; */
  cursor: pointer;
  margin-top: 3px;
  list-style-type: decimal;
  cursor: pointer;
}

.linkclassTextLast.linkbox {
  border: 1px solid #a7a7a7;
  padding: 1px 4px;
  display: inline;
  margin-right: 5px;
}

.linkclassText.linkbox {
  border: 1px solid #a7a7a7;
  padding: 1px 4px;
  display: inline;
  margin-right: 5px;
}

.location-info {
  background-color: #e8f4fd;
  border: 1px solid #61dafb;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  position: relative;
  color: #282c34;
  font-size: 16px;
  animation: slideIn 0.3s ease-out;
}

.location-info strong {
  color: #1976d2;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #333;
}

.instruction-text {
  text-align: center;
  color: #666;
  font-style: italic;
  margin-top: 15px;
  font-size: 14px;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.error-block-display {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.error-block-button-display {
  margin-top: 16px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.fallback-display {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.trash-button-icon.light-gray-button.disabled-element .trash-icon {
  filter: none !important;
}

.right-buttons .trash-button-icon.light-gray-button .trash-icon {
  filter: brightness(0);
}

.dark-theme .chathead {
  color: #000;
}

.dark-theme .skills-tabs .ai-collection-grid {
  background: transparent;
  padding: 0;
}

.dark-theme .overview-card {
  background: #fff;
  box-shadow: 2px 2px 10px #3b3b3b;
}

.dark-theme .chart-active-button {
  background: #fff;
  color: #053a64;
}

.dark-theme .e-control.e-chart {
  background: #fff;
}

.dark-theme .container-no-records {
  color: #000;
}

.dark-theme .light-gray-button .trash-icon {
  filter: invert(1);
}

/***********breadcrumbs end**********/

/*******feedback page start********/
.feedabck-wrapper {
  gap: 20px;
  padding: 20px 40px;
  display: flex;
  align-items: flex-start;
}

.feedback-left-section,
.feedback-right-section {
  width: 100%;
}

.feedback-textarea {
  width: 100%;
  min-height: 300px;
  resize: none;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 10px;
}

.feedback-left-section {
  display: flex;
  flex-flow: column;
  gap: 20px;
  max-height: calc(100vh - 148px);
  overflow-y: auto;
}

.feedbacktext {
  background: #f9f9f9;
  font-size: 12px;
  padding: 10px;
  border-radius: 5px;
}

.feedback-flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.check-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.check-wrap label {
  font-weight: 500;
  margin: 0;
  font-size: 12px;
}

.feedback-right-section h2 {
  margin: 0;
}

.count-word {
  text-align: right;
}

.read-more-text {
  color: #0063ff;
  cursor: pointer;
}

.feedback-right-section {
  background: #f3f3f3;
  padding: 20px;
  border-radius: 10px;
}

.feedback-btn-submit {
  padding: 7px;
  background-color: #053a64;
  color: white;
  border-radius: 5px;
}

/*********prompt page start************/

.prompt-steps {
  display: flex;
  padding: 20px 0;
  background: #ffffff;
  position: relative;
}

.prompt-step {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.p-dot {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background-color: #fff;
  border: 1px solid #b3b7bd;
}

.p-done .p-dot {
  background: #005fff;
}

.p-current::after {
  content: "";
  background-color: #e5e5e5;
  width: 100%;
  height: 1px;
  display: block;
  position: absolute;
  bottom: 6px;
}

.p-current .p-dot {
  border: 1px solid #005fff;
  background: #e5e5e5;
}

.prompt-selects select,
.prompt-selects .dropdown-button {
  background: #fff;
}

.prompt-selects .custom-dropdown .dropdown-menu-custom {
  background: #fff;
}

.suggestions {
  position: absolute;
  background: #fff;
  z-index: 1;
  font-size: 12px;
  padding: 9px;
  border-radius: 0 0 10px 10px;
  border: 1px solid #e5e5e5;
  /* cursor: pointer; */
}

.suggestions.mks-suggestion {
  top: 47px;
  border-radius: 5px 5px 0 0;
  width: 46%;
  left: 0;
}

.mks-suggestion .suggestion-item {
  padding: 3px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  font-size: 11px;
}

.mks-suggestion-prompt .suggestion-item {
  padding: 3px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  font-size: 11.5px;
}

.suggestions.prompt-suggestions {
  bottom: 40px;
  border-radius: 5px 5px 0 0;
  width: 46%;
  left: 0;
  max-height: 56vh;
  overflow-y: auto;
}

.prompt-suggestions .suggestion-item {
  padding: 3px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  font-size: 11px;
}

.dark-theme .suggestions.prompt-suggestions {
  border-top: 2px solid #5a7b9d;
}

.suggestion-item {
  cursor: pointer;
}

.addtag-input button {
  background: #226194;
  color: #fff;
  padding: 3px 8px;
  border-radius: 5px;
  margin-left: 7px;
}

.p-dot-wrapper {
  margin-top: 6px;
}

.prompt-steps .prompt-step:last-child .p-done::after {
  display: none;
}

.prompt-step-desc {
  font-size: 12px;
  color: #a39e9e;
}

.p-done::after {
  content: "";
  background-color: #005fff;
  width: 100%;
  height: 1px;
  display: block;
  position: absolute;
  bottom: 6px;
}

.check-ackn {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  justify-content: flex-start;
}

.help-section {
  display: grid;
  grid-template-columns: 70% 30%;
  gap: 26px;
}

.help-video-boxes {
  max-height: calc(100vh - 170px);
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 21px;
  padding: 13px 15px;
}

.check-ackn p {
  margin-bottom: 0;
  font-size: 12px;
}

.help-video-desc {
  color: #053a64;
  font-size: 0.7rem;
  font-weight: 500;
}

.h-full {
  height: 100%;
}

.p-checkbox {
  margin-top: 2px;
  width: 20px;
  height: 20px;
}

.prompt-title {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  line-height: 14px;
  margin-bottom: 10px;
}

.prompt-img {
  max-width: 60px;
  height: 60px;
  border: 6px solid #e5e5e5;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 100%;
}

.prompt-img-title {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.prompt-title-small {
  font-size: 12px;
  margin: 0;
  line-height: 14px;
  margin-bottom: 10px;
}

.prompt-title-wrap {
  width: 100%;
  position: relative;
}

.prompt-title-wrap .suggestions {
  width: 100%;
}

.prompt-textarea {
  width: 100%;
  padding: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  min-height: 130px;
  resize: none;
  overflow-y: auto;
  font-size: 12px;
}

.prompt-pii {
  padding: 10px;
  min-height: 100px;
  overflow-y: auto;
  max-height: 100px;
  width: 100%;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  background-color: white;
  outline: none;
}

.disabled-element .prompt-pii {
  background-color: #f2f2f2;
}

.disabled-parent .prompt-pii {
  background-color: #f2f2f2;
}

.disabled-element select {
  background-color: #f2f2f2;
}

select.prompt-skill.disabled-element {
  background-color: #f2f2f2;
}

.pref-block {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pref-block select,
.word-count-field {
  border: 1px solid #e5e5e5;
  font-size: 12px;
  padding: 6px 11px;
  border-radius: 5px;
  height: 33px;
}

.preference-wrapper {
  background: #f1f1f1;
  width: max-content;
  padding: 16px;
  border-radius: 5px;
}

.prompt-text {
  width: 100%;
  padding: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #fff;
}

input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 0;
}

.border-red {
  border: 1px solid red !important;
}

.prompt-desc {
  width: 100%;
  padding: 6px;
  border: 1px solid #e5e5e5;
}

.add-prompt-btn {
  position: absolute;
  right: 0;
  z-index: 2;
  top: 8px;
}

.prompt-tabs .ai-collection-grid.light-bg {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 10px;
}

.prompt-tag-select {
  display: flex;
  gap: 10px;
}

.prompt-skill {
  width: 100%;
  padding: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.prompt-modal select {
  width: 150px;
  padding: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.prompt-explanaion {
  display: grid;
  gap: 15px;
  grid-template-columns: 50% 50%;
}

.prompt-step-two .prompt-explanaion {
  display: grid;
  gap: 15px;
  grid-template-columns: 33% 33% 33%;
}

.prompt-text {
  width: 100%;
  padding: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.genrate-btn {
  background: #226194;
  color: #ffffff;
  padding: 10px 24px;
  border-radius: 40px;
}

.add-user {
  float: right;
  cursor: pointer;
}

.add-user-button {
  text-align: right;
}

.cancel-btn {
  background: #fff;
  color: #0c2a42;
  padding: 10px 24px;
  border-radius: 40px;
  text-decoration: none;
  border: 1px solid #d5cece;
}

.cancel-btn.small-size-bn {
  padding: 4px 15px;
  font-size: 10px;
}

.cancel-btn:hover {
  border: 0.5px solid;
}

.close-icon:hover {
  filter: brightness(0.5);
  cursor: pointer;
}

.addtag-input button:hover {
  background: #164e7a;
}

.genrate-btn:hover {
  background: #164e7a;
}

.backbtn:hover {
  background: #dddddd;
}

.saveprompt .genrate-btn {
  padding: 10px 20px;
}

.prompt-button-wrapper {
  display: flex;
  justify-content: space-between;
}

.flex-end {
  justify-content: flex-end;
}

.prompt-review {
  text-align: center;
}

.selected-tag {
  display: inline-block;
  background: #c6e1f7;
  padding: 4px 18px;
  border-radius: 30px;
  margin-top: 6px;
}

.prompt-review-box {
  display: flex;
  background: #fff;
  padding: 10px;
  gap: 10px;
  width: 100%;
}

.prompted-text {
  width: 100%;
  border: 0;
  font-size: 12px;
}

.prompted-text:focus-visible {
  outline: 0;
}

.new-reply-comment {
  width: 100%;
  margin-bottom: 10px;
}

.user-profile-initial.auto-cursor {
  cursor: default;
}

.new-reply-comment textarea {
  border: 1px solid #e5e5e5;
  font-size: 12px;
  max-height: 50px;
  overflow-y: auto;
  font-size: 11px;
  line-height: normal;
  resize: none;
}

.comment-reply-btn {
  background: #226194;
  color: #ffffff;
  font-size: 11px;
  padding: 1px 10px;
  border-radius: 5px;
}

.cancel-comment {
  background: #e5e5e5;
  color: #226194;
  font-size: 11px;
  padding: 1px 10px;
  border-radius: 5px;
}

.g-10 {
  gap: 10px;
}

.prompt-review-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.backbtn {
  display: flex;
  align-items: center;
  background: #efefef;
  color: #0c2a42;
  padding: 10px 24px 10px 14px;
  text-decoration: none;
}

.flex-block {
  display: flex;
  align-items: center;
}

.backbtn::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: inline-block;
}

.close-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}

.prompt-tags-wrap {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.all-comment {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-flow: column-reverse;
}

.p-tag {
  display: flex;
  align-items: center;
  background: #c6e1f7;
  border-radius: 24px;
  padding: 4px 10px;
  font-size: 8px;
  font-weight: 500;
  line-height: 12px;
}

.prompt-selects {
  display: flex;
  gap: 20px;
}

.h-line {
  display: block;
  width: 100%;
  border-top: 1px solid #e5e5e5;
}

.tag-flex {
  display: flex;
  justify-content: space-between;
}

.add-tag-btn {
  border: 1px solid #0063ff;
  background: #fff;
  padding: 1px 9px;
  border-radius: 5px;
  color: #0063ff;
  cursor: pointer;
  display: none;
}

.input-tag {
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 3px;
}

.input-numeric-tag {
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 6px;
}

.input-tag:focus-visible {
  outline: 0;
}

.input-numeric-tag:focus-visible {
  outline: 0;
}

.mt20 {
  margin-top: 20px;
}

.all-selected-item {
  display: flex;
  gap: 5px;
}

span.close-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
}

span.selected-val {
  background: #efefef;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 6px;
  font-size: 10px;
  gap: 3px;
}

.edit-common-icons.star-end {
  border: 0;
  padding: 0;
}

.star-end .favourite-button-active {
  position: static;
  cursor: pointer;
}

.no-pointer {
  cursor: context-menu !important;
}

.star-end .favourite-button {
  position: static;
  cursor: pointer;
}

.skill-detaill-right .prompt-selects {
  flex-flow: column;
}

.skill-fullwidth {
  padding: 0 40px 20px;
  display: flex;
  flex-flow: column;
  gap: 15px;
}

.skill-update-box {
  position: relative;
}

.custom-dropset {
  position: absolute;
  top: 53px;
  left: 0;
}

.create-skill-window .custom-dropset {
  bottom: 40px;
  top: auto;
}

.create-skill-window .ownerdrodown {
  box-shadow: 1px -11px 10px #e5e5e5;
}

.dark-theme .create-skill-window .ownerdrodown {
  box-shadow: 1px -11px 10px #042947;
}

.max-width-row {
  width: 100%;
  display: flex;
  gap: 20px;
  /* max-width: 60%; */
}

.securitygroup-text {
  padding: 8px;
  border: 0;
  width: 100%;
  border-radius: 4px;
}

.owner-box .custom-dropdown {
  width: 100%;
}

.skill-detaill-right .custom-dropdown {
  width: 100%;
}

.skill-detaill-right.autowidth .custom-dropdown {
  width: 100%;
  min-width: 100%;
}

.skill-one-row .check-ackn {
  width: 100%;
  max-width: 150px;
}

.skill-one-row .wrapper-api-url {
  width: 250px;
}

.skill-one-row .check-contain {
  top: -9px;
}

.check-ackn.hide-skill {
  max-width: 100px;
}

.skill-detaill-right .skill-subtitle,
.skill-detaill-right-full .skill-subtitle {
  margin-bottom: 5px;
}

.skill-one-row .check-ackn {
  align-items: center;
}

.publish-date-wrap .react-datepicker-wrapper {
  width: 100%;
}

.ownerdrodown {
  width: 100%;
  padding: 10px;
  background: #fff;
  box-shadow: 1px 14px 10px #e5e5e5;
  z-index: 1;
}

.owner-box .custom-dropdown .dropdown-button {
  background-color: #fff;
}

.skill-one-row {
  display: flex;
  width: 100%;
  min-height: 35px;
}

.skill-filter-field.w-select {
  padding: 5px;
}

/*********prompt page end************/

.dropchat-wrap {
  border: 1px solid #e5e5e5;
  margin: 0 20px 0 20px;
  background-color: #fff;
}

.multifile-wrap {
  display: flex;
  flex-wrap: wrap;
}

.chatprompt-form {
  padding-left: 0;
}

.pdf-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
}

.chat-file-dowbload {
  display: flex;
  width: 100%;
  padding-left: 30px;
  color: #0063ff;
  cursor: pointer;
}

.pdf-icon-list.chat-file-dowbload {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.img-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.excel-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.html-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.tiff-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.ppt-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.word-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block !important;
}

.chat-file-dowbload {
  display: flex;
  width: 100%;
  padding-left: 30px;
  color: #0063ff;
  cursor: pointer;
}

.absolute-icon {
  position: absolute;
  right: -34px;
  top: -5px;
  cursor: pointer;
}

.file-icon-list {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  background-size: 25px;
}

.upload-drag {
  display: flex;
  background: #fff;
  border: 1px solid #e5e5e5;
  padding: 10px;
  border-radius: 6px;
  gap: 10px;
  align-items: center;
  max-width: 270px;

  margin: 10px;
}

.upload-drag p {
  width: 214px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 12px;
}

/* Prompt Managment Card image Start */
.card-img {
  max-width: 30px;
  margin-bottom: 7px;
  width: 100%;
}

/* Prompt Managment Card image End */

/* Add Comment Modal in Prompt Management Start here */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  position: relative;
}

.send-icon {
  width: 20px;
}

.error-message {
  color: red;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.prompt-user-img {
  /* width: 100%; */
  max-width: 24px;
  height: 24px;
  min-width: 24px;
}

/* Add Comment Modal in Prompt Management End Here */
.flexible-icon {
  display: flex;
  align-items: center;
}

.flexible-icon img {
  cursor: pointer;
}

.edit-prompt-info .flex-row {
  gap: 10px;
}

.edit-prompt-info {
  margin-bottom: 10px;
}

/********modal css*************/

.modal-wrapper {
  position: fixed;
  left: 0%;
  top: 0%;
  right: 0%;
  bottom: 0%;
  z-index: 200;
  display: none;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.39);
  opacity: 0;
  font-family: Poppins, sans-serif;
}

.popup-btn-container {
  text-align: center;
  display: flex;
  gap: 10px;
}

.popup-btn-container-skill {
  text-align: right;
  gap: 10px;
}

.modal-header h2 {
  width: 100%;
  text-align: left;
}

.modal-popup-header h3 {
  width: 100%;
  text-align: left;
}

.modal-body {
  text-align: left;
}

.modal-block {
  display: flex;
  overflow: hidden;
  width: 80%;
  max-width: 500px;
  flex-direction: column;
  border-radius: 11px;
  background-color: #fff;
}

.modal-header label {
  font-weight: 700;
}

.modal-header h2 {
  margin: 0;
  font-size: 22px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 17px;
  padding-bottom: 11px;
}

.modal-popup-header h3 {
  margin: 0;
  font-size: 22px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 17px;
  padding-bottom: 11px;
  color: #ea384c;
}

.flex-block-modal {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 21px;
}

.modal-header p {
  font-size: 13px;
}

.flex-block-modal label {
  display: flex;
  gap: 10px;
}

.image-control .modal-content {
  min-height: 200px;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.crop-img-wrap {
  width: 100%;
}

.image-control .modal-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 20px;
}

.image-control .popup-btn-container {
  display: flex;
  gap: 20px;
}

.image-control img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.confirmation-content-wrapper {
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  line-height: 26px;
  font-weight: 400;
}

.confirmation-button-block {
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  /*    align-items: center;*/
  font-size: small;
  align-items: stretch;
}

.confirmation-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  background-color: #e7e8e9;
  color: #691c33;
  font-size: 16px;
  text-align: center;
}

.modal-body p {
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 26px;
}

.modal-wrapper.show-modal-wrapper {
  display: flex !important;
  opacity: 1 !important;
}

.popup-btn-container button {
  line-height: 16px;
  font-size: 13px;
}

.app-list .modal-content {
  padding: 0;
}

.app-list .modal-block {
  max-width: 350px;
}

.prompt-share-header {
  margin-bottom: 12px;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 14px;
}

.prompt-share-header h3 {
  margin: 0;
  width: 100%;
  text-align: left;
}

.prompt-share-header .search-cross-icon-common {
  width: 100%;
}

.app-list.prompt-share-modal .modal-block {
  max-width: 475px;
}

.chathead {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.result-tab-content {
  font-size: 13px;
  padding: 10px;
}

.input-tab-content {
  background-color: #e5e5e5;
  padding: 10px;
  margin: 8px;
}

.input-tab-content p {
  margin: 0;
  color: #7e7878;
  font-size: 12px;
}

.edit-prompt-info {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.semibold-text {
  font-weight: 500;
}

.action-btn-wrapper {
  display: flex;
  gap: 5px;
}

.private-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  width: 18px;
  height: 18px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.public-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  width: 18px;
  height: 18px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.star-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  width: 18px;
  height: 18px;
  background-size: 100%;
  background-repeat: no-repeat;
}

.edit-common-icons {
  display: flex;
  /* width: 100%; */
  border: 1px solid #cfd4d8;
  padding: 2px 11px;
  font-size: 12px;
  gap: 5px;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.prompt-test-heading h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.edit-prompt-buttons {
  display: flex;
  justify-content: flex-end;
}

.edit-col {
  display: flex;
  gap: 10px;
  font-size: 12px;
}

.prompt-badge {
  background: #e0effb;
  font-size: 11px;
  border-radius: 18px;
  padding: 2px 9px;
}

.white-space {
  white-space: nowrap;
}

div#container_mainContainer {
  min-height: 80vh !important;
}

@media (max-width: 1440px) {
  .prompt-step-desc {
    font-size: 10px;
  }
}

@media screen and (min-width: 1440px) {
  .dash-menu {
    width: 15%;
  }

  textarea.scrollinput {
    max-height: 14vh !important;
  }

  .pdfview.overlap {
    height: 92vh;
    max-height: 92vh;
  }

  .dash-body {
    flex: 1 1;
    width: 85%;
  }

  .app-right-col {
    width: 25%;
    min-width: 25%;
  }

  .app-links-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

@media (min-width: 1600px) {
  .pdfview.overlap {
    height: 93vh;
    max-height: 93vh;
  }
}

@media (min-width: 1800px) {
  .ai-collection-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .pdfview.overlap {
    height: 94vh;
    max-height: 94vh;
  }
}

@media screen and (min-width: 1920px) {
  .pdfview.overlap {
    height: 94vh;
    max-height: 94vh;
  }

  .dash-body {
    grid-column-gap: 20px;
    /* grid-row-gap: 20px; */
  }

  .menu-logo {
    width: 120px;
  }

  .left-menu-link {
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .menu-icon {
    width: 30px;
  }

  .h1 {
    font-size: 42px;
  }

  .paragraph {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  .paragraph.small {
    font-size: 0.8rem;
  }

  .chat-tablink {
    padding-top: 13px;
    padding-bottom: 13px;
    font-size: 14px;
  }

  .chat-button {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .chat-input-field {
    min-height: 50px;
  }

  .h2 {
    font-size: 22px;
    line-height: 40px;
  }

  .ai-collection-grid {
    grid-column-gap: 22px;
    grid-row-gap: 22px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .h3 {
    font-size: 20px;
    line-height: 39px;
  }

  .h3.small {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  .skill-keyword {
    font-size: 10px;
    line-height: 12px;
  }

  .button.text {
    font-size: 13px;
  }

  .dashboard-wrapper {
    padding-top: 20px;
    padding-left: 0;
    padding-right: 0;
  }

  .chat-box-wrapper {
    padding-top: 20px;
  }

  .chat-history {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
  }

  .chatbox {
    padding-left: 5%;
    padding-right: 5%;
  }

  .chat-msg {
    border-radius: 9px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .chat-msg.reply {
    align-items: flex-start;
  }

  .chat-user-icon {
    width: 50px;
    height: 50px;
  }

  .msg-text {
    grid-column-gap: 9px;
    grid-row-gap: 9px;
  }

  .chat-text {
    font-size: 13px;
  }

  .msg-time {
    font-size: 12px;
  }

  .expand-history-btn {
    background-size: 25px;
  }

  .h4 {
    font-size: 18px;
    line-height: 24px;
  }

  .icon-button {
    background-size: 17px;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    font-size: 13px;
  }

  .appdash-wrapper {
    padding-left: 65px;
    padding-right: 65px;
  }

  .task-label {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .app-left-col {
    padding-left: 5%;
    padding-right: 5%;
  }

  .app-links-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 991px) {
  .appdash-wrapper {
    margin-top: 0;
  }

  .accordian-body {
    display: none;
  }

  .my-workspace-wrapper {
    flex-flow: column-reverse;
  }

  .app-right-col {
    z-index: 999;
    width: 100%;
  }

  .app-links-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

@media (max-width: 1080px) {
  .left-menu-link {
    padding: 4px;
  }
}

/* Skill Library Filter Multi Check Box */
.custom-dropdown {
  position: relative;
  display: inline-block;
  min-width: 250px;
}

.custom-dropdown.max-dropdown {
  min-width: 260px;
}

.dropdown-button {
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
}

.dropdown-menu-custom {
  display: none;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  list-style: none;
  padding: 10px;
  z-index: 1000;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
}

/* .prompt-step-two .dropdown-menu-custom{
bottom: 30px;
} */
.prompt-step-two .dropdown-menu-custom {
  max-height: 150px;
  overflow-y: auto;
}

.custom-dropdown:hover .dropdown-menu-custom {
  display: block;
}

.dropdown-menu-custom li {
  margin: 5px 0;
}

input::file-selector-button {
  background-image: linear-gradient(to right,
      #0062ff,
      #0062ff,
      #0062ff 100%,
      #0062ff 200%);
  background-position-x: 0%;
  background-size: 200%;
  border: 0;
  border-radius: 8px;
  color: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

input::file-selector-button:hover {
  background-color: #0d4eb7;
}

.prompt-box {
  display: flex;
  flex-flow: column;
  /* align-items: end; */
  justify-content: space-between;
}

.feedbackmodal {
  position: relative;
}

.feedbackmodal .cross-icon {
  position: absolute;
  right: 5px;
  top: 7px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  width: 18px;
  height: 18px;
  background-size: 18px;
  background-repeat: no-repeat;
  cursor: pointer;
}

.light-theme .feedbackmodal .cross-icon {
  filter: invert(1);
}

/* The container */
.check-contain {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.check-contain input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark-check {
  position: absolute;
  top: 4px;
  left: 0;
  height: 21px;
  width: 21px;

  background-color: #ffffff;
  border: 1px solid #ddd;
}

/* On mouse-over, add a grey background color */
.check-contain:hover input~.checkmark-check {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.check-contain input:checked~.checkmark-check {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark-check:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check-contain input:checked~.checkmark-check:after {
  display: block;
}

/* Style the checkmark/indicator */
.check-contain .checkmark-check:after {
  left: 7px;
  top: 1px;
  width: 7px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.chat-event-btn-wrapper.dropchat {
  inset: auto auto 210px;
}

/* The container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  user-select: none;
  font-weight: 500;
}

/* Hide the browser's default radio button */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.custom-check {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.custom-check {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.checkbox-container input:checked~.custom-check {
  background-color: #2196f3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.custom-check:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.checkbox-container input:checked~.custom-check:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.checkbox-container .custom-check:after {
  top: 7px;
  left: 7px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.allcheck {
  width: 19px;
  height: 18px;
}

.applist-row .checkmark-check {
  top: -2px;
  width: 19px;
  height: 19px;
  border: 1px solid #e5e5e5;
}

.view-btn {
  background: #3a83ff;
  color: #fff;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 5px;
}

.check-contain .checkmark-check:after {
  left: 6px;
  top: 0px;
  width: 6px;
  height: 13px;
}

.toggle-menu-mobile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  width: 40px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.toggle-menu-desk {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  position: absolute;
  right: -20px;
  background-color: #7fb0ff;
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

input[disabled] {
  cursor: not-allowed !important;
}

.toggle-menu-desk:hover {
  background-color: #5c8cdb;
}

.dark-theme .toggle-menu-mobile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  background-repeat: no-repeat;
}

.paragraph.small.mb0 {
  margin-bottom: 0;
}

.checklist-row .checkmark-check {
  top: 0;
  height: 17px;
  width: 17px;
}

.checklist-row .check-contain {
  padding-left: 30px;
  margin-bottom: 7px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  user-select: none;
  font-weight: 500;
}

.checklist-row .check-contain .checkmark-check:after {
  left: 5px;
  top: 0px;
  width: 6px;
  height: 12px;
}

textarea.scrollinput {
  overflow-y: auto;
  resize: none;
  margin: 0 10px;
  width: 100%;
  padding: 10px 5px;
  font-size: 12px;
  height: 40px;
  max-height: 12vh;
}

.dark-theme .ownerdrodown .applist-row .app-name-label {
  color: #00567d;
}

.linklists {
  padding-left: 10px;
  list-style: decimal;
}

.attach-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  width: 24px;
  height: 40px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

/********* toggle button *******/
.switch {
  position: relative;
  display: inline-block;
  width: 53px;
  height: 25px;
  margin-bottom: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switchrow {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  font-size: 15px;
  margin-top: 15px;
}

.switchrow.disable {
  cursor: not-allowed;
}

.switch.toggle-button-additives {
  pointer-events: none;
}

.chart-text-display {
  text-align: center;
  margin-top: 10px;
  color: #7fb0ff;
}

.slider.round.disable {
  cursor: not-allowed;
}

.new-check-row .check-contain {
  font-size: 15px;
}

.checklist-row.disable {
  cursor: not-allowed;
}

.check-contain.disable {
  pointer-events: none;
  opacity: 0.6;
}

.disable .checkmark-check {
  cursor: not-allowed;
}

.flex-content {
  display: flex;
  gap: 10px;
}

.left-info-section {
  display: flex;
  flex-flow: column;
  gap: 10px;
}

.notif-right-section {
  width: 60%;
}

.user-set {
  display: flex;
  justify-content: space-between;
}

.user-dec-info {
  background: #f8f8f8;
  padding: 20px;
  display: flex;
  flex-flow: column;
  gap: 8px;
}

.prompt-desc-style {
  font-size: 12px;
}

.prompt-desc-style h3 {
  margin: 0;
  padding: 0;
  line-height: normal;
}

.more-details {
  margin-top: 12px;
}

.user-prompt-desc {
  display: flex;
  flex-flow: column;
  gap: 5px;
}

.left-info-section {
  width: 40%;
  max-height: calc(100vh - 163px);
  overflow-y: auto;
}

.user-breif {
  display: flex;
  gap: 10px;
  border: 1px solid #e5e5e5;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

.clear-chatbtn {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-right: 10px;
  position: absolute;
  right: 53px;
  top: 7px;
}

.show-followup-btn {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  position: absolute;
  right: 39px;
  top: 7px;
}

.follow-up-icon-blur {
  opacity: 0.5;
}

.suggest-line-wrapper {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.suggest-line {
  background: #053a64;
  border-radius: 10px;
  padding: 1px 14px;
  color: #fff;
  cursor: pointer;
}

.suggest-line-disabled {
  background: #dee5ea;
  border-radius: 10px;
  padding: 1px 14px;
  color: #fff;
  cursor: pointer;
}

.follow-up-section {
  border-top: 1px solid #e5e5e5;
  width: 100%;
  padding: 6px 0;
  margin-top: 9px;
}

.follow-up-section {
  border-top: 1px solid #e5e5e5;
  width: 100%;
  padding: 6px 0;
  margin-top: 9px;
}

.clear-chatbtn.disabled-div .trash-icon {
  cursor: not-allowed;
}

.trash-icon:hover::after {
  content: attr(data-title);
  position: absolute;
  right: 24px;
  color: #000;
  font-size: 10px;
  line-height: 13px;
  background: #f6f6f6;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
  width: 74px;
}

.follow-up-icon:hover::after {
  content: attr(data-follow);
  position: absolute;
  right: 24px;
  color: #000;
  font-size: 10px;
  line-height: 13px;
  background: #f6f6f6;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
  width: 74px;
}

.copy-clipboard:hover::after {
  content: attr(data-title);
  position: absolute;
  left: 23px;
  top: 0;
  color: #000;
  font-size: 10px;
  line-height: 13px;
  background: #f6f6f6;
  padding: 3px 9px;
  border-radius: 5px;
  z-index: 2;
  width: 52px;
}

.copy-clipboard:hover::before {
  content: "";
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid #f6f6f6;
  left: 17px;
  position: absolute;
  top: 4px;
}

.dark-theme .copy-clipboard:hover::after {
  background: transparent;
  border: 1px solid;
  color: #fff;
}

.dark-theme .copy-clipboard:hover::before {
  display: none;
}

.pagination-container .paginate-link {
  background-color: transparent !important;
}

.excel-box-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  margin-top: 10px;
  border: 1px solid #e5e5e5;

  border-radius: 0 0 10px 10px;
  padding-bottom: 10px;
}

.flex-col {
  width: 100%;
  margin-right: 74px;
}

.w-80 {
  width: 80%;
}

.heading-gray {
  padding: 6px 10px;
  background: #e5e5e5;
}

.dark-theme .heading-gray {
  color: #000;
}

.dark-theme .excel-box-wrapper .close-icon {
  filter: brightness(20);
}

.desc-row {
  padding: 5px 10px;
  align-items: flex-start;
  border-bottom: 1px solid #e5e5e5;
  display: grid;
  grid-template-columns: 20% 54% 20% 40px;
}

.visibilty-hidden {
  visibility: hidden;
}

.trash-icon:hover::before {
  content: "";
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #f6f6f6;
  right: 19px;
  position: absolute;
  top: 4px;
}

.follow-up-icon:hover::before {
  content: "";
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #f6f6f6;
  right: 19px;
  position: absolute;
  top: 4px;
}

.dark-theme .trash-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  background-size: cover;
  background-repeat: no-repeat;
}

.dark-theme .follow-up-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  background-size: cover;
  background-repeat: no-repeat;
}

.trash-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
}

.follow-up-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
}

.msg-text p {
  margin-bottom: 0;
}

/********dark theme*****/
.dark-theme .skill-icon-block .ai-block-icon {
  filter: brightness(45.5);
}

/* .dark-theme .prompt-action-count {
  color: #fff;
} */

.dark-theme .msg-text {
  color: #000;
}

.dark-theme .applist-view .app-logo-icon img {
  background-color: #fff;
}

.dark-theme .private-icon {
  filter: brightness(11.5);
}

.dark-theme .public-icon {
  filter: brightness(11.5);
}

.dark-theme .chat-right {
  color: #000;
}

.dark-theme .upload-drag p {
  color: #000;
}

.dark-theme .dash-menu.open .menu-logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  width: 32px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.dark-theme .chat-history-sec,
.dark-theme .checkbox-list.show {
  box-shadow: 2px 2px 10px #000000;
}

.dark-theme .version-link .col-text {
  background-color: #6f94bb;
}

.dark-theme .version-link .col-text:hover {
  background-color: #005488;
}

.dark-theme .check-class {
  accent-color: #6f94bb;
}

button[disabled] {
  cursor: not-allowed;
}

.dark-theme .allcheck {
  accent-color: #6f94bb;
}

.dark-theme .prompt-user-img {
  background-color: #80ce1a;
}

.dark-theme .dash-body {
  background-color: #053a64;
  color: #fff;
}

.dark-theme .suggestion-item {
  color: #000;
  padding: 3px;
  border-bottom: 1px solid #f3f3f3;
  font-size: 11px;
}

.suggestion-item-heading {
  color: #000;
  padding: 3px;
  border-bottom: 1px solid #f3f3f3;
  font-size: 14px;
}

.suggestion-item.selected {
  background-color: #d3d3d3;
  /* Highlight color */
}

.dark-theme .workspace-dashboard {
  background-color: #ffffff;
}

.dark-theme .left-menu-link {
  color: #053a64;
}

.dark-theme .menu-icon {
  filter: invert(1);
}

.dark-theme .dash-header h1 {
  color: #fff;
}

.dark-theme .paragraph {
  color: #fff;
}

.dark-theme .flexbox {
  background-color: #053a64;
}

.dark-theme .menu-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  background-position: 0%;
  background-repeat: no-repeat;
  background-size: contain;
}

.dark-theme .skill-detail-left {
  background-color: transparent;
}

.dark-theme .upperchartbox {
  box-shadow: 2px 2px 10px #000000;
  color: #000;
}

.dark-theme .upperchartbox .prompt-tabs-link.w--current {
  border-bottom-color: #053a64;
  color: #053a64;
}

.dark-theme .left-menu-link:hover {
  background-color: #053a64;
  color: #fff;
}

.dark-theme .left-menu-link:hover .menu-icon {
  filter: invert(0);
}

.dark-theme .contact-detail {
  color: #000;
}

.dark-theme .infotext {
  color: #000;
}

.dark-theme .skill-detaill-right h3 {
  color: #000;
}

.dark-theme .skill-detaill-right-full h3 {
  color: #000;
}

.dark-theme .skill-subtitle-info {
  color: #000;
}

.skill-tags h3 {
  color: #000;
}

.dark-theme .button.light {
  color: #fff;
}

.dark-theme .dash-section {
  background-color: transparent;
}

.dark-theme .ai-collection-link-block {
  box-shadow: none;
}

.dark-theme .ai-collection-link-block:hover {
  box-shadow: 2px 2px 30px #373737;
}

.selected-Video-hover {
  box-shadow: 2px 2px 30px #999898;
}

.input-search-videos {
  margin-bottom: 5px;
}

.light-grey {
  background-color: #ebebeb;
  padding: 22px;
  border-radius: 5px;
  justify-content: center;
  gap: 0;
}

.dark-theme .h2 {
  color: #fff;
}

popup-heading {
  color: #ea384c;
}

.dark-theme .button.text:hover {
  background-color: #fff;
}

.dark-theme .app-group-heading {
  color: #fff;
}

.dark-theme .custom-application img {
  filter: invert(0);
}

.dark-theme .draggable-button {
  filter: invert(1);
}

.dark-theme .prompt-tabs-link.w--current {
  border-bottom-color: #fff;
  color: #fff;
}

.dark-theme .skill-filter-wrapper {
  background-color: transparent;
  border: 0;
}

.dark-theme .edit-button-icon {
  filter: brightness(63.5);
}

.dark-theme .trash-button-icon a {
  color: #fff;
}

.dark-theme .trash-button-icon .trash-icon::before {
  display: none;
}

.dark-theme .prompt-tabs .ai-collection-grid.light-bg {
  background: transparent;
  padding: 0;
}

.dark-theme .prompts-tabs-content .skill-filter-wrapper {
  padding: 17px 0;
}

.dark-theme .prompt-steps {
  background-color: transparent;
}

.dark-theme .preference-wrapper {
  background-color: transparent;
  padding: 0;
}

.dark-theme .breadcrumb .normal-link {
  color: #fff;
}

.dark-theme .normal-link::after,
.dark-theme .home-link::after {
  opacity: 1;
  filter: invert(1);
}

.dark-theme .normal-link.long-title:hover::after {
  filter: invert(0);
}

.dark-theme .prompt-pii {
  color: #000;
}

.dark-theme select,
.dark-theme input,
.dark-theme textarea {
  color: #000;
}

.dark-theme .ai-collection-info-block .paragraph.small {
  color: #000;
}

.dark-theme .prompt-gen .selected-tag {
  background: #818181;
}

.dark-theme .modal-content {
  background-color: #053a64;
}

.dark-theme .confirmation-content-wrapper {
  background-color: #053a64;
}

.dark-theme .p-tag {
  background: #6f94bb;
  gap: 5px;
}

.dark-theme .close-icon {
  filter: brightness(0.1);
  width: 12px;
  height: 12px;
}

.dark-theme .backbtn {
  border-radius: 29px;
}

.dark-theme .user-profile-menu {
  border: 0;
}

.dark-theme .chatprompt-form {
  padding: 0;
}

.dark-theme .chatprompt-field-label {
  background: #6f94bb;
  cursor: pointer;
}

.dark-theme .chatprompt-field-label:hover {
  background-color: #005488;
}

.dark-theme .sample-prompts {
  background-color: #fff;
}

.dark-theme .feedbacktext {
  background-color: #092f4d;
}

.chat-button:hover {
  background-color: #20457f;
}

input[disabled].chat-button:hover {
  background-color: #0062ff;
}

.dark-theme input.chat-button.w-button {
  color: #fff;
}

.dark-theme .edit-prompt-header .prompt-action-count {
  color: #fff;
}

.dark-theme input.chat-button.w-button:hover {
  background-color: #37618c;
}

.dark-theme input[disabled].chat-button.w-button:hover {
  background-color: #6f94bb;
}

.dark-theme .feedback-right-section {
  background: #86919b;
}

.dark-theme .copy-clipboard {
  filter: brightness(62.5);
}

.dark-theme .dash-section.p20 {
  padding: 0;
}

.dark-theme .applist-row .app-name-label {
  color: #fff;
  font-weight: 500;
}

.dark-theme .left-menu-link.w--current {
  background-color: #053a64;
  color: #fff;
}

.dark-theme .left-menu-link.w--current .menu-icon {
  filter: invert(0);
}

.dark-theme .chat-tablink {
  color: #dddddd;
}

.dark-theme .dash-header h1 span {
  color: #80ce1a;
}

.dark-theme .chat-tablink.w--current {
  background-color: #ffffff;
  color: #6f94bb;
}

.dark-theme .chat-button {
  background-color: #6f94bb;
}

.dark-theme .button {
  background-color: #6f94bb;
}

.dark-theme .button:hover,
.dark-theme .icon-button.add:hover {
  background-color: #005488;
}

.dark-theme .skill-keyword {
  background-color: #6f94bb;
  color: #fff;
}

.dark-theme .button.text {
  background: transparent;
  color: #6f94bb;
}

.dark-theme .read-more-text {
  color: #6f94bb;
}

.dark-theme .icon-button {
  background-color: #6f94bb;
}

.dark-theme .p-done .p-dot {
  background-color: #6f94bb;
}

.dark-theme .p-done::after {
  background-color: #6f94bb;
}

.dark-theme .p-current .p-dot {
  border: 1px solid #6f94bb;
}

.dark-theme .breadcrumb a.visited:hover {
  color: #6f94bb;
}

.dark-theme .home-link::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}

.dark-theme .check-contain input:checked~.checkmark-check {
  background-color: #6f94bb;
}

.dark-theme .chatprompt-button {
  background-color: #6f94bb;
}

.dark-theme .terminal-button {
  background-color: transparent;
}

.dark-theme .terminal-button.w--current {
  background-color: #fff;
  color: #6f94bb;
}

.dark-theme .chat-event-button {
  background-color: #6f94bb;
  color: #fff;
}

.dark-theme .like-icon {
  filter: brightness(56.5);
}

.dark-theme .chat-event-button:hover {
  background-color: #005488;
}

.dark-theme .chatprompt-button:hover {
  background-color: #005488;
}

.dark-theme .div-table-header {
  background-color: #6f94bb;
}

.dark-theme .upperchartbox .skill-filter-wrapper {
  padding: 17px 20px;
}

.dark-theme .checkbox-container input:checked~.custom-check {
  background-color: #6f94bb;
}

.dark-theme input::file-selector-button {
  background-image: linear-gradient(to right,
      #6f94bb,
      #6f94bb,
      #6f94bb 100%,
      #6f94bb 200%);
  background-position-x: 0%;
  background-size: 200%;
  border: 0;
  border-radius: 8px;
  color: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

.dark-theme input[type="file"] {
  color: #fff;
}

.dark-theme input::file-selector-button:hover {
  background-color: #74bd15;
}

.dark-theme .prompt-creator-block {
  color: #000;
}

.dark-theme .coment-section {
  background: #053a64;
}

.dark-theme .light-coment-bg {
  color: #000;
}

.dark-theme .coment-section .close-icon {
  filter: invert(1);
}

.dark-theme .submit-btn {
  background: #6f94bb;
}

.mb-10 {
  margin-bottom: 10px;
}

.chat-text .linkclass.mb-10:nth-child(1) {
  margin-top: 10px;
}

.dark-theme .user-dec-info {
  color: #000;
}

.dark-theme .pagination-container .pagination-wrapper {
  color: #fff;
}

.dark-theme .pagination-container .padding-right-5,
.dark-theme .pagination-container .paginate-highlight {
  color: #fff;
}

.dark-theme .user-table-list .pagination-container .pagination-wrapper {
  color: #000;
}

.dark-theme .user-table-list .pagination-container .padding-right-5,
.dark-theme .user-table-list .pagination-container .paginate-highlight {
  color: #000;
}

.dark-theme .pagination-container .no-border {
  filter: invert(1);
  color: #000;
}

.dark-theme .user-table-list .pagination-container .no-border {
  filter: invert(0);
  color: #000;
}

.dark-theme .user-table-list .pagination-container .paginate-link {
  filter: invert(0);
}

.dark-theme .user-breif {
  background-color: #fff;
  color: #474444;
}

.dark-theme .unread-notif {
  background: #f7f7f7;
  color: #0092ff;
}

.dark-theme .user-breif.selected {
  border: 3px solid #80ce1a;
}

.dark-theme .prompt-badge {
  color: #000;
}

.dark-theme .edit-common-icons .private-icon,
.dark-theme .edit-common-icons .thumbs-up-icon,
.dark-theme .edit-common-icons .views-icon,
.dark-theme .edit-common-icons .share-icon,
.dark-theme .edit-common-icons .comment-icon {
  filter: brightness(7.5);
}

.dark-theme input[disabled].prompt-text {
  color: #fff;
}

.dark-theme .medium-font {
  color: #fff;
}

.dark-theme .pagination-container .paginate-link {
  background-color: transparent;
  filter: invert(1);
}

.dark-theme .pdf-full-expand .prompt-tabs-link.w--current {
  border-bottom-color: #053a64;
  color: #053a64;
}

.dropdown-with-button.disabled-parent {
  cursor: not-allowed;
}

.dropdown-with-button.disabled-parent .genrate-btn {
  pointer-events: none;
  opacity: 0.5;
}

.not-clickable {
  cursor: not-allowed;
}

.custom-dropdown.disabled-parent,
select.skill-filter-field.w-select.disabled-element {
  pointer-events: none;
  background-color: #f2f2f2;
}

.dropdown-button.disabled-element {
  background-color: #f2f2f2;
}

.applist-row.border-line {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 9px;
}

.instruction-lines {
  padding: 0 0 0 14px;
  margin: 0;
}

.line-height-normal {
  line-height: 12px;
}

.mobile-absolute-icon .close-icon {
  margin-top: 10px;
  width: 18px;
}

.font-semibold {
  font-weight: 600;
}

@media screen and (max-width: 767px) {

  .chart-div-display,
  .chart-row-view {
    flex-direction: column;
  }

  .chart-button-display {
    padding: 6px 11px;
    font-size: 12px;
  }

  .chart-display-width {
    width: 100%;
  }

  .user-role-row {
    grid-template-columns: 1fr;
    position: relative;
    gap: 0;
    border: 1px solid #ccc;
  }

  .add-user-modal .modal-content {
    width: 90%;
  }

  div#container_mainContainer {
    min-height: 68vh !important;
  }

  .suggestions.prompt-suggestions {
    width: 100%;
  }

  .dash-menu .dropdown-label .down-arrow {
    filter: invert(1);
  }

  .top-bar {
    flex-flow: column-reverse;
    gap: 10px;
    align-items: flex-end;
  }

  .top-bar .search-cross-icon-common {
    max-width: 100%;
  }

  .modal-header h2 {
    word-break: break-word;
  }

  .modal-popup-header h3 {
    word-break: break-word;
  }

  .height-100 {
    min-height: calc(100vh - 100px);
  }

  /* a.visited.normal-link {
    width: 280px;
  } */
  .chat-event-button.stop-generate.w-button {
    padding-left: 37px;
  }

  .cancel-btn {
    margin-bottom: 2px;
  }

  .copy-clipboard:hover::after {
    left: 19px;
    padding: 3px 4px;
  }

  .trash-icon {
    top: -49px;
    z-index: 1;
  }

  .trash-button-icon .trash-icon {
    top: 0px;
  }

  .trash-button-icon .trash-icon::after {
    display: none;
  }

  .medium-font {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
  }

  .chat-box-wrapper .w-button {
    padding: 7px 15px;
  }

  .description-rows {
    gap: 10px;
  }

  .desc-row {
    grid-template-columns: 1fr;
    border: 1px solid #e5e5e5;
    position: relative;
  }

  .excel-title::before {
    content: "Title : ";
    font-weight: 600;
  }

  .user-role-row .excel-title::before {
    content: "User Name : ";
    font-weight: 600;
  }

  .excel-title {
    padding-right: 40px;
  }

  .excel-skill::before {
    content: "Skill : ";
    font-weight: 600;
  }

  .excel-dec::before {
    content: "Description : ";
    font-weight: 600;
  }

  .user-role-row .excel-dec::before {
    content: "Role Type : ";
    font-weight: 600;
  }

  .mobile-absolute-icon {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .excel-box-wrapper {
    border: 0;
  }

  .desc-row.heading-gray {
    display: none;
  }

  .skill-info-wrapper {
    left: 0;
  }

  .ai-block-header .h3.small {
    max-width: 195px;
  }

  .dash-menu.hide-on-mobile {
    display: none;
  }

  textarea.chat-input-field.w-input.home-chat-field.scrollinput {
    padding: 2px 5px 6px 5px;
  }

  .prompt-share-header h3 {
    font-size: 18px;
  }

  textarea.scrollinput {
    padding: 2px 6px;
    margin: 0;
  }

  .tabs-menu.h-flex.head-wrapper.w-tab-menu.test-tab {
    display: flex;
    justify-content: flex-start;
  }

  .custom-dropdown {
    width: 100%;
    min-width: auto;
  }

  .prompt-icon span {
    display: none;
  }

  .chatprompt-field-label {
    width: auto;
  }

  .auto-chat-row {
    display: none;
  }

  .chat-table-lis-row {
    grid-template-columns: 1fr;
    gap: 5px;
  }

  .chem-addit::before {
    content: "Chemical Additives :";
    margin-right: 10px;
    font-weight: 600;
  }

  .count-name::before {
    content: "Count :";
    margin-right: 10px;
    font-weight: 600;
  }

  .type-name::before {
    content: "Type :";
    margin-right: 10px;
    font-weight: 600;
  }

  .compound-name::before {
    content: "Compound :";
    margin-right: 10px;
    font-weight: 600;
  }

  .original-name::before {
    content: "Chemical Additives in Original Language :";
    margin-right: 10px;
    font-weight: 600;
  }

  .percent-name::before {
    content: "Occurrence in Percentage :";
    margin-right: 10px;
    font-weight: 600;
  }

  .patent-name::before {
    content: "Patent Numbers :";
    margin-right: 10px;
    font-weight: 600;
  }

  .pagination-custom {
    justify-content: center;
  }

  .absolute-icon {
    top: -6px;
  }

  .pagination-container .pagination-block {
    padding: 0 !important;
    gap: 2px;
  }

  .pagination-container .pagination-wrapper {
    font-size: 10px !important;
    gap: 2px;
  }

  .pagination-container .paginate-link.next-page,
  .pagination-container .paginate-link.last-page,
  .pagination-container .paginate-link.previous-page,
  .pagination-container .paginate-link {
    width: 11px !important;
  }

  .clear-chatbtn {
    right: 0;
    top: 56px;
  }

  .chattab-wrap {
    display: flex;
    justify-content: flex-start !important;
  }

  .user-set {
    flex-flow: column;
  }

  .user-time-detail {
    font-size: 12px;
  }

  .left-info-section.mobile-hide {
    display: none;
  }

  .notif-right-section {
    width: 100%;
  }

  .notif-right-section.hide-mobile {
    display: none;
  }

  .gridlisticon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
    width: 23px;
    height: 23px;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .dark-theme .gridlisticon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .left-info-section {
    width: 100%;
    max-height: calc(100vh - 205px);
  }

  .flex-content {
    flex-flow: column;
  }

  .loader-text.login-text-loader {
    background: transparent;
    color: #00558a;
  }

  .dropbox-wrapper-main {
    padding: 6px 10px;
  }

  .import-prompt-box {
    padding: 20px 20px 0 20px;
    font-size: 12px;
  }

  .dropbox-wrapper-main {
    padding-bottom: 46px;
  }

  .hide-on-mobile {
    display: none;
  }

  .breadcrumb .normal-link {
    font-size: 11px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .breadcrumb a.visited {
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pdfview.overlap {
    width: 85%;
    height: 70vh;
    max-height: 70vh;
    bottom: 41px;
    top: 0;

    right: 14px;
  }

  .pdf-full-expand {
    width: 89%;
    top: auto;
    bottom: 44px;
    right: 5px;
    height: calc(100vh - 136px);
  }

  .pdf-full-expand.hide {
    height: auto;
  }

  .inner-tab-content {
    max-height: calc(100vh - 251px);
  }

  .pdf-full-expand.hide .pdf-expand {
    top: 0;
    right: 34%;
    height: 25px;
    background-color: transparent;
  }

  .modal-content.comment-modal {
    width: 93%;
  }

  .feedabck-wrapper {
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
  }

  .prompts-tabs-content .search-cross-icon-common {
    width: 100%;
  }

  .modal-header {
    width: 100%;
    word-break: break-all;
    overflow: hidden;
  }

  .popup-btn-container {
    flex-flow: column;
  }



  .image-control .popup-btn-container {
    flex-direction: column;
  }

  .btn-add-promt {
    width: 100px;
  }

  .dark-theme .left-menu-link {
    color: #fff;
  }

  .dark-theme .menu-icon {
    filter: invert(0);
  }

  .skill-full-wrap {
    padding: 10px;
  }

  .chat-msg {
    padding: 0;
  }

  .prompt-steps {
    padding: 0;
  }

  .left-menu-link {
    padding: 6px;
  }

  .dash-body {
    width: 100%;
  }

  .workspace-dashboard {
    flex-direction: column;
    padding: 10px;
  }

  .dash-menu.open {
    display: none;
  }

  .toggle-areas {
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    display: flex;
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
  }

  .checkbox-list.show {
    width: 100%;
  }

  .chat-right {
    position: absolute;
    bottom: 0px;
    background: #fff;
    width: 100%;
    height: auto;
    top: auto;
  }

  .chat-box-wrapper {
    position: relative;
  }

  .chat-history-sec.show {
    width: 100%;
  }

  .dash-menu {
    width: 67%;
    display: flex;
    background-image: linear-gradient(#041f35f5, #041f35f5),
      url(${___CSS_LOADER_URL_REPLACEMENT_101___});
    background-position: 0 0, 50%;
    position: absolute;
    left: 9px;
    margin: 0 auto;
    top: 61px;
    z-index: 3;
    height: calc(100vh - 68px);
  }

  .dash-page-header.light-bg {
    padding: 15px 20px;
  }

  .prompt-selects {
    flex-direction: column;
  }

  .section-wrapper {
    padding: 20px;
  }

  .ai-collection-grid {
    grid-template-columns: 1fr;
  }

  .dash-section.p20 {
    padding: 12px;
  }

  .left-menu-header {
    display: none;
  }

  .mobile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .my-workspace-wrapper {
    flex-flow: column-reverse;
  }

  .upperchartbox {
    margin-left: 0;
    max-height: 33vh;
    overflow: auto;
    width: 89%;
    margin-left: 20px;
  }

  .div-table-row {
    grid-template-columns: 1fr 1fr 1fr;
    word-break: break-all;
  }

  .dropchat-wrap {
    margin: 0 20px 0 0px;
  }

  .custom-div-table {
    overflow: visible;
  }

  .welcome-wrapper {
    padding: 15px 9px;
  }

  .app-right-col {
    width: 100%;
  }

  .h-flex.head-wrapper.input-workspace {
    position: relative;
    padding-left: 0;
    width: 100%;
  }

  .app-group-heading {
    line-height: normal;
    padding-bottom: 10px;
  }

  .app-link-tile {
    height: 100%;
  }

  .chat-terminal-wrapper {
    flex-flow: column;
    overflow: auto;
    min-height: calc(88vh - 89px);
    max-height: calc(88vh - 89px);
  }

  .chatbox {
    padding: 0 10px 5px 10px;
    max-height: calc(70vh - 55px);
    overflow: auto;
  }

  .skill-filter-form {
    display: grid;
  }

  .chatprompt-block {
    padding: 35px 0 0 20px;
  }

  .skill-filter-wrapper {
    padding: 20px;
  }

  .chat-tab-menu.w-tab-menu {
    display: flex;
    width: 100%;
  }

  .chat-tablink {
    padding: 6px 15px;
    width: 100%;
    text-align: center;
  }

  .view-link-block {
    justify-content: space-between;
    align-items: center;
  }

  .app-links-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .w-nav-brand {
    padding-left: 10px;
  }

  .w-nav[data-collapse="small"] .w-nav-menu {
    display: none;
  }

  .w-nav[data-collapse="small"] .w-nav-button {
    display: block;
  }

  .w-nav-brand {
    padding-left: 10px;
  }

  .dark-theme .login-form-logo {
    margin-left: 0px;
  }

  .prompt-step-desc {
    display: none;
  }

  .prompt-step-name {
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    height: 33px;
    max-height: 27px;
  }

  .prompt-img-title {
    flex-direction: column;
  }

  .prompt-explanaion {
    grid-template-columns: 100%;
  }

  .prompt-step-two .prompt-explanaion {
    grid-template-columns: 100%;
  }

  .prompt-button-wrapper {
    flex-direction: column-reverse;
    text-align: center;
    gap: 10px;
  }

  .prompt-review-wrap {
    flex-direction: column;
    grid-template-columns: 1fr;
  }

  .genrate-btn {
    padding: 10px 13px;
  }

  .workspace-dashboard.flex-end {
    flex-direction: column;
    padding-left: 10px;
  }

  .left-user-settings.hide-on-mobile {
    display: none;
  }

  .dash-header {
    padding: 11px 20px;
  }

  .dash-header h1 {
    font-size: 18px;
    line-height: 27px;
  }

  .dash-header .paragraph {
    font-size: 9px;
    line-height: 12px;
  }

  .skill-detail-wrapper {
    flex-direction: column;
    padding: 10px;
  }

  .skill-detail-left {
    width: 100%;
  }

  .create-skill-left {
    padding: 0 7px;
  }

  .description-wrap {
    flex-flow: column;
  }

  .skill-fullwidth {
    padding: 0 10px;
    margin-bottom: 10px;
  }

  .max-width-row {
    width: 100%;
    flex-flow: column;
    max-width: 100%;
  }

  .skill-detaill-right {
    width: 100%;
  }

  .skill-detaill-right-full {
    width: 100%;
  }

  .skill-one-row {
    flex-flow: column;
    gap: 10px;
    margin-bottom: 15px;
    min-height: auto;
  }

  .skill-heading h2 {
    font-size: 16px;
    line-height: 22px;
  }

  .skill-block-header {
    gap: 10px;
  }

  .skill-flex-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .skill-update-box {
    flex-direction: column;
  }

  .login-form-logo {
    width: 100%;
    height: 41%;
  }

  .skill-contact-person {
    flex-direction: column;
  }

  .breadcrumb {
    padding: 20px 16px 0;
    flex-wrap: nowrap;
  }

  .login-form-wrapper {
    width: 100%;
    border-radius: 0 0 20px 20px;
    justify-content: flex-start;
  }

  .login-logo-img {
    margin-top: 50px;
  }

  .login-bg-video {
    border-radius: 20px 20px 0 0;
  }

  .login-logo {
    width: 120px;
    height: 120px;
  }

  .w-hidden-main,
  .w-hidden-medium {
    display: inherit !important;
  }

  .w-hidden-small {
    display: none !important;
  }

  .w-row,
  .w-container .w-row {
    margin-left: 0;
    margin-right: 0;
  }

  .w-col {
    width: 100%;
    left: auto;
    right: auto;
  }

  .w-col-small-1 {
    width: 8.33333%;
  }

  .w-col-small-2 {
    width: 16.6667%;
  }

  .w-col-small-3 {
    width: 25%;
  }

  .w-col-small-4 {
    width: 33.3333%;
  }

  .w-col-small-5 {
    width: 41.6667%;
  }

  .w-col-small-6 {
    width: 50%;
  }

  .w-col-small-7 {
    width: 58.3333%;
  }

  .w-col-small-8 {
    width: 66.6667%;
  }

  .w-col-small-9 {
    width: 75%;
  }

  .w-col-small-10 {
    width: 83.3333%;
  }

  .w-col-small-11 {
    width: 91.6667%;
  }

  .w-col-small-12 {
    width: 100%;
  }
}

@media screen and (max-width: 479px) {
  .w-container {
    max-width: none;
  }

  .edit-prompt-info .flex-row {
    flex-wrap: wrap;
    justify-content: flex-start;
    column-gap: 8px;
    row-gap: 5px;
  }

  .verticleline {
    display: none;
  }

  .button-use-promp {
    margin-bottom: 17px;
    margin-top: 11px;
    margin-left: auto;
  }

  .edit-common-icons {
    padding: 2px 6px;
  }

  .edit-prompt-info {
    flex-direction: column;
    align-items: flex-end;
    gap: 0;
    margin-bottom: 0;
  }

  .dropdown-with-button {
    flex-flow: column;
  }

  .dropdown-with-button .prompt-title-wrap {
    width: 100%;
  }

  .w-hidden-main,
  .w-hidden-medium,
  .w-hidden-small {
    display: inherit !important;
  }

  .w-hidden-tiny {
    display: none !important;
  }

  .w-col {
    width: 100%;
  }

  .w-col-tiny-1 {
    width: 8.33333%;
  }

  .w-col-tiny-2 {
    width: 16.6667%;
  }

  .w-col-tiny-3 {
    width: 25%;
  }

  .w-col-tiny-4 {
    width: 33.3333%;
  }

  .w-col-tiny-5 {
    width: 41.6667%;
  }

  .w-col-tiny-6 {
    width: 50%;
  }

  .w-col-tiny-7 {
    width: 58.3333%;
  }

  .w-col-tiny-8 {
    width: 66.6667%;
  }

  .w-col-tiny-9 {
    width: 75%;
  }

  .w-col-tiny-10 {
    width: 83.3333%;
  }

  .w-col-tiny-11 {
    width: 91.6667%;
  }

  .w-col-tiny-12 {
    width: 100%;
  }
}

@media screen and (max-width: 479px) {
  .edit-col {
    font-size: 10px;
  }

  .appdash-wrapper {
    height: auto;
    padding-left: 4px;
    padding-right: 4px;
  }

  .my-workspace-wrapper {
    padding: 7px;
  }

  .app-group {
    flex-flow: column;
    padding-left: 18px;
    padding-right: 18px;
    display: flex;
  }

  .app-left-col {
    padding: 6px;
  }

  .app-link-tile {
    border-style: solid;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .app-right-col {
    width: 100%;
    margin-top: 0;
    padding: 6px;
  }

  .app-logo-icon {
    width: 30px;
    height: 30px;
  }

  .app-logo-icon.wide {
    width: 60px;
    height: 30px;
    margin-bottom: 1px;
  }

  .app-links-grid {
    grid-template-columns: 1fr 1fr;
  }

  .accordian-heading {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .app-name-label {
    font-size: 10px;
    line-height: 14px;
  }

  .app-category-label {
    font-size: 8px;
    font-weight: 600;
    line-height: 8px;
  }
}

@media (max-width: 360px) {
  .edit-common-icons {
    gap: 2px;
  }

  .prompt-tabs-link {
    font-size: 13px;
    line-height: 27px;
  }
}

#w-node-f324eca9-b2d0-c27d-e0cc-05fe1ee153cc-32048603,
#w-node-_783c6719-fc73-f8ba-c852-c01966d16bf5-32048603 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

@media screen and (max-width: 479px) {
  #w-node-f324eca9-b2d0-c27d-e0cc-05fe1ee153be-32048603 {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }
}

@media (max-width: 390px) {
  .chat-event-btn-wrapper {
    inset: auto auto 114px !important;
  }
}

@media (max-width: 385px) {
  .pagination-container .padding-right-5 {
    padding-right: 0 !important;
  }

  .chat-event-btn-wrapper {
    inset: auto auto 111px !important;
  }

  .chat-terminal-wrapper {
    min-height: calc(82vh - 80px);
    max-height: calc(82vh - 80px);
  }

  .chatbox {
    max-height: calc(59vh - 57px);
    overflow: auto;
  }
}

@media (max-width: 360px) {
  .chat-event-btn-wrapper {
    inset: auto auto 138px !important;
  }
}

@media (min-width: 768px) {
  .linkclass-clicked {
    width: calc(100vw - 832px);
  }

  .chat-sidebar {
    width: calc(100vw - 375px);
  }

  .dark-theme .dash-menu .dropdown-item {
    color: #053a64;
  }

  .dark-theme .dash-menu .dropdown-item .menu-icon-nested {
    filter: invert(1);
  }

  .dark-theme .dash-menu .dropdown-item:hover {
    color: #fff;
    background-color: #053a64;
  }

  .dark-theme .dash-menu .dropdown-item:hover .menu-icon-nested {
    filter: invert(0);
  }

  .dark-theme .dash-menu.open .dropdown-item {
    color: #fff;
  }

  .dark-theme .dash-menu.open .dropdown-item .menu-icon-nested {
    filter: invert(0);
  }

  .dark-theme .dash-menu.open .dropdown-item:hover {
    color: #053a64;
    background-color: #fff;
  }

  .dark-theme .dash-menu.open .dropdown-item:hover .menu-icon-nested {
    filter: invert(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/css/mks-application.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;EAaE,cAAc;AAChB;;AAEA;;;;EAIE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;EAGE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,+DAAwhF;EACxhF,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;;;;;EAME,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;EAC7D,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,6DAA6D;EAC7D,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,QAAQ;EACR,OAAO;EACP,UAAU;;EAEV;qBACmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;EACR,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8CAA8C;;AAE9C;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yDAAgD;EAChD,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mDAAsD;EACtD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mDAAuC;EACvC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oEAAiE;EACjE,wCAAwC;EACxC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,sCAAsC;EACtC,gCAAgC;EAChC,uCAAuC;EACvC,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,qCAAqC;EACrC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mDAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mDAAyC;EACzC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;GAIG;AACH;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mDAA6C;EAC7C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAoC;EACpC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oDAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;;EAErB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oDAAyC;EACzC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mDAAsD;EACtD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;;AAEpB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oDAAwC;EACxC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAAyC;EACzC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qEAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qEAAiE;EACjE,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;;GAEG;AACH;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EAEzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0DAAsD;EACtD,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;CAEC;;AAED;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC,qBAAqB;EACrB,UAAU;EACV,6EAA6E;EAC7E,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,0DAA2U;EAC3U,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,0DAA+U;EAC/U,aAAa;EACb,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,0DAA2W;EAC3W,qBAAqB;EACrB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0DAAoD;IACpD,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;;EAEb,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,WAAW;AACb;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0DAAuE;EACvE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yDAA+C;EAC/C,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0DAA0E;EAC1E,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;;EAEjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,0DAA6D;EAC7D,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oDAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;EACjC,aAAa;EACb,QAAQ;EACR,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;EAChC,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oDAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0DAA6D;EAC7D,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;EACP,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB,iBAAiB;;EAEjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,SAAO;EACP,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;;EAEf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,SAAO;EACP,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oDAAsD;EACtD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oDAAuD;EACvD,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0DAA+D;EAC/D,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,0DAAmE;EACnE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;uCACqC;EACrC,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,0DAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,UAAU;;EAEV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;EAC9B,QAAQ;EACR,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;EACjC,aAAa;EACb,QAAQ;EACR,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0DAAiE;EACjE,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0DAAiE;AACnE;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAAoE;AACtE;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0DAAkD;EAClD,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0DAAgD;EAChD,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0DAAmE;EACnE,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kDAAkD;EAClD,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0DAA0C;EAC1C,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gCAAgC;;EAEhC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,0DAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA6D;EAC7D,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oDAAuC;EACvC,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,0DAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,0DAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,0DAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,0DAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0DAA+D;AACjE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,qDAAqD;EACrD,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,6CAA6C;EAC7C,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb;6CAC2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oDAAuD;EACvD,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oDAAuD;EACvD,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0DAAkE;EAClE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,0DAAkE;EAClE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,0DAAkE;EAClE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0DAAwD;EACxD,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAAiD;EACjD,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAAiE;EACjE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAAqE;EACrE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;EACtC,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0DAAqE;EACrE,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;;;GAKG;;AAEH;EACE,0DAAmE;EACnE,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,SAAO;EACP,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0DAA+D;EAC/D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0DAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;EACxB,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,0DAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,wBAAwB;AAC1B;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,0DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,cAAY;EACZ,UAAU;EACV,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;;EAEtC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0DAAsE;EACtE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0DAA8D;EAC9D,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0DAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oDAAmC;EACnC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,oDAAiC;EACjC,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wEAAwE;EACxE,gEAAgE;EAChE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,0DAAgD;EAChD,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA,8BAA8B;;AAE9B,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;;EAErB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oDAAoD;EACpD,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oDAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC,mCAAmC;AACnC;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,UAAU;EACV,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oDAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,oDAA0D;EAC1D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;;AAErC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oDAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oDAAyC;EACzC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAA0C;EAC1C,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAA0C;EAC1C,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAAyC;EACzC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAA0C;EAC1C,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oDAAyC;EACzC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,oCAAoC;;AAEpC,sDAAsD;AACtD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,qCAAqC;EACrC,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAKhB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;EAInB,SAAO;EACP,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oDAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;;mBAIiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;;EAEX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oDAAwC;EACxC,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oDAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oDAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oDAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;;EAET,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;;EAEzB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oDAA8C;EAC9C,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oDAA8C;EAC9C,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oDAAwC;EACxC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oDAAwC;EACxC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oDAAmD;EACnD,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0DAAoD;EACpD,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAyD;EACzD,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;;mBAIiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;KAEG;EACH;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;;;IAIE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oDAAuC;IACvC,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,qDAA6C;IAC7C,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,MAAM;;IAEN,WAAW;EACb;;EAEA;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,MAAM;IACN,UAAU;IACV,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;;;EAIA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;IACX,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;IACb;+CACoC;IACpC,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,SAAS;IACT,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["html {\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  font-family: sans-serif;\n}\n\nbody {\n  margin: 0;\n}\n\n.margin-model {\n  margin-top: 10px;\n}\n\n.margin-bottom {\n  margin-bottom: 10px;\n}\n\n.item-video {\n  margin-top: 15px;\n}\n\n.item-video iframe {\n  border-radius: 6px;\n}\n\n.release-container {\n  max-width: 1800px;\n  /* margin: auto; */\n  padding: 10px 30px 40px 20px;\n}\n\n.release-header h1 {\n  font-size: 32px;\n}\n\n.version {\n  color: #1a73e8;\n}\n\n.release-video {\n  margin: 30px 0;\n}\n\n.release-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.release-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.upcoming-grid {\n  /* display: grid; */\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 25px;\n}\n\n.upcoming-card {\n  background: white;\n  border-radius: 10px;\n  padding: 18px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n}\n\n.upcoming-release-no-records {\n  margin-top: 20px;\n  text-align: center;\n  background: #f5f6fe;\n  min-height: 300px;\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 19px;\n}\n\n.upcoming-image {\n  width: 100%;\n  height: 480px;\n  object-fit: cover;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.badge {\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  color: white;\n}\n\n.feature {\n  background: #28a745;\n}\n\n.improvement {\n  background: #007bff;\n}\n\n.bugfix {\n  background: #dc3545;\n}\n\n.teaser img {\n  width: 100%;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.model-dropdown {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  position: absolute;\n  right: 78px;\n  top: 4px;\n}\n\n.model-card {\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\naudio,\ncanvas,\nprogress,\nvideo {\n  vertical-align: baseline;\n  display: inline-block;\n}\n\naudio:not([controls]) {\n  height: 0;\n  display: none;\n}\n\n[hidden],\ntemplate {\n  display: none;\n}\n\na {\n  background-color: #0000;\n}\n\na:active,\na:hover {\n  outline: 0;\n}\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nh1 {\n  margin: 0.67em 0;\n  font-size: 2em;\n}\n\nmark {\n  color: #000;\n  background: #ff0;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  vertical-align: baseline;\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nimg {\n  border: 0;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\n\npre {\n  overflow: auto;\n  white-space: normal;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ninput {\n  line-height: normal;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\nlegend {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n}\n\noptgroup {\n  font-weight: bold;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n\n@font-face {\n  font-family: webflow-icons;\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"w-icon-\"],\n[class*=\" w-icon-\"] {\n  speak: none;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  font-family: webflow-icons !important;\n}\n\n.w-icon-slider-right:before {\n  content: \"\";\n}\n\n.w-icon-slider-left:before {\n  content: \"\";\n}\n\n.form-config-box .custom-dropdown {\n  min-width: 100%;\n}\n\n.dropdown-button-span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.w-icon-nav-menu:before {\n  content: \"\";\n}\n\n.disabled-dropdown {\n  background-color: #f2f2f2;\n}\n\n.w-icon-arrow-down:before,\n.w-icon-dropdown-toggle:before {\n  content: \"\";\n}\n\n.w-icon-file-upload-remove:before {\n  content: \"\";\n}\n\n.w-icon-file-upload-icon:before {\n  content: \"\";\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  color: #333;\n  background-color: #fff;\n  min-height: 100%;\n  margin: 0;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nimg {\n  vertical-align: middle;\n  max-width: 100%;\n  display: inline-block;\n}\n\nhtml.w-mod-touch * {\n  background-attachment: scroll !important;\n}\n\n.w-block {\n  display: block;\n}\n\n.w-inline-block {\n  max-width: 100%;\n  display: inline-block;\n}\n\n.w-clearfix:before,\n.w-clearfix:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-clearfix:after {\n  clear: both;\n}\n\n.w-hidden {\n  display: none;\n}\n\n.w-button {\n  color: #fff;\n  line-height: inherit;\n  cursor: pointer;\n  background-color: #3898ec;\n  border: 0;\n  border-radius: 0;\n  padding: 9px 15px;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.w-button-disabled {\n  background-color: #81b9ec !important;\n}\n\ninput.w-button {\n  -webkit-appearance: button;\n}\n\nhtml[data-w-dynpage] [data-w-cloak] {\n  color: #0000 !important;\n}\n\n.w-code-block {\n  margin: unset;\n}\n\npre.w-code-block code {\n  all: inherit;\n}\n\n.w-optimization {\n  display: contents;\n}\n\n.w-webflow-badge,\n.w-webflow-badge * {\n  z-index: auto;\n  visibility: visible;\n  box-sizing: border-box;\n  float: none;\n  clear: none;\n  box-shadow: none;\n  opacity: 1;\n  direction: ltr;\n  font-family: inherit;\n  font-weight: inherit;\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  font-style: inherit;\n  font-variant: inherit;\n  text-align: inherit;\n  letter-spacing: inherit;\n  -webkit-text-decoration: inherit;\n  text-decoration: inherit;\n  text-indent: 0;\n  text-transform: inherit;\n  text-shadow: none;\n  font-smoothing: auto;\n  vertical-align: baseline;\n  cursor: inherit;\n  white-space: inherit;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  background: none;\n  border: 0 #0000;\n  border-radius: 0;\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  height: auto;\n  min-height: 0;\n  max-height: none;\n  margin: 0;\n  padding: 0;\n  list-style-type: disc;\n  transition: none;\n  display: block;\n  position: static;\n  inset: auto;\n  overflow: visible;\n  transform: none;\n}\n\n.w-webflow-badge {\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: 0 0 0 1px #0000001a, 0 1px 3px #0000001a;\n  visibility: visible !important;\n  z-index: 2147483647 !important;\n  color: #aaadb0 !important;\n  opacity: 1 !important;\n  background-color: #fff !important;\n  border-radius: 3px !important;\n  width: auto !important;\n  height: auto !important;\n  margin: 0 !important;\n  padding: 6px !important;\n  font-size: 12px !important;\n  line-height: 14px !important;\n  text-decoration: none !important;\n  display: inline-block !important;\n  position: fixed !important;\n  inset: auto 12px 12px auto !important;\n  overflow: visible !important;\n  transform: none !important;\n}\n\n.w-webflow-badge>img {\n  visibility: visible !important;\n  opacity: 1 !important;\n  vertical-align: middle !important;\n  display: inline-block !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\nh1 {\n  margin-top: 20px;\n  font-size: 38px;\n  line-height: 44px;\n}\n\nh2 {\n  margin-top: 20px;\n  font-size: 32px;\n  line-height: 36px;\n}\n\nh3 {\n  margin-top: 20px;\n  font-size: 24px;\n  line-height: 30px;\n}\n\nh4 {\n  margin-top: 10px;\n  font-size: 18px;\n  line-height: 24px;\n}\n\nh5 {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nh6 {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 18px;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\nblockquote {\n  border-left: 5px solid #e2e2e2;\n  margin: 0 0 10px;\n  padding: 10px 20px;\n  font-size: 18px;\n  line-height: 22px;\n}\n\nfigure {\n  margin: 0 0 10px;\n}\n\nfigcaption {\n  text-align: center;\n  margin-top: 5px;\n}\n\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n  padding-left: 40px;\n}\n\n.w-list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.w-embed:before,\n.w-embed:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-embed:after {\n  clear: both;\n}\n\n.w-video {\n  width: 100%;\n  padding: 0;\n  position: relative;\n}\n\n.w-video iframe,\n.w-video object,\n.w-video embed {\n  border: none;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"] {\n  cursor: pointer;\n  -webkit-appearance: button;\n  border: 0;\n}\n\n.btn-add-promt {\n  float: right;\n  width: 115px;\n}\n\n.w-form {\n  margin: 0 0 15px;\n}\n\n.w-form-done {\n  text-align: center;\n  background-color: #ddd;\n  padding: 20px;\n  display: none;\n}\n\n.w-form-fail {\n  background-color: #ffdede;\n  margin-top: 10px;\n  padding: 10px;\n  display: none;\n}\n\nlabel {\n  margin-bottom: 5px;\n  font-weight: bold;\n  display: block;\n}\n\n.chart-row-view {\n  display: flex;\n  gap: 20px;\n}\n\n.chart-display-width {\n  width: 50%;\n}\n\n.chart-button-display {\n  padding: 6px 21px;\n  background: transparent;\n  border: 1px solid #ededed;\n  border-radius: 5px;\n}\n\n.chart-div-display {\n  margin-bottom: 20px;\n  text-align: center;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.filter-display-boarder {\n  background: #f5f5f5;\n  padding: 16px;\n  text-align: center;\n  border-radius: 10px;\n}\n\n#maps_control_1 {\n  border: 1px solid #ccc;\n  margin-top: 19px;\n}\n\n.chart-active-button {\n  background: #053a64;\n  color: #fff;\n}\n\n.chart-left-border-radius {\n  border-radius: 5px 0 0 5px;\n}\n\n.chart-right-border-radius {\n  border-radius: 0 5px 5px 0;\n}\n\n.section-wrapper-graphs {\n  overflow-y: auto;\n  min-height: calc(100vh - 200px);\n}\n\n.table-chat-view:has(> table) {\n  white-space: normal !important;\n}\n\n.table-chat-view table {\n  width: 100%;\n  margin: 8px 0;\n}\n\n.table-chat-view table thead th,\n.table-chat-view table tbody td {\n  padding: 3px 5px;\n  border-bottom: 1px solid #ccc;\n}\n\n.w-input,\n.w-select {\n  color: #333;\n  vertical-align: middle;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  width: 100%;\n  height: 38px;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  display: block;\n}\n\n.w-input::placeholder,\n.w-select::placeholder {\n  color: #999;\n}\n\n.w-input:focus,\n.w-select:focus {\n  border-color: #3898ec;\n  outline: 0;\n}\n\n.chat-button-visibility {\n  opacity: 0.5 !important;\n}\n\n/* .disabled-parent {\n  pointer-events: none !important;\n} */\n\n.disabled-element {\n  cursor: not-allowed !important;\n}\n\n.disabled-delete {\n  opacity: 0.5;\n  /* Optional: Add additional styles to convey disabled state */\n  background-color: #f2f2f2;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.disabled-div {\n  pointer-events: none;\n  opacity: 0.5;\n  /* Optional: Add additional styles to convey disabled state */\n  /* background-color: #f2f2f2; */\n  color: #999;\n  cursor: not-allowed;\n}\n\n.error-text {\n  color: red;\n  font-size: 10px;\n  display: block;\n  margin-top: 4px;\n  position: absolute;\n  bottom: -17px;\n}\n\n.input-wrapper {\n  position: relative;\n}\n\n.input-date-text {\n  border: 1px solid #e5e5e5;\n  padding: 4px;\n  border-radius: 5px;\n  width: 100%;\n}\n\n.suggest-line-disabled-div {\n  pointer-events: none;\n  opacity: 0.5;\n  /* Optional: Add additional styles to convey disabled state */\n  /* background-color: #f2f2f2; */\n  color: #fff;\n  cursor: not-allowed;\n}\n\n.disabled-btn {\n  background-color: #f2f2f2;\n  color: #999;\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.w-input[disabled],\n.w-select[disabled],\n.w-input[readonly],\n.w-select[readonly],\nfieldset[disabled] .w-input,\nfieldset[disabled] .w-select {\n  cursor: not-allowed;\n}\n\n.w-input[disabled]:not(.w-input-disabled),\n.w-select[disabled]:not(.w-input-disabled),\n.w-input[readonly],\n.w-select[readonly],\nfieldset[disabled]:not(.w-input-disabled) .w-input,\nfieldset[disabled]:not(.w-input-disabled) .w-select {\n  background-color: #eee;\n}\n\ntextarea.w-input,\ntextarea.w-select {\n  height: auto;\n}\n\n.w-select {\n  background-color: #f3f3f3;\n}\n\n.w-select[multiple] {\n  height: auto;\n}\n\n.w-form-label {\n  cursor: pointer;\n  margin-bottom: 0;\n  font-weight: normal;\n  display: inline-block;\n}\n\n.w-radio {\n  margin-bottom: 5px;\n  padding-left: 20px;\n  display: block;\n}\n\n.w-radio:before,\n.w-radio:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-radio:after {\n  clear: both;\n}\n\n.w-radio-input {\n  float: left;\n  margin: 3px 0 0 -20px;\n  line-height: normal;\n}\n\n.w-file-upload {\n  margin-bottom: 10px;\n  display: block;\n}\n\n.w-file-upload-input {\n  opacity: 0;\n  z-index: -100;\n  width: 0.1px;\n  height: 0.1px;\n  position: absolute;\n  overflow: hidden;\n}\n\n.w-file-upload-default,\n.w-file-upload-uploading,\n.w-file-upload-success {\n  color: #333;\n  display: inline-block;\n}\n\n.w-file-upload-error {\n  margin-top: 10px;\n  display: block;\n}\n\n.w-file-upload-default.w-hidden,\n.w-file-upload-uploading.w-hidden,\n.w-file-upload-error.w-hidden,\n.w-file-upload-success.w-hidden {\n  display: none;\n}\n\n.w-file-upload-uploading-btn {\n  cursor: pointer;\n  background-color: #fafafa;\n  border: 1px solid #ccc;\n  margin: 0;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  display: flex;\n}\n\n.w-file-upload-file {\n  background-color: #fafafa;\n  border: 1px solid #ccc;\n  flex-grow: 1;\n  justify-content: space-between;\n  margin: 0;\n  padding: 8px 9px 8px 11px;\n  display: flex;\n}\n\n.w-file-upload-file-name {\n  font-size: 14px;\n  font-weight: normal;\n  display: block;\n}\n\n.w-file-remove-link {\n  cursor: pointer;\n  width: auto;\n  height: auto;\n  margin-top: 3px;\n  margin-left: 10px;\n  padding: 3px;\n  display: block;\n}\n\n.btn-delete-prompt {\n  padding-right: 5px;\n}\n\n.w-icon-file-upload-remove {\n  margin: auto;\n  font-size: 10px;\n}\n\n.error-msg {\n  margin: 0;\n  padding: 8px;\n  font-size: 11px;\n}\n\n.w-file-upload-error-msg {\n  color: #ea384c;\n  padding: 2px 0;\n  display: inline-block;\n}\n\n.w-file-upload-info {\n  padding: 0 12px;\n  line-height: 38px;\n  display: inline-block;\n}\n\n.w-file-upload-label {\n  cursor: pointer;\n  background-color: #fafafa;\n  border: 1px solid #ccc;\n  margin: 0;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  display: inline-block;\n}\n\n.btn-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadspinner {\n  margin-right: 5px;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  border-top-color: #000;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.w-icon-file-upload-icon,\n.w-icon-file-upload-uploading {\n  width: 20px;\n  margin-right: 8px;\n  display: inline-block;\n}\n\n.w-icon-file-upload-uploading {\n  height: 20px;\n}\n\n.w-container {\n  max-width: 940px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.w-container:before,\n.w-container:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-container:after {\n  clear: both;\n}\n\n.w-container .w-row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.w-row:before,\n.w-row:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-row:after {\n  clear: both;\n}\n\n.user-role-row {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 1fr 1fr 100px;\n  padding: 5px 10px;\n  border-top: 1px solid #ccc;\n  align-items: center;\n}\n\n.w-row .w-row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.w-col {\n  float: left;\n  width: 100%;\n  min-height: 1px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n}\n\n.w-col .w-col {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.w-col-1 {\n  width: 8.33333%;\n}\n\n.w-col-2 {\n  width: 16.6667%;\n}\n\n.w-col-3 {\n  width: 25%;\n}\n\n.w-col-4 {\n  width: 33.3333%;\n}\n\n.w-col-5 {\n  width: 41.6667%;\n}\n\n.w-col-6 {\n  width: 50%;\n}\n\n.w-col-7 {\n  width: 58.3333%;\n}\n\n.w-col-8 {\n  width: 66.6667%;\n}\n\n.w-col-9 {\n  width: 75%;\n}\n\n.w-col-10 {\n  width: 83.3333%;\n}\n\n.w-col-11 {\n  width: 91.6667%;\n}\n\n.w-col-12 {\n  width: 100%;\n}\n\n.w-hidden-main {\n  display: none !important;\n}\n\n.login-form-wrapper {\n  grid-column-gap: 30px;\n  grid-row-gap: 30px;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 0 20px 20px 0;\n  flex-flow: column;\n  flex: 0 1 auto;\n  align-items: center;\n  width: 40%;\n  height: 100%;\n  margin-top: auto;\n  margin-bottom: auto;\n  padding: 5% 6%;\n  display: flex;\n  justify-content: center;\n}\n\n.skills-tabs .ai-collection-grid {\n  background: #f5f5f5;\n}\n\n.skills-tabs .ai-collection-grid.light {\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.form-wrapper {\n  width: 70%;\n}\n\n/* --------------Start of Prompt Table  csss--------- */\n\n.custom-div-table {\n  padding: 10px;\n}\n\n.div-table-header {\n  background-color: #0062ff;\n  color: white;\n}\n\n.div-table-body {\n  border: 1px solid #e5e5e5;\n  max-height: 180px;\n  overflow-y: auto;\n  border-radius: 5px !important;\n}\n\n.chat-bottom-wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n}\n\n.chat-sort {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.chat-order-select {\n  background: #f5f7f8;\n  border: 0;\n  font-size: 12px;\n  padding: 6px 6px;\n  border-radius: 5px;\n}\n\n.div-table-row {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n}\n\n.div-table-cell {\n  padding: 12px;\n  border-right: 1px solid #ddd;\n  text-align: left;\n}\n\n.div-table-cell:last-child {\n  border-right: none;\n  /* Remove border from the last cell */\n}\n\n.div-table-body .div-table-row:nth-child(even) {\n  background-color: #f3f3f3;\n  /* Alternating row color */\n}\n\n.div-table-body .div-table-row:hover {\n  background-color: #f1f1f1;\n  /* Hover effect */\n}\n\n.div-table-header .div-table-cell {\n  color: #fff;\n  padding: 5px 10px;\n}\n\n.prompt-down-arrow {\n  position: absolute;\n  right: 7px;\n  cursor: pointer;\n  top: 6px;\n}\n\n.upperchartbox {\n  position: absolute;\n  bottom: 65px;\n  background: #fff;\n  margin: 0 20px;\n  box-shadow: 2px 2px 10px #e5e5e5;\n  right: 0;\n  left: 0;\n  z-index: 1;\n\n  /* max-height: 300px;\n  overflow-y: auto; */\n}\n\n.upperchartbox-wide {\n  padding: 10px;\n}\n\n.upperchartbox-home {\n  position: absolute;\n  top: 52px;\n  background: #fff;\n  box-shadow: 2px 2px 10px #e5e5e5;\n  right: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.dark-theme .upperchartbox-home {\n  color: #000;\n}\n\n.dark-theme .upperchartbox-home .prompt-tabs-link.w--current {\n  border-bottom-color: #053a64;\n  color: #053a64;\n}\n\n.chatpromp .skill-filter-wrapper {\n  padding: 10px;\n  border: 0;\n}\n\n.prompt-head {\n  font-weight: 500;\n}\n\n.chatprompt-block {\n  position: relative;\n}\n\n.center {\n  text-align: center;\n}\n\n.empty-row {\n  text-align: center;\n\n  grid-template-columns: 1fr !important;\n}\n\n.auto-chat-row,\n.chat-table-lis-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.chat-table-lis-row {\n  /* font-size: 11px; */\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n}\n\n.auto-chat-row {\n  border-bottom: 1px solid #cccccc;\n  padding-bottom: 6px;\n  margin-bottom: 5px;\n  font-weight: 600;\n  position: relative;\n}\n\n.auto-chat-row.auto-col-3,\n.chat-table-lis-row.auto-col-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.auto-chat-row.auto-col-5,\n.chat-table-lis-row.auto-col-5 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.empty-row .div-table-cell {\n  text-align: center;\n}\n\n/* ------------- end of prompt table ----css */\n\n.text-left {\n  text-align: left;\n  margin-bottom: 25px;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.recent-comments .full-width {\n  width: 92%;\n}\n\n.submit-button {\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.text-left label {\n  font-size: 16px;\n}\n\n.login-form-logo {\n  width: 60%;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.input-field {\n  border-radius: 5px;\n}\n\n.flex-end {\n  justify-content: flex-end;\n}\n\n.login-logo {\n  background-image: url(../images/mks_logo.png);\n  width: 220px;\n  height: 120px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.login-form-wrapper h1 {\n  margin: 0;\n}\n\n.auth-logo-icon {\n  background-image: url(../images/microsoftid.svg);\n  width: 140px;\n  height: 45px;\n  background-size: 130px;\n  background-repeat: no-repeat;\n}\n\n.autl-logo-link button {\n  display: flex;\n  background-color: transparent;\n  align-items: center;\n  font-size: 14px;\n  gap: 10px;\n  width: 100%;\n  justify-content: center;\n  padding: 14px;\n  border-radius: 5px;\n  /* border: 1px solid #e5e5e5; */\n}\n\n.right-arrow {\n  background: url(../images/mksapp/down-arrow-white.svg);\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  transform: rotate(270deg);\n}\n\n.edit-icon {\n  background: url(../images/editicon.svg);\n  width: 19px;\n  height: 19px;\n  display: inline-block;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.edit-button-icon {\n  display: flex;\n  gap: 3px;\n  align-items: center;\n  border-right: 1px solid #ccc;\n  padding-right: 11px;\n}\n\n.trash-button-icon {\n  display: flex;\n  gap: 3px;\n  align-items: center;\n}\n\n.trash-button-icon .trash-icon::after {\n  display: none;\n}\n\n.light-theme .use-skill-row-wrap .trash-button-icon {\n  filter: brightness(0.5);\n}\n\n.dark-theme .user-table-row {\n  color: #000;\n}\n\n.dark-theme .trash-button-icon.light-gray-button a {\n  color: #000;\n}\n\n.dark-theme .trash-button-icon.light-gray-button.trash-icon {\n  filter: invert(1);\n}\n\n.skill-detaill-right-full .trash-icon:hover::before {\n  display: none;\n}\n\n.edit-button-icon a {\n  color: #053a64;\n  text-decoration: none;\n}\n\n.trash-button-icon a {\n  color: #5f5a5a;\n  text-decoration: none;\n}\n\n.auth-logo-link .azure-btn {\n  display: flex;\n  background-color: #00567d;\n  align-items: center;\n  font-size: 14px;\n  gap: 10px;\n  width: 100%;\n  justify-content: space-between;\n  padding: 14px;\n  border-radius: 5px;\n  border: 1px solid #e5e5e5;\n}\n\n.auth-logo-link .login-small-text {\n  color: #fff;\n  font-weight: 500;\n}\n\n.text-label {\n  font-weight: 700;\n  color: #00567d;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n\n.auth-logo-link {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.login-small-text {\n  /* border-right: 1px solid #e5e5e5; */\n  height: 100%;\n  display: flex;\n  align-items: center;\n  /* padding-right: 22px; */\n  font-weight: 800;\n  color: #00567d;\n  font-size: 18px;\n}\n\n.autl-logo-link {\n  display: flex;\n  justify-content: center;\n  margin-top: 15px;\n  font-weight: 600;\n}\n\n.loader {\n  display: none;\n  width: 100%;\n  height: 100%;\n  background-image: url(../images/common/loaderblue.gif) !important;\n  background-position: 50% 50vh !important;\n  background-size: 50px !important;\n  background-repeat: no-repeat !important;\n}\n\n.loader.show {\n  display: block !important;\n  position: fixed;\n  cursor: progress !important;\n  z-index: 99999;\n}\n\n.loader-base {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  /* background: red; */\n  z-index: 99;\n}\n\n.overlay-loading {\n  width: 100%;\n  height: 100%;\n  /* background-image: url(../images/common/loaderblue.gif) !important; */\n  background-position: center !important;\n  background-size: 50px !important;\n  background-repeat: no-repeat !important;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  cursor: progress !important;\n  z-index: 99999;\n  align-items: center;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: #fffdfd63;\n}\n\n.loader-dot {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #509cdb;\n}\n\n/* .loader-dot2{\n  animation-delay: 0s;\n  \n}\n\n.loader-dot3{\n  animation-delay: 0.5s;\n \n}\n\n.loader-dot4{\n  animation-delay: 1s;\n  \n}\n.loader-wrap{\n  width: 40px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n@keyframes circleMove {\n  0% {\n    transform: rotate(0deg) translateX(10px);\n  }\n  100% {\n     transform: rotate(360deg) translateX(10px);\n  }\n} */\n\n.loader-dot1 {\n  visibility: hidden;\n}\n\n/* .loader-dot1, .loader-dot2, .loader-dot3, .loader-dot4{\n  animation: ani 2s linear infinite;\n} */\n.loader-dot2 {\n  background-color: hsl(203, 100%, 27%);\n  animation: movebottom 3.5s infinite;\n  animation-delay: 0.2s;\n}\n\n.loader-dot3 {\n  background-color: #6f94bb;\n  top: 26px;\n  animation: moveleft 3.5s infinite;\n  animation-delay: 0.4s;\n}\n\n.buttonpopup {\n  position: relative;\n}\n\n.loader-dot4 {\n  background-color: #a0b6d3;\n  top: 26px;\n  left: -26px;\n  animation: movetop 3.5s infinite;\n  animation-delay: 0.6s;\n}\n\n.loader-wrap {\n  width: 117px;\n  position: relative;\n  right: -51px;\n}\n\n.pagination-custom {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dark-theme .create-skill-left .skill-update-box .prompt-title {\n  color: #000;\n}\n\n.pagination-custom a {\n  color: black;\n  float: left;\n  padding: 5px 14px;\n  text-decoration: none;\n  transition: background-color 0.3s;\n  border: 1px solid #ddd;\n  margin: 0 4px;\n  border-radius: 5px;\n  font-size: 12px;\n}\n\n.flex {\n  display: flex;\n}\n\n.pagination-custom a.active {\n  background-color: #053a64;\n  color: white;\n  border: 1px solid #053a64;\n  border-radius: 5px;\n}\n\n.pagination-custom a:hover:not(.active) {\n  background-color: #ddd;\n}\n\n.loader-text {\n  position: absolute;\n  top: 56px;\n  width: 100%;\n  right: 54px;\n  font-weight: 600;\n  color: #00558a;\n  font-size: 12px;\n  font-family: Poppins, sans-serif;\n  background: #ffffff;\n  padding: 5px;\n}\n\n.loader-text.login-text-loader {\n  background: transparent;\n  color: #fff;\n}\n\n.dropbox-wrapper {\n  border: 2px dashed #ccc;\n  padding: 5px;\n\n  text-align: center;\n}\n\n.dropbox-wrapper-main {\n  padding: 6px 40px;\n}\n\n.f-10 {\n  font-size: 10px;\n}\n\n.flex-line {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n}\n\n.uplod-icon {\n  background: url(../images/mkspropmanagment/cloud-upload.svg);\n  width: 25px;\n  height: 25px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.success-icon {\n  background: url(../images/check-circle-green.svg);\n  width: 32px;\n  height: 32px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.error-icon {\n  background: url(../images/cancel-red.svg);\n  width: 32px;\n  height: 32px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.dark-theme .download-text .download-arrow {\n  filter: brightness(8);\n}\n\n/* .import-section > button {\n  position: absolute;\n  right: 0;\n  top: 10px;\n} */\n.description-rows {\n  display: flex;\n  flex-flow: column;\n  max-height: calc(100vh - 460px);\n  overflow-y: auto;\n}\n\n.linkcss {\n  font-weight: 400;\n\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.bluelink {\n  color: #0063ff;\n  margin-right: 4px;\n  cursor: pointer;\n}\n\n.dark-theme .bluelink {\n  color: #5194ff;\n}\n\ntextarea.chat-input-field.w-input.home-chat-field.scrollinput {\n  margin: 0 0 0 -10px;\n  padding: 10px 5px 10px 10px;\n}\n\n.flex-line .prompt-img {\n  margin: 4px auto;\n  max-width: 50px;\n  height: 50px;\n  cursor: pointer;\n}\n\n.download-text {\n  display: flex;\n  cursor: pointer;\n}\n\n.light-text {\n  font-size: 12px;\n  color: #807c7c;\n  margin-bottom: 0;\n}\n\n.import-prompt-box {\n  padding: 20px 40px 0 40px;\n}\n\n.download-arrow {\n  background: url(../images/download-arrow.svg);\n  width: 20px;\n  height: 20px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.user-text h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.user-breif {\n  display: flex;\n  gap: 10px;\n}\n\n.user-image {\n  border-radius: 100%;\n  overflow: hidden;\n}\n\n.small-text {\n  font-size: 12px;\n}\n\n.small-text-anchor {\n  font-size: 12px;\n  color: blue;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.unread-notif {\n  background: #f7f7f7;\n  color: #0092ff;\n}\n\n.user-breif.selected {\n  border: 1px solid #0063ff;\n}\n\n.user-name-box.user-profile-initial {\n  background-color: #7fb0ff;\n}\n\n.error-rows {\n  padding: 0;\n  list-style: none;\n  color: #e74c3c;\n  font-size: 12px;\n  max-height: calc(100vh - 413px);\n  overflow-y: auto;\n}\n\n.import-section {}\n\n@keyframes movebottom {\n  0% {\n    top: 0px;\n  }\n\n  40% {\n    top: 26px;\n    left: 0px;\n  }\n\n  80% {\n    top: 26px;\n    left: -26px;\n  }\n\n  100% {\n    top: 0px;\n    left: 0px;\n  }\n}\n\n@keyframes moveleft {\n  0% {\n    top: 26px;\n    left: 0px;\n  }\n\n  40% {\n    top: 26px;\n    left: -26px;\n  }\n\n  80% {\n    top: 0px;\n    left: 0px;\n  }\n\n  100% {\n    top: 26px;\n    left: 0px;\n  }\n}\n\n@keyframes movetop {\n  0% {\n    top: 26px;\n    left: -26px;\n  }\n\n  40% {\n    top: 0px;\n    left: 0px;\n  }\n\n  80% {\n    top: 26px;\n    left: 0px;\n  }\n\n  100% {\n    top: 26px;\n    left: -26px;\n  }\n}\n\n/* .dark-theme .loader-dot {\n  background-color: #80CE1A;\n} */\n\n/* .dark-theme .loader-dot2 {\n  background-color: #5f9c0f;\n  animation: movebottomgreen 3.5s infinite;\n  animation-delay: 0.2s;\n}\n\n.dark-theme .loader-dot3 {\n  background-color: #78c219;\n  top: 26px;\n  animation: moveleftgreen 3.5s infinite;\n  animation-delay: 0.4s;\n}\n\n.dark-theme .loader-dot4 {\n  background-color: #b4f164;\n  top: 26px;\n  left: -26px;\n  animation: movetopgreen 3.5s infinite;\n  animation-delay: 0.6s;\n}\n\n.dark-theme .loader-wrap {\n  width: 40px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 5px;\n  position: relative;\n} */\n\n.dark-theme .workspace-dashboard.flex-end {\n  background-color: #053a64;\n}\n\n.dark-theme .loader-text {\n  background-color: transparent;\n  color: #fff;\n}\n\n.dark-theme .login-form-wrapper .submit-button.w-button.full-width {\n  color: #fff;\n}\n\n@keyframes movebottomgreen {\n  0% {\n    top: 0px;\n  }\n\n  40% {\n    top: 26px;\n    left: 0px;\n  }\n\n  80% {\n    top: 26px;\n    left: -26px;\n  }\n\n  100% {\n    top: 0px;\n    left: 0px;\n  }\n}\n\n@keyframes moveleftgreen {\n  0% {\n    top: 26px;\n    left: 0px;\n  }\n\n  40% {\n    top: 26px;\n    left: -26px;\n  }\n\n  80% {\n    top: 0px;\n    left: 0px;\n  }\n\n  100% {\n    top: 26px;\n    left: 0px;\n  }\n}\n\n@keyframes movetopgreen {\n  0% {\n    top: 26px;\n    left: -26px;\n  }\n\n  40% {\n    top: 0px;\n    left: 0px;\n  }\n\n  80% {\n    top: 26px;\n    left: 0px;\n  }\n\n  100% {\n    top: 26px;\n    left: -26px;\n  }\n}\n\n/*********skilldetail**************/\n\n.skill-detail-wrapper {\n  display: flex;\n  padding: 0 40px 20px;\n}\n\n.skill-heading h2 {\n  font-size: 24px;\n  margin: 0;\n}\n\n.skill-detail-left {\n  padding: 0 20px 0 0;\n  width: 75%;\n  grid-column-gap: 20px;\n  background-color: #fff;\n  flex-flow: column;\n  display: flex;\n  position: relative;\n  grid-row-gap: 20px;\n  border-radius: 10px 0 0 10px;\n}\n\n.skill-detaill-right {\n  width: 25%;\n  padding: 20px;\n  grid-column-gap: 20px;\n  background-color: #f5f5f5;\n  flex-flow: column;\n  display: flex;\n  position: relative;\n  grid-row-gap: 20px;\n  border-radius: 10px;\n}\n\n.skill-detaill-right-full {\n  width: 25%;\n}\n\n.use-skill-row-wrap {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 13px;\n  gap: 10px;\n}\n\n.skill-detaill-right-full h3 {\n  margin: 0;\n}\n\n.skill-detaill-right-section {\n  padding: 20px;\n  grid-column-gap: 20px;\n  background-color: #f5f5f5;\n  flex-flow: column;\n  display: flex;\n  position: relative;\n  grid-row-gap: 20px;\n  border-radius: 10px;\n}\n\n.skill-full-wrap {\n  padding: 0 40px 20px;\n}\n\n.skill-subheading {\n  margin: 0;\n  font-size: 18px;\n  padding-bottom: 10px;\n}\n\n.skill-flex-col {\n  display: flex;\n  gap: 15px;\n  border-top: 1px solid #e5e5e5;\n  padding-top: 24px;\n}\n\n.skill-card-small {\n  width: 100%;\n  background: #f5f5f5;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.skill-block-header {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.version-link .col-text:hover {\n  background: #1459c7;\n}\n\n.use-skill-icon {\n  background: url(../images/skill.svg);\n  width: 18px;\n  height: 24px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.dropchat-wrap .search-input-field {\n  border: 0;\n  background: transparent;\n}\n\n.dropchat-wrap .search-input-field:focus {\n  background-color: transparent;\n}\n\n.use-skill {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 11px;\n  gap: 5px;\n  color: #000;\n}\n\n.use-skill-icon.active {\n  background: url(../images/skilldev.svg);\n}\n\n.skill-icon-block {\n  width: 58px;\n  height: 47px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n}\n\n.skill-detaill-right h3 {\n  font-size: 16px;\n  margin: 0;\n}\n\n.skill-subtitle {\n  font-size: 12px;\n  color: #053a64;\n  font-weight: 600;\n}\n\n.skill-subtitle-info {\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.skill-card-small p {\n  margin: 0;\n}\n\n.skill-update-box {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  background: #f5f5f5;\n  padding: 16px;\n  border-radius: 10px;\n}\n\n.contact-detail {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.skill-icon-circle {\n  width: 40px;\n  height: 40px;\n  background: #e5e5e5e5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n}\n\n.skill-desc p {\n  font-size: 13px;\n}\n\n.skill-desc,\n.skill-tags,\n.skill-contact-detail {\n  padding-bottom: 18px;\n}\n\n.skill-tags {\n  background: #f5f5f5;\n  padding: 15px;\n  border-radius: 10px;\n}\n\n.skill-contact-detail {\n  padding-top: 20px;\n}\n\n.skill-contact-person {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  background: #f5f5f5;\n  padding: 16px;\n  border-radius: 10px;\n}\n\n.contact-detail-box {\n  display: flex;\n  gap: 15px;\n  flex-direction: column;\n}\n\n.version-col {\n  display: flex;\n  gap: 20px;\n  background: #f5f5f5;\n  padding: 14px;\n  border-radius: 10px;\n  flex-wrap: wrap;\n}\n\n.col-text {\n  color: #053a64;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.version-link .col-text {\n  color: #fff;\n  text-decoration: none;\n  display: block;\n  background-color: #0063ff;\n  padding: 2px 15px;\n  border-radius: 5px;\n}\n\n.version-link .col-text:hover {\n  color: #fff;\n}\n\n.skill-tags .skill-keyword {\n  font-size: 11px;\n}\n\n.skill-col {\n  width: 100%;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  padding: 20px 40px 0;\n}\n\n.breadcrumb a {\n  display: flex;\n  text-decoration: none;\n\n  align-items: center;\n}\n\n.home-link::after {\n  content: \"\";\n  background: url(../images/mksapp/chevron-right.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n  opacity: 0.6;\n}\n\n.normal-link::after {\n  content: \"\";\n  background: url(../images/mksapp/chevron-right.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n  opacity: 0.6;\n}\n\n.normal-link:last-child::after {\n  display: none;\n}\n\n.breadcrumb a.normal-link {\n  color: #ada3a3;\n  font-size: 13px;\n}\n\n.breadcrumb a.normal-link:last-child::after {\n  display: none;\n}\n\n.infotext::before {\n  content: \"\";\n  background: url(../images/mksapp/help.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n}\n\n.use-skill-row {\n  width: 100%;\n}\n\n.use-skill-row .button {\n  width: 100%;\n  font-size: 12px;\n  text-align: center;\n}\n\n.infotext {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 5px;\n}\n\n/********custom dropdown********/\n\n.custom-dropdown .dropdown-menu-custom li label {\n  display: flex;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.custom-dropdown .dropdown-menu-custom {\n  background-color: #f5f7f8;\n  color: #7a7a7a;\n}\n\n.down-arrow {\n  background: url(../images/down-arrow.svg);\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.dropdown-nav {\n  color: #fff;\n  font-size: 12px;\n  padding-left: 30px;\n}\n\n.dropdown-nav a.dropdown-item {\n  color: #fff;\n  text-decoration: none;\n}\n\n.dropdown-item {\n  word-break: auto-phrase;\n  padding: 4px 10px;\n  white-space: normal;\n  display: flex;\n  gap: 5px;\n}\n\n.dash-menu.open .dropdown-nav {\n  position: absolute;\n  top: 24px;\n  z-index: 2;\n  background: #053a64;\n  color: #fff;\n  border: 1px solid #e5e5e3;\n  left: 50px;\n  width: 200px;\n  padding-left: 0;\n  border-radius: 7px;\n}\n\n.menu-icon-nested {\n  width: 18px;\n  height: 18px;\n}\n\n.light-theme .dash-menu .dropdown-label .down-arrow {\n  filter: invert(1);\n}\n\n.light-theme .dash-menu .dropdown-label:hover .down-arrow {\n  filter: invert(0);\n}\n\n.dash-menu.open .dropdown-item {\n  font-size: 10px;\n  padding: 2px 10px;\n}\n\n.dash-menu.open .dropdown-item:hover::after {\n  display: none;\n}\n\n.dash-menu.open .dropdown-items {\n  position: relative;\n}\n\n.dash-menu.open .down-arrow {\n  display: none;\n}\n\n.dash-menu.open .flex-links {\n  width: auto;\n}\n\n.dropdown-nav a.dropdown-item:hover {\n  background-color: #ffffff;\n  color: #053a64;\n  border-radius: 40px;\n}\n\n.dropdown-item:hover .menu-icon-nested {\n  filter: invert(1);\n}\n\n.down-arrow-white {\n  background: url(../images/mksapp/down-arrow-white.svg);\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.upperchartbox-wide .down-arrow {\n  z-index: 10;\n}\n\n.custom-dropdown .dropdown-button {\n  padding: 9px 3px 9px 9px;\n  border: 0;\n  background-color: #f5f7f8;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  color: #7a7a7a;\n  justify-content: space-between;\n}\n\n.form-config-box .dropdown-button {\n  background-color: #ffffff;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n}\n\n.form-config-box .custom-dropdown .dropdown-menu-custom {\n  background-color: #ffffff;\n  box-shadow: 1px 14px 10px #e5e5e5;\n  border: 0;\n  border-radius: 0 0px 5px 5px;\n}\n\n.dark-theme .form-config-box .custom-dropdown .dropdown-menu-custom {\n  box-shadow: 1px 14px 10px #042947;\n}\n\n.dark-theme .no-users-found {\n  color: #053a64;\n}\n\n.dropdown-with-button {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  justify-content: flex-end;\n}\n\n.dropdown-with-button .prompt-title-wrap {\n  width: 200px;\n}\n\n.bot-configuration {}\n\n.bot-configuration h1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.bot-configuration .form-group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.form-group .form-config-box {\n  width: 100%;\n}\n\n.form-group .form-config-box label {\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0;\n  line-height: 14px;\n  margin-bottom: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.description-wrap {\n  display: flex;\n  gap: 15px;\n}\n\n.form-config-box-check {\n  width: 100%;\n  display: flex;\n  gap: 6px;\n}\n\n.checkbox-row {\n  max-width: 57%;\n  width: 100%;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0;\n  line-height: 14px;\n}\n\n.variable-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* Adds space between inputs and buttons */\n  margin-bottom: 17px;\n  /* Adds space between each row */\n}\n\n.variable-input input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 200px;\n  /* Adjust width as needed */\n}\n\n.variable-input button {\n  border: none;\n  background: white;\n  border-radius: 100%;\n  cursor: pointer;\n  padding: 0;\n}\n\n.variable-input button:hover {\n  box-shadow: 2px 2px 10px #d0caca;\n}\n\n.button-wrap-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.all-variavle-inputs {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.minus-icon-white {\n  background: url(../images/minusicon.svg);\n  width: 24px;\n  height: 24px;\n  background-size: cover;\n  display: block;\n}\n\n.container-no-records {\n  text-align: center;\n  background: #f5f6fe;\n  min-height: 300px;\n  height: 75%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 19px;\n}\n\n.plus-icon-white-bot {\n  background: url(../images/add-circle.svg);\n  width: 24px;\n  height: 24px;\n  background-size: cover;\n  display: block;\n  cursor: pointer;\n}\n\n.plusbtn:hover {\n  background-color: #3d8b40;\n}\n\n.btn-save-bot {\n  padding: 3px 3px 3px 5px;\n  background-color: #007bff;\n  color: rgba(255, 255, 255, 0.942);\n  text-align: center;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-block;\n  min-width: 80px;\n}\n\n.btn-save-bot:hover {\n  background-color: #0056b3;\n  color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transform: translateY(0px);\n}\n\n.btn-save-bot:active {\n  background-color: #004085;\n  transform: translateY(1px);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.btn-save-bot:disabled {\n  background-color: #66b0ff;\n  color: rgba(255, 255, 255, 0.5);\n  pointer-events: none;\n  transform: none;\n  box-shadow: none;\n}\n\n/* UserGrid.css */\n\n.user-table-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 9px;\n  font-size: 12px;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.user-table-header {\n  font-weight: 600;\n  border-bottom: 1px solid #ccc;\n  padding: 10px 9px 5px 9px;\n  background: #f3f3f3;\n}\n\n.user-table-list {\n  background: #fff;\n  border-radius: 7px;\n  border: 1px solid #e5e5e5;\n}\n\n.light-gray-button {\n  background: #e6e6e6;\n  border-radius: 40px;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 5px 15px;\n}\n\n.user-table-row .user-col {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.user-col.auto-width {\n  max-width: 40px;\n  align-items: center;\n  display: flex;\n}\n\n.light-gray-button .trash-icon:hover::before {\n  display: none;\n}\n\n.top-bar {\n  display: flex;\n  justify-content: space-between;\n}\n\n.delete-btn,\n.add-btn {\n  padding: 8px 12px;\n  border: none;\n  cursor: pointer;\n  color: white;\n}\n\n.text-style {\n  min-height: 35px;\n  margin-bottom: 0;\n  padding: 10px 30px 10px 10px;\n  font-size: 11px;\n  border: 1px solid #e5e5e5;\n  width: 100%;\n  margin-bottom: 20px;\n  border-radius: 4px;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.top-bar .search-cross-icon-common {\n  max-width: 300px;\n  width: 100%;\n}\n\n/* .add-btn {\n  background-color: green;\n} */\n\n.pagination {\n  margin-top: 10px;\n}\n\n.pagination button {\n  margin-right: 5px;\n  padding: 5px 10px;\n}\n\n.pagination .active {\n  background-color: blue;\n  color: white;\n}\n\n/* UserModal.css */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  width: 300px;\n  text-align: center;\n  position: relative;\n}\n\n.close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.dark-theme .create-skill-window .prompt-title {\n  color: #000;\n}\n\n/* \nStart of CSS related to Sorting\n*/\n.sort-button.sorting-ascending {\n  display: block;\n}\n\n.sort-button.sorting-descending {\n  display: block;\n}\n\n.sorting-ascending {\n  width: 20px;\n  background-image: url(\"../images/asc-arrow-up.svg\") !important;\n  background-position: 6px;\n  background-repeat: no-repeat;\n  color: white;\n  background-size: 12px;\n  height: 30px;\n  cursor: pointer;\n}\n\n.sorting-descending {\n  width: 20px;\n  background-image: url(\"../images/desc-arrow-down.svg\") !important;\n  background-position: 6px;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  height: 30px;\n  cursor: pointer;\n}\n\n/* .survey-list-wrapper-sort-column {\n  cursor: pointer;\n} */\n.sort-button {\n  background-color: transparent;\n  border-bottom-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-top-width: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}\n\n.sort-button-hide {\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding-bottom: 0 !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  padding-top: 0 !important;\n  position: absolut !important;\n  white-space: nowrap !important;\n  width: 1px !important;\n}\n\n.sort-new-column {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  line-height: 15px;\n}\n\n.sort-new-column .sort-button {\n  /* position: absolute; */\n  display: block;\n}\n\n.sort-button {\n  width: 24px;\n  background-image: url(../images/default-sort-icon.svg);\n  background-position: 6px;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  height: 24px;\n  cursor: pointer;\n}\n\n.sort-column {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.unsort-column {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  margin-top: 5px;\n}\n\n.unsort-column-nomargin {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n}\n\n/* \nEnd of CSS related to Sorting\n*/\n\n@media screen and (max-width: 991px) {\n  .w-container {\n    max-width: 728px;\n  }\n\n  .w-hidden-main {\n    display: inherit !important;\n  }\n\n  .w-hidden-medium {\n    display: none !important;\n  }\n\n  .w-col-medium-1 {\n    width: 8.33333%;\n  }\n\n  .w-col-medium-2 {\n    width: 16.6667%;\n  }\n\n  .w-col-medium-3 {\n    width: 25%;\n  }\n\n  .w-col-medium-4 {\n    width: 33.3333%;\n  }\n\n  .w-col-medium-5 {\n    width: 41.6667%;\n  }\n\n  .w-col-medium-6 {\n    width: 50%;\n  }\n\n  .w-col-medium-7 {\n    width: 58.3333%;\n  }\n\n  .w-col-medium-8 {\n    width: 66.6667%;\n  }\n\n  .w-col-medium-9 {\n    width: 75%;\n  }\n\n  .w-col-medium-10 {\n    width: 83.3333%;\n  }\n\n  .w-col-medium-11 {\n    width: 91.6667%;\n  }\n\n  .w-col-medium-12 {\n    width: 100%;\n  }\n\n  .w-col-stack {\n    width: 100%;\n    left: auto;\n    right: auto;\n  }\n}\n\n.w-widget {\n  position: relative;\n}\n\n.w-widget-map {\n  width: 100%;\n  height: 400px;\n}\n\n.w-widget-map label {\n  width: auto;\n  display: inline;\n}\n\n.w-widget-map img {\n  max-width: inherit;\n}\n\n.w-widget-map .gm-style-iw {\n  text-align: center;\n}\n\n.w-widget-map .gm-style-iw>button {\n  display: none !important;\n}\n\n.w-widget-twitter {\n  overflow: hidden;\n}\n\n.w-widget-twitter-count-shim {\n  vertical-align: top;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #758696;\n  border-radius: 3px;\n  width: 28px;\n  height: 20px;\n  display: inline-block;\n  position: relative;\n}\n\n.w-widget-twitter-count-shim * {\n  pointer-events: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.w-widget-twitter-count-shim .w-widget-twitter-count-inner {\n  text-align: center;\n  color: #999;\n  font-family: serif;\n  font-size: 15px;\n  line-height: 12px;\n  position: relative;\n}\n\n.w-widget-twitter-count-shim .w-widget-twitter-count-clear {\n  display: block;\n  position: relative;\n}\n\n.w-widget-twitter-count-shim.w--large {\n  width: 36px;\n  height: 28px;\n}\n\n.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {\n  font-size: 18px;\n  line-height: 18px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical) {\n  margin-left: 5px;\n  margin-right: 8px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large {\n  margin-left: 6px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):before,\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n  content: \" \";\n  pointer-events: none;\n  border: solid #0000;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 50%;\n  left: 0;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):before {\n  border-width: 4px;\n  border-color: #75869600 #5d6c7b #75869600 #75869600;\n  margin-top: -4px;\n  margin-left: -9px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {\n  border-width: 5px;\n  margin-top: -5px;\n  margin-left: -10px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n  border-width: 4px;\n  border-color: #fff0 #fff #fff0 #fff0;\n  margin-top: -4px;\n  margin-left: -8px;\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {\n  border-width: 5px;\n  margin-top: -5px;\n  margin-left: -9px;\n}\n\n.w-widget-twitter-count-shim.w--vertical {\n  width: 61px;\n  height: 33px;\n  margin-bottom: 8px;\n}\n\n.w-widget-twitter-count-shim.w--vertical:before,\n.w-widget-twitter-count-shim.w--vertical:after {\n  content: \" \";\n  pointer-events: none;\n  border: solid #0000;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n}\n\n.w-widget-twitter-count-shim.w--vertical:before {\n  border-width: 5px;\n  border-color: #5d6c7b #75869600 #75869600;\n  margin-left: -5px;\n}\n\n.w-widget-twitter-count-shim.w--vertical:after {\n  border-width: 4px;\n  border-color: #fff #fff0 #fff0;\n  margin-left: -4px;\n}\n\n.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {\n  font-size: 18px;\n  line-height: 22px;\n}\n\n.w-widget-twitter-count-shim.w--vertical.w--large {\n  width: 76px;\n}\n\n.w-background-video {\n  color: #fff;\n  height: 500px;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-logo-img {\n  margin-bottom: 10px;\n}\n\n.plus-icon-white {\n  background: url(../images/mksapp/plus-icon-white.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.add-user-button-top {\n  background-color: #0062ff;\n  padding: 10px;\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.login-main-text {\n  font-size: 47px;\n  font-weight: 700;\n  color: #1f5078;\n  line-height: 55px;\n}\n\n.w-background-video>video {\n  object-fit: inherit;\n  z-index: -100;\n  background-position: 50%;\n  background-size: cover;\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  top: -100%;\n  bottom: -100%;\n  left: -100%;\n  right: -100%;\n}\n\n.login-bg-video {\n  z-index: 1;\n  border-radius: 20px 0 0 20px;\n  flex: 1 1;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n.w-background-video>video::-webkit-media-controls-start-playback-button {\n  -webkit-appearance: none;\n  display: none !important;\n}\n\n.w-background-video--control {\n  background-color: #0000;\n  padding: 0;\n  position: absolute;\n  bottom: 1em;\n  right: 1em;\n}\n\n.w-background-video--control>[hidden] {\n  display: none !important;\n}\n\n.w-slider {\n  text-align: center;\n  clear: both;\n  -webkit-tap-highlight-color: #0000;\n  tap-highlight-color: #0000;\n  background: #ddd;\n  height: 300px;\n  position: relative;\n}\n\n.w-slider-mask {\n  z-index: 1;\n  white-space: nowrap;\n  height: 100%;\n  display: block;\n  position: relative;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.w-slide {\n  vertical-align: top;\n  white-space: normal;\n  text-align: left;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  position: relative;\n}\n\n.w-slider-nav {\n  z-index: 2;\n  text-align: center;\n  -webkit-tap-highlight-color: #0000;\n  tap-highlight-color: #0000;\n  height: 40px;\n  margin: auto;\n  padding-top: 10px;\n  position: absolute;\n  inset: auto 0 0;\n}\n\n.w-slider-nav.w-round>div {\n  border-radius: 100%;\n}\n\n.w-slider-nav.w-num>div {\n  font-size: inherit;\n  line-height: inherit;\n  width: auto;\n  height: auto;\n  padding: 0.2em 0.5em;\n}\n\n.w-slider-nav.w-shadow>div {\n  box-shadow: 0 0 3px #3336;\n}\n\n.w-slider-nav-invert {\n  color: #fff;\n}\n\n.w-slider-nav-invert>div {\n  background-color: #2226;\n}\n\n.w-slider-nav-invert>div.w-active {\n  background-color: #222;\n}\n\n.w-slider-dot {\n  cursor: pointer;\n  background-color: #fff6;\n  width: 1em;\n  height: 1em;\n  margin: 0 3px 0.5em;\n  transition: background-color 0.1s, color 0.1s;\n  display: inline-block;\n  position: relative;\n}\n\n.w-slider-dot.w-active {\n  background-color: #fff;\n}\n\n.w-slider-dot:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px #fff;\n}\n\n.w-slider-dot:focus.w-active {\n  box-shadow: none;\n}\n\n.w-slider-arrow-left,\n.w-slider-arrow-right {\n  cursor: pointer;\n  color: #fff;\n  -webkit-tap-highlight-color: #0000;\n  tap-highlight-color: #0000;\n  -webkit-user-select: none;\n  user-select: none;\n  width: 80px;\n  margin: auto;\n  font-size: 40px;\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.w-slider-arrow-left [class^=\"w-icon-\"],\n.w-slider-arrow-right [class^=\"w-icon-\"],\n.w-slider-arrow-left [class*=\" w-icon-\"],\n.w-slider-arrow-right [class*=\" w-icon-\"] {\n  position: absolute;\n}\n\n.w-slider-arrow-left:focus,\n.w-slider-arrow-right:focus {\n  outline: 0;\n}\n\n.w-slider-arrow-left {\n  z-index: 3;\n  right: auto;\n}\n\n.w-slider-arrow-right {\n  z-index: 4;\n  left: auto;\n}\n\n.menunav {\n  width: 100%;\n  position: relative;\n}\n\n.w-icon-slider-left,\n.w-icon-slider-right {\n  width: 1em;\n  height: 1em;\n  margin: auto;\n  inset: 0;\n}\n\n.w-slider-aria-label {\n  clip: rect(0 0 0 0);\n  border: 0;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.w-slider-force-show {\n  display: block !important;\n}\n\n.w-dropdown {\n  text-align: left;\n  z-index: 900;\n  margin-left: auto;\n  margin-right: auto;\n  display: inline-block;\n  position: relative;\n}\n\n.w-dropdown-btn,\n.w-dropdown-toggle,\n.w-dropdown-link {\n  vertical-align: top;\n  color: #222;\n  text-align: left;\n  white-space: nowrap;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 20px;\n  text-decoration: none;\n  position: relative;\n}\n\n.w-dropdown-toggle {\n  -webkit-user-select: none;\n  user-select: none;\n  cursor: pointer;\n  padding-right: 40px;\n  display: inline-block;\n}\n\n.w-dropdown-toggle:focus {\n  outline: 0;\n}\n\n.w-icon-dropdown-toggle {\n  width: 1em;\n  height: 1em;\n  margin: auto 20px auto auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.w-dropdown-list {\n  background: #ddd;\n  min-width: 100%;\n  display: none;\n  position: absolute;\n}\n\n.w-dropdown-list.w--open {\n  display: block;\n}\n\n.w-dropdown-link {\n  color: #222;\n  padding: 10px 20px;\n  display: block;\n}\n\n.w-dropdown-link.w--current {\n  color: #0082f3;\n}\n\n.w-dropdown-link:focus {\n  outline: 0;\n}\n\n.w-lightbox-backdrop {\n  cursor: auto;\n  letter-spacing: normal;\n  text-indent: 0;\n  text-shadow: none;\n  text-transform: none;\n  visibility: visible;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  color: #fff;\n  text-align: center;\n  z-index: 2000;\n  opacity: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  background: #000000e6;\n  outline: 0;\n  font-family: Helvetica Neue, Helvetica, Ubuntu, Segoe UI, Verdana, sans-serif;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 1.2;\n  list-style: disc;\n  position: fixed;\n  inset: 0;\n  -webkit-transform: translate(0);\n}\n\n.w-lightbox-backdrop,\n.w-lightbox-container {\n  -webkit-overflow-scrolling: touch;\n  height: 100%;\n  overflow: auto;\n}\n\n.w-lightbox-content {\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n}\n\n.w-lightbox-view {\n  opacity: 0;\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n}\n\n.w-lightbox-view:before {\n  content: \"\";\n  height: 100vh;\n}\n\n.w-lightbox-group,\n.w-lightbox-group .w-lightbox-view,\n.w-lightbox-group .w-lightbox-view:before {\n  height: 86vh;\n}\n\n.w-lightbox-frame,\n.w-lightbox-view:before {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.button-use-promp {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.w-lightbox-figure {\n  margin: 0;\n  position: relative;\n}\n\n.w-lightbox-group .w-lightbox-figure {\n  cursor: pointer;\n}\n\n.w-lightbox-img {\n  width: auto;\n  max-width: none;\n  height: auto;\n}\n\n.w-lightbox-image {\n  float: none;\n  max-width: 100vw;\n  max-height: 100vh;\n  display: block;\n}\n\n.w-lightbox-group .w-lightbox-image {\n  max-height: 86vh;\n}\n\n.w-lightbox-caption {\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background: #0006;\n  padding: 0.5em 1em;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.w-lightbox-embed {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n}\n\n.w-lightbox-control {\n  cursor: pointer;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  width: 4em;\n  transition: all 0.3s;\n  position: absolute;\n  top: 0;\n}\n\n.w-lightbox-left {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==\");\n  display: none;\n  bottom: 0;\n  left: 0;\n}\n\n.w-lightbox-right {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+\");\n  display: none;\n  bottom: 0;\n  right: 0;\n}\n\n.w-lightbox-close {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=\");\n  background-size: 18px;\n  height: 2.6em;\n  right: 0;\n}\n\n.w-lightbox-strip {\n  white-space: nowrap;\n  padding: 0 1vh;\n  line-height: 0;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: auto hidden;\n}\n\n.w-lightbox-item {\n  box-sizing: content-box;\n  cursor: pointer;\n  width: 10vh;\n  padding: 2vh 1vh;\n  display: inline-block;\n  -webkit-transform: translate3d(0, 0, 0);\n}\n\n.w-lightbox-active {\n  opacity: 0.3;\n}\n\n.w-lightbox-thumbnail {\n  background: #222;\n  height: 10vh;\n  position: relative;\n  overflow: hidden;\n}\n\n.w-lightbox-thumbnail-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.w-lightbox-thumbnail .w-lightbox-tall {\n  width: 100%;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n\n.w-lightbox-thumbnail .w-lightbox-wide {\n  height: 100%;\n  left: 50%;\n  transform: translate(-50%);\n}\n\n.w-lightbox-spinner {\n  box-sizing: border-box;\n  border: 5px solid #0006;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  margin-top: -20px;\n  margin-left: -20px;\n  animation: 0.8s linear infinite spin;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.w-lightbox-spinner:after {\n  content: \"\";\n  border: 3px solid #0000;\n  border-bottom-color: #fff;\n  border-radius: 50%;\n  position: absolute;\n  inset: -4px;\n}\n\n.w-lightbox-hide {\n  display: none;\n}\n\n.w-lightbox-noscroll {\n  overflow: hidden;\n}\n\n.mobile-header .user-profile-menu {\n  color: #fff;\n  border: 0;\n}\n\n.mobile-header .dash-header {\n  padding: 0;\n  border: 0;\n}\n\n@media (min-width: 768px) {\n  .skill-select-charts {\n    min-width: 330px;\n  }\n\n  .dash-menu.open .left-menu-nav-wrapper a {\n    position: relative;\n  }\n\n  .dash-menu.open .left-menu-nav-wrapper a:hover::after {\n    content: attr(data-title);\n    position: absolute;\n    left: 54px;\n    color: #000;\n    font-size: 11px;\n    line-height: 13px;\n    background: #fff;\n    border: 1px solid #e5e5e5;\n    padding: 3px 9px;\n    border-radius: 5px;\n    z-index: 1;\n    top: 4px;\n    white-space: nowrap;\n  }\n\n  .dash-menu.open .left-menu-nav-wrapper .dropdown-label:hover::after {\n    content: attr(data-title);\n    position: absolute;\n    left: 54px;\n    color: #000;\n    font-size: 11px;\n    line-height: 13px;\n    background: #fff;\n    border: 1px solid #e5e5e5;\n    padding: 3px 9px;\n    border-radius: 5px;\n    z-index: 1;\n    top: 4px;\n  }\n\n  .dash-menu.open .menunav {\n    position: relative;\n  }\n\n  .dash-menu.open .menu-logo {\n    background-image: url(\"../images/mks_logo-icon.png\");\n    width: 32px;\n  }\n\n  .dash-menu.open .left-menu-link {\n    flex-flow: column;\n    padding: 5px;\n  }\n\n  .dash-menu.open .menu-icon {\n    width: 27px;\n  }\n\n  .dash-menu.open .toggle-menu-desk {\n    transform: rotate(180deg);\n  }\n\n  .dash-menu.open .left-menu-header {\n    justify-content: center;\n  }\n\n  .dash-body.expand {\n    width: 100%;\n  }\n\n  .dash-menu.open {\n    width: 70px;\n  }\n\n  .dash-menu.open .menu-link-text {\n    display: none;\n  }\n\n  .mobile-header,\n  .hide-on-desk {\n    display: none;\n  }\n\n  .w-lightbox-content {\n    height: 96vh;\n    margin-top: 2vh;\n  }\n\n  .w-lightbox-view,\n  .w-lightbox-view:before {\n    height: 96vh;\n  }\n\n  .w-lightbox-group,\n  .w-lightbox-group .w-lightbox-view,\n  .w-lightbox-group .w-lightbox-view:before {\n    height: 84vh;\n  }\n\n  .w-lightbox-image {\n    max-width: 96vw;\n    max-height: 96vh;\n  }\n\n  .w-lightbox-group .w-lightbox-image {\n    max-width: 82.3vw;\n    max-height: 84vh;\n  }\n\n  .w-lightbox-left,\n  .w-lightbox-right {\n    opacity: 0.5;\n    display: block;\n  }\n\n  .w-lightbox-close {\n    opacity: 0.8;\n  }\n\n  .w-lightbox-control:hover {\n    opacity: 1;\n  }\n}\n\n.w-lightbox-inactive,\n.w-lightbox-inactive:hover {\n  opacity: 0;\n}\n\n.w-richtext:before,\n.w-richtext:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-richtext:after {\n  clear: both;\n}\n\n.w-richtext[contenteditable=\"true\"]:before,\n.w-richtext[contenteditable=\"true\"]:after {\n  white-space: initial;\n}\n\n.w-richtext ol,\n.w-richtext ul {\n  overflow: hidden;\n}\n\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,\n.w-richtext .w-richtext-figure-selected[data-rt-type=\"video\"] div:after,\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,\n.w-richtext .w-richtext-figure-selected[data-rt-type=\"image\"] div {\n  outline: 2px solid #2895f7;\n}\n\n.w-richtext figure.w-richtext-figure-type-video>div:after,\n.w-richtext figure[data-rt-type=\"video\"]>div:after {\n  content: \"\";\n  display: none;\n  position: absolute;\n  inset: 0;\n}\n\n.w-richtext figure {\n  max-width: 60%;\n  position: relative;\n}\n\n.w-richtext figure>div:before {\n  cursor: default !important;\n}\n\n.w-richtext figure img {\n  width: 100%;\n}\n\n.w-richtext figure figcaption.w-richtext-figcaption-placeholder {\n  opacity: 0.6;\n}\n\n.w-richtext figure div {\n  color: #0000;\n  font-size: 0;\n}\n\n.w-richtext figure.w-richtext-figure-type-image,\n.w-richtext figure[data-rt-type=\"image\"] {\n  display: table;\n}\n\n.w-richtext figure.w-richtext-figure-type-image>div,\n.w-richtext figure[data-rt-type=\"image\"]>div {\n  display: inline-block;\n}\n\n.w-richtext figure.w-richtext-figure-type-image>figcaption,\n.w-richtext figure[data-rt-type=\"image\"]>figcaption {\n  caption-side: bottom;\n  display: table-caption;\n}\n\n.w-richtext figure.w-richtext-figure-type-video,\n.w-richtext figure[data-rt-type=\"video\"] {\n  width: 60%;\n  height: 0;\n}\n\n.w-richtext figure.w-richtext-figure-type-video iframe,\n.w-richtext figure[data-rt-type=\"video\"] iframe {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.w-richtext figure.w-richtext-figure-type-video>div,\n.w-richtext figure[data-rt-type=\"video\"]>div {\n  width: 100%;\n}\n\n.w-richtext figure.w-richtext-align-center {\n  clear: both;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image>div,\n.w-richtext figure.w-richtext-align-center[data-rt-type=\"image\"]>div {\n  max-width: 100%;\n}\n\n.w-richtext figure.w-richtext-align-normal {\n  clear: both;\n}\n\n.w-richtext figure.w-richtext-align-fullwidth {\n  text-align: center;\n  clear: both;\n  width: 100%;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n.w-richtext figure.w-richtext-align-fullwidth>div {\n  padding-bottom: inherit;\n  display: inline-block;\n}\n\n.w-richtext figure.w-richtext-align-fullwidth>figcaption {\n  display: block;\n}\n\n.w-richtext figure.w-richtext-align-floatleft {\n  float: left;\n  clear: none;\n  margin-right: 15px;\n}\n\n.w-richtext figure.w-richtext-align-floatright {\n  float: right;\n  clear: none;\n  margin-left: 15px;\n}\n\n.w-nav {\n  z-index: 1000;\n  background: #ddd;\n  position: relative;\n}\n\n.w-nav:before,\n.w-nav:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-nav:after {\n  clear: both;\n}\n\n.w-nav-brand {\n  float: left;\n  color: #333;\n  text-decoration: none;\n  position: relative;\n}\n\n.w-nav-link {\n  vertical-align: top;\n  color: #222;\n  text-align: left;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 20px;\n  text-decoration: none;\n  display: inline-block;\n  position: relative;\n}\n\n.w-nav-link.w--current {\n  color: #0082f3;\n}\n\n.w-nav-menu {\n  float: right;\n  position: relative;\n}\n\n[data-nav-menu-open] {\n  text-align: center;\n  background: #c8c8c8;\n  min-width: 200px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  overflow: visible;\n  display: block !important;\n}\n\n.w--nav-link-open {\n  display: block;\n  position: relative;\n}\n\n.w-nav-overlay {\n  width: 100%;\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.w-nav-overlay [data-nav-menu-open] {\n  top: 0;\n}\n\n.w-nav[data-animation=\"over-left\"] .w-nav-overlay {\n  width: auto;\n}\n\n.w-nav[data-animation=\"over-left\"] .w-nav-overlay,\n.w-nav[data-animation=\"over-left\"] [data-nav-menu-open] {\n  z-index: 1;\n  top: 0;\n  right: auto;\n}\n\n.w-nav[data-animation=\"over-right\"] .w-nav-overlay {\n  width: auto;\n}\n\n.w-nav[data-animation=\"over-right\"] .w-nav-overlay,\n.w-nav[data-animation=\"over-right\"] [data-nav-menu-open] {\n  z-index: 1;\n  top: 0;\n  left: auto;\n}\n\n.w-nav-button {\n  float: right;\n  cursor: pointer;\n  -webkit-tap-highlight-color: #0000;\n  tap-highlight-color: #0000;\n  -webkit-user-select: none;\n  user-select: none;\n  padding: 18px;\n  font-size: 24px;\n  display: none;\n  position: relative;\n}\n\n.w-nav-button:focus {\n  outline: 0;\n}\n\n.w-nav-button.w--open {\n  color: #fff;\n  background-color: #c8c8c8;\n}\n\n.w-nav[data-collapse=\"all\"] .w-nav-menu {\n  display: none;\n}\n\n.w-nav[data-collapse=\"all\"] .w-nav-button,\n.w--nav-dropdown-open,\n.w--nav-dropdown-toggle-open {\n  display: block;\n}\n\n.w--nav-dropdown-list-open {\n  position: static;\n}\n\n.highlight {\n  color: #6664ff;\n}\n\n.recent-comments {\n  display: flex;\n\n  justify-content: flex-start;\n  text-align: left;\n  margin-bottom: 10px;\n  flex-flow: column;\n  padding: 8px;\n  background: #fff;\n  border-radius: 5px;\n  position: relative;\n  margin-right: 6px;\n}\n\n.new-comment,\n.reply-comment {\n  display: flex;\n  gap: 10px;\n}\n\n.reply-comment {\n  margin-left: 32px;\n  position: relative;\n  padding-left: 15px;\n  margin-left: 18px;\n}\n\n.light-coment-bg {\n  background: #fff;\n}\n\n.comment-actions {\n  display: flex;\n  font-size: 10px;\n  gap: 20px;\n}\n\n.comment-action {\n  cursor: pointer;\n}\n\n.replied::before {\n  content: \"\";\n  background: #e5e5e5;\n  height: 88%;\n  width: 1.5px;\n  position: absolute;\n  top: 24px;\n  left: 11px;\n}\n\n.reply-comment.replied::after {\n  content: \"\";\n  background: #e5e5e5;\n  height: 100%;\n  width: 1.5px;\n  position: absolute;\n  top: 15px;\n  left: -7px;\n}\n\n.reply-comment::before {\n  content: \"\";\n  background: #e5e5e5;\n  height: 2.5px;\n  width: 19px;\n  position: absolute;\n  top: 14px;\n  left: -6px;\n}\n\n.reply-input {\n  border: 1px solid #e5e5e5;\n  font-size: 12px;\n}\n\n.replied {\n  position: relative;\n}\n\n.bold-name {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.user-comment-name {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n.coment-section {\n  background: #f5f5f5;\n  padding: 10px;\n}\n\n.modal-content.comment-modal {\n  background: #f5f5f5;\n}\n\n.delete-prompt-modal .modal-content {\n  max-width: 350px;\n  padding: 0;\n}\n\n.delete-prompt-modal .modal-block {\n  max-width: 350px;\n}\n\n.prompts-action-wrapper .modal-content {\n  background: #f5f5f5;\n}\n\n.text-box {\n  display: flex;\n  width: 100%;\n}\n\n.textwrap {\n  width: 100%;\n  border: 1px solid #e5e5e5;\n  min-height: 40px;\n  resize: none;\n}\n\n.commentdate {\n  font-size: 10px;\n  color: #b1a7a7;\n  display: flex;\n  gap: 7px;\n}\n\n.top-close {\n  position: absolute;\n  right: 11px;\n  top: 7px;\n  cursor: pointer;\n}\n\n.comment-header {\n  margin-top: 0;\n  font-size: 20px;\n  line-height: 25px;\n  margin-bottom: 14px;\n}\n\n.user-coment {\n  font-size: 12px;\n  word-break: auto-phrase;\n  word-wrap: break-word;\n}\n\n.user-table-body {\n  max-height: calc(100vh - 350px);\n  overflow-y: auto;\n}\n\n.no-users-found {\n  padding: 10px;\n  text-align: center;\n}\n\n.reply-comment .user-coment {\n  margin-bottom: 10px;\n}\n\n.submit-btn {\n  background: #053a64;\n  color: #fff;\n  padding: 10px 21px;\n  border-radius: 0 5px 5px 0;\n}\n\n@media screen and (max-width: 991px) {\n  .w-nav[data-collapse=\"medium\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"medium\"] .w-nav-button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .chat-event-btn-wrapper {\n    inset: auto auto 132px !important;\n  }\n\n  .w-nav[data-collapse=\"tiny\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"tiny\"] .w-nav-button {\n    display: block;\n  }\n}\n\n.w-tabs {\n  position: relative;\n}\n\n.w-tabs:before,\n.w-tabs:after {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-tabs:after {\n  clear: both;\n}\n\n.w-tab-menu {\n  position: relative;\n}\n\n.w-tab-link {\n  vertical-align: top;\n  text-align: left;\n  cursor: pointer;\n  color: #222;\n  background-color: #ddd;\n  padding: 9px 30px;\n  text-decoration: none;\n  display: inline-block;\n  position: relative;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.w-tab-link.w--current {\n  background-color: #c8c8c8;\n}\n\n.w-tab-link:focus {\n  outline: 0;\n}\n\n.w-tab-content {\n  display: block;\n  position: relative;\n}\n\n.w-tab-pane {\n  display: none;\n  position: relative;\n}\n\n.w--tab-active {\n  display: block;\n}\n\n@media screen and (max-width: 479px) {\n  .w-tab-link {\n    display: block;\n  }\n}\n\n.w-ix-emptyfix:after {\n  content: \"\";\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.w-dyn-empty {\n  background-color: #ddd;\n  padding: 10px;\n}\n\n.w-dyn-hide,\n.w-dyn-bind-empty,\n.w-condition-invisible {\n  display: none !important;\n}\n\n.wf-layout-layout {\n  display: grid;\n}\n\n.w-code-component>* {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n:root {\n  --black: black;\n  --mks-primary: #226194;\n  --mks-primary-dark: #053a64;\n  --white: white;\n  --mks-blue: #0062ff;\n  --border-grey: #f0f0f0;\n  --darkbg: #161822;\n  --slate-gray: #a4b4c2;\n  --mks-blue-light: #e7f4ff;\n  --dark-bg-2: #20212c;\n  --border-color: #ffffff1a;\n  --purple-font: #6664ff;\n  --green: #00ff91;\n  --purple: #6f00ff;\n  --mks-green: #00d672;\n}\n\n.w-layout-hflex {\n  flex-direction: row;\n  align-items: flex-start;\n  display: flex;\n}\n\n.w-layout-grid {\n  grid-row-gap: 16px;\n  grid-column-gap: 16px;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  display: grid;\n}\n\n.w-checkbox {\n  margin-bottom: 5px;\n  padding-left: 20px;\n  display: block;\n}\n\n.w-checkbox:before {\n  content: \" \";\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-checkbox:after {\n  content: \" \";\n  clear: both;\n  grid-area: 1 / 1 / 2 / 2;\n  display: table;\n}\n\n.w-checkbox-input {\n  float: left;\n  margin: 4px 0 0 -20px;\n  line-height: normal;\n}\n\n.w-checkbox-input--inputType-custom {\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  width: 12px;\n  height: 12px;\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-checked {\n  background-color: #3898ec;\n  background-image: url(\"../images/mksapp/custom-checkbox-checkmark.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-color: #3898ec;\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-focus {\n  box-shadow: 0 0 3px 1px #3898ec;\n}\n\n.flexbox {\n  background-color: #dce1ee;\n  flex-flow: column;\n  height: 100vh;\n  min-height: 100vh;\n  max-height: 100vh;\n  font-family: Poppins, sans-serif;\n  display: flex;\n}\n\n.workspace-dashboard {\n  background-color: #053a64;\n  background-position: 0 0, 50%;\n  background-size: auto, auto;\n  height: 100%;\n  max-height: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-right: 10px;\n  display: flex;\n  overflow: hidden;\n  box-shadow: 0 2px 20px #3e67be33;\n}\n\n.workspace-dashboard.flex-end {\n  padding: 15px;\n}\n\n.dash-menu {\n  border-right: 1px none var(--black);\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 20%;\n  max-height: 100%;\n  display: flex;\n  padding: 0 10px;\n}\n\n.dash-body {\n  background-color: #fff;\n  background-position: 0 0, 50%;\n  background-repeat: repeat, repeat;\n  background-size: auto, auto;\n  border-radius: 10px;\n  flex-flow: column;\n  width: 80%;\n  display: flex;\n  overflow: hidden;\n}\n\n.left-menu-header {\n  border-bottom: 1px solid #c9c9c9;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 0 13px;\n  display: flex;\n}\n\nimg.upload-icon {\n  border-radius: 100%;\n  max-width: 40px;\n  max-height: 40px;\n  height: 40px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.dropdown-items {\n  flex-flow: column;\n}\n\n.red {\n  color: red;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.flex-links {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.left-menu-link:hover .down-arrow {\n  filter: invert(1);\n}\n\n.dash-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 11px 40px;\n  border-bottom: 1px solid #e5e5e5;\n  gap: 10px;\n}\n\n.dash-header h1 {\n  font-size: 27px;\n  font-weight: 400;\n  color: #053a64;\n  line-height: 39px;\n  margin: 0;\n}\n\n.menu-logo {\n  background-image: url(\"../images/mks_logo.png\");\n  background-position: 0%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 85px;\n  min-height: 40px;\n}\n\n.close-panel-button {\n  background-color: var(--mks-primary);\n  background-image: url(\"../images/mksapp/left-double-arrow-icon-white.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 7px;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  width: 19px;\n  height: 33px;\n  display: none;\n}\n\n.close-panel-button:hover {\n  background-color: var(--mks-primary-dark);\n}\n\n.left-menu-nav-wrapper {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  flex-flow: column;\n  flex: 1;\n  width: 100%;\n  padding-right: 10px;\n  display: flex;\n  padding: 10px 0;\n}\n\n.left-menu-link {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  color: #fff;\n  border-radius: 4px;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: 7px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  display: flex;\n}\n\n.left-menu-link:hover {\n  background-color: #ffffff;\n  color: #053a64;\n  border-radius: 40px;\n}\n\n.left-menu-link.w--current .menu-icon {\n  filter: invert(1);\n}\n\n.left-menu-link:hover .menu-icon {\n  filter: invert(1);\n}\n\n.left-menu-link.w--current {\n  background-color: #ffffff;\n  color: #053a64;\n  border-radius: 40px;\n}\n\n.menu-icon {\n  width: 22px;\n}\n\n.dash-page-header {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 15px 25px;\n  display: flex;\n}\n\n.dash-page-header.light-bg {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  padding-left: 60px;\n  padding-right: 60px;\n}\n\n.h1 {\n  color: #81a5c2;\n  margin-top: 10px;\n  font-size: 32px;\n  font-weight: 300;\n  line-height: 39px;\n}\n\n.color-span {\n  color: #053a64;\n  font-weight: 500;\n}\n\n.paragraph {\n  color: var(--mks-primary-dark);\n  margin-bottom: 0;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 15px;\n}\n\n.dash-section.p20 {\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n.paragraph.medium {\n  font-size: 0.9rem;\n}\n\n.paragraph.large {\n  font-size: 1rem;\n}\n\n.paragraph.small {\n  font-size: 0.7rem;\n  margin-bottom: 15px;\n}\n\n.dash-section {\n  grid-column-gap: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n  flex-flow: column;\n\n  display: flex;\n  position: relative;\n  grid-row-gap: 20px;\n}\n\n.dash-section.light-bg {\n  background-color: #fff;\n  padding: 15px 20px;\n}\n\n.chat-tablink {\n  color: #afacac;\n  background-color: transparent;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.chat-tablink.w--current {\n  opacity: 1;\n  color: #ffffff;\n  background-color: #053a64;\n}\n\n.chat-tab-menu {\n  grid-column-gap: 4px;\n  grid-row-gap: 4px;\n  background-color: #a1acdd40;\n  border-radius: 40px;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 5px;\n  display: flex;\n}\n\n.chat-tablink {\n  border-radius: 100px;\n}\n\n.chat-tabs.w-tabs {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-tab-pane {}\n\n.utility-page-wrap {\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  max-width: 100%;\n  height: 100vh;\n  max-height: 100%;\n  display: flex;\n}\n\n.utility-page-content {\n  text-align: center;\n  flex-direction: column;\n  width: 260px;\n  display: flex;\n}\n\n.utility-page-form {\n  flex-direction: column;\n  align-items: stretch;\n  display: flex;\n}\n\n.chat-flex {\n  display: flex;\n  gap: 10px;\n}\n\n.chat-select {\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  padding: 3px 6px;\n  font-size: 13px;\n}\n\n.chat-select:focus-visible {\n  outline: 0;\n}\n\n.chat-form-wrapper {\n  margin-bottom: 0;\n}\n\n.chat-field-wrapper {\n  grid-column-gap: 8px;\n  grid-row-gap: 8px;\n  justify-content: flex-start;\n  align-items: flex-end;\n  display: flex;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.chat-button {\n  background-color: var(--mks-blue);\n  background-image: url(\"../images/mksapp/chat-icon-white.svg\");\n  background-position: 14px;\n  background-repeat: no-repeat;\n  background-size: 23px;\n  border-radius: 7px;\n  padding-left: 44px;\n  padding-right: 15px;\n  font-size: 11px;\n}\n\n.chat-input-field {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  margin-bottom: 0;\n  background: #f7f7f7;\n}\n\n.prompt-icon {\n  display: flex;\n  gap: 10px;\n}\n\n.prompt-icon::before {\n  content: \"\";\n  background: url(../images/prompt-suggetion.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  display: block;\n}\n\n.pl20 {\n  padding: 0 20px;\n}\n\n.h2 {\n  color: var(--mks-primary-dark);\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 19px;\n  font-weight: 500;\n  line-height: 27px;\n}\n\n.h-flex {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.h-flex.head-wrapper {\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.h-flex.head-wrapper.input-workspace {\n  position: absolute;\n  right: 0;\n  padding: 8px 10px 8px 24px;\n  width: calc(100% - 140px);\n}\n\n.flex-workspace {\n  display: flex;\n  align-items: center;\n}\n\n.text-link {\n  color: var(--white);\n  background-color: #6664ff4a;\n  border-radius: 6px;\n  padding: 5px 18px;\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.ai-collection-grid {\n  grid-column-gap: 15px;\n  grid-row-gap: 15px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr;\n  justify-content: start;\n}\n\n.ai-collection-link-block {\n  grid-column-gap: 6px;\n  grid-row-gap: 6px;\n  background: #ffffff;\n  border-radius: 11px;\n  flex-flow: column;\n  justify-content: space-between;\n  padding: 10px;\n  text-decoration: none;\n  display: flex;\n  box-shadow: 2px 2px 53px #ededed;\n  /* cursor: pointer; */\n}\n\n.numeric-input::-webkit-outer-spin-button,\n.numeric-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\n.numeric-input[type=\"number\"] {\n  -moz-appearance: textfield;\n  width: 100px;\n}\n\n.h3 {\n  color: var(--mks-primary);\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.3rem;\n}\n\n.center-grid {\n  grid-template-columns: 1fr;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.skill-center-grid {\n  grid-template-columns: 1fr;\n  text-align: center;\n}\n\n.center-grid-search {\n  grid-template-columns: 1fr;\n  text-align: center;\n}\n\n.center-align-text {\n  grid-template-columns: 1fr;\n  text-align: center;\n  margin-top: 12px;\n  border-radius: 5px 5px 5px 5px;\n}\n\n.h3.small {\n  font-size: 12px;\n  line-height: 1.2rem;\n  width: 79%;\n}\n\n.ai-collection-info-block {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  background-color: #fff;\n  border-radius: 10px;\n  flex-flow: column;\n  flex: 1 1;\n  display: flex;\n  position: relative;\n  cursor: pointer;\n  justify-content: space-between;\n}\n\n.numeric-input-box {\n  width: 100px !important;\n}\n\n.ai-block-header {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  height: 48px;\n  margin-bottom: 10px;\n  display: flex;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.ai-block-header .h3.small,\n.normal-link.long-title {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 250px;\n}\n\n.breadcrumb {\n  position: relative;\n}\n\n.ai-block-header .h3.small.long-title:hover::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-right: 11px solid transparent;\n  border-left: 11px solid transparent;\n  border-bottom: 11px solid #f6f6f6;\n  border-top: 0;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  top: 33px;\n  bottom: auto;\n}\n\n.ai-block-header .h3.small.long-title:hover::after {\n  content: attr(data-title);\n  position: absolute;\n  left: 0px;\n  color: #000;\n  font-weight: 400;\n  font-size: 9px;\n  line-height: 16px;\n  background: #f7f7f7;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n  width: auto;\n  top: 41px;\n  height: max-content;\n  right: 0;\n  white-space: normal;\n  word-break: break-all;\n}\n\n.normal-link.long-title:hover::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  border-right: 11px solid #f6f6f6;\n  right: 0;\n  left: 504px;\n  position: absolute;\n  top: 23px;\n  bottom: auto;\n}\n\n.normal-link.long-title:hover::after {\n  content: attr(data-title);\n  position: absolute;\n  left: 513px;\n  color: #000;\n  font-weight: 400;\n  font-size: 9px;\n  line-height: 16px;\n  background: #f7f7f7;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n  width: 250px;\n  top: 23px;\n  height: max-content;\n  right: 0;\n  white-space: normal;\n  display: block;\n  opacity: 1;\n  word-break: break-all;\n}\n\n.ai-block-icon {\n  width: 30px;\n  height: 30px;\n}\n\n.copy-clipboard {\n  background: url(../images/copy-content.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  position: absolute;\n  right: -22px;\n  top: 9px;\n}\n\n.keyword-block {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.skill-keyword {\n  color: var(--mks-primary);\n  white-space: nowrap;\n  background-color: #22619424;\n  border-radius: 24px;\n  padding: 4px 10px;\n  font-size: 8px;\n  font-weight: 500;\n  line-height: 12px;\n}\n\n.button {\n  background-color: var(--mks-blue);\n  color: var(--white);\n  border-radius: 40px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.button-newchat-disabled {\n  background-color: var(--border-grey);\n  color: #bdbdbd;\n  border-radius: 40px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 10px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin: 7px;\n  border-radius: 5px;\n  cursor: default;\n}\n\n.aligned-margin {\n  margin: 0 7px;\n}\n\n.button.text {\n  color: var(--mks-blue);\n  background-color: #6664ff00;\n  border-radius: 5px;\n}\n\n.button.text:hover {\n  background-color: #a4b4c23d;\n}\n\n.button.icon {\n  background-image: url(\"../images/mksapp/plus-icon-white.svg\");\n  background-position: 15px;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  padding-left: 40px;\n}\n\n.new-chatbutton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin: 8px 0;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.plusimg {\n  width: 12px;\n}\n\n.ai-button-wrapper {\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px 9px 7px;\n  display: flex;\n  border-radius: 5px;\n  background-color: #f5f5f5;\n}\n\n.check-icon {\n  width: 15px;\n  height: 15px;\n}\n\n.skill-checkbox-wrapper {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 12px;\n  display: flex;\n}\n\n.dashboard-wrapper {\n  flex-flow: column;\n  padding-bottom: 40px;\n  display: flex;\n  overflow: auto;\n  height: 80vh;\n}\n\n.dashboard-wrapper-full {\n  flex-flow: column;\n  padding-bottom: 10px;\n  display: flex;\n  overflow: auto;\n  height: 100vh;\n}\n\n.chat-terminal-wrapper {\n  grid-column-gap: 2px;\n  grid-row-gap: 2px;\n  flex-flow: row;\n  min-height: calc(100% - 92px);\n  max-height: 100%;\n  display: flex;\n  /* overflow: hidden; */\n  position: relative;\n}\n\n.chat-terminal-header {\n  grid-column-gap: 4px;\n  grid-row-gap: 4px;\n  background-color: #a1acdd40;\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 5px;\n  display: flex;\n}\n\n.chat-box-wrapper {\n  grid-column-gap: 15px;\n  grid-row-gap: 15px;\n  flex-flow: column;\n  flex: 1;\n  padding-top: 10px;\n  display: flex;\n}\n\n.chat-history {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n\n  flex-flow: column;\n\n  display: flex;\n}\n\n.chatbox {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  flex-flow: column;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  padding-bottom: 70px;\n  padding-left: 25px;\n  padding-right: 25px;\n  display: flex;\n  position: relative;\n  overflow: auto;\n}\n\n.chatprompt-block {\n  margin-bottom: 0;\n  padding: 20px 0;\n}\n\n.chat-msg {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  border-radius: 10px;\n  /* justify-content: space-between; */\n  width: 100%;\n  padding: 12px 5px 12px 20px;\n  display: flex;\n}\n\n.chat-bottom-line {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.chat-msg.user .chat-icon-text {\n  border-radius: 20px 0;\n  background: #e2e6ed;\n  margin-right: 0;\n\n  word-break: auto-phrase;\n  word-wrap: break-word;\n}\n\n.chat-msg.reply {\n  /* background-color: #fff; */\n  align-items: flex-start;\n}\n\n.prompt-mobile-wrap {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n}\n\n.chat-msg.user {\n  flex-flow: row-reverse;\n  align-items: baseline;\n}\n\n.not-sent-icon {\n  display: flex;\n  background: red;\n  color: #fff;\n  width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  min-width: 18px;\n}\n\n.chat-user-icon {\n  border-radius: 1000px;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n}\n\n.msg-text {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  flex-flow: column;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: flex-start;\n  font-size: 12px;\n  display: flex;\n}\n\n.msg-icon-wrapper {\n  grid-column-gap: 3px;\n  grid-row-gap: 3px;\n  padding-left: 4px;\n  padding-right: 4px;\n  display: flex;\n}\n\n.chat-icon-text {\n  display: flex;\n  gap: 10px;\n  flex-flow: column;\n  background: #f2f4f8;\n  padding: 10px;\n  border-radius: 0 20px;\n  margin-right: 63px;\n  word-break: break-all;\n  position: relative;\n}\n\n.chat-text {\n  color: var(--darkbg);\n  margin-bottom: 0;\n  font-size: 11px;\n  line-height: 17px;\n  word-break: break-word;\n}\n\n.chat-text p {\n  display: inline;\n}\n\n.chat-text li {\n  list-style-position: inside;\n}\n\n.chat-user-img {\n  border-radius: 100px;\n  width: 100%;\n}\n\n.msg-time {\n  color: var(--mks-primary-dark);\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 14px;\n}\n\n.terminal-button {\n  background-color: var(--border-grey);\n  color: #bdbdbd;\n  border-radius: 5px;\n  padding-left: 36px;\n  padding-right: 36px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.terminal-button:hover {\n  font-weight: 500;\n}\n\n.terminal-button.w--current {\n  background-color: var(--mks-primary-dark);\n  color: #fff;\n}\n\n.chat-event-button {\n  background-color: #053a64;\n  border-radius: 5px;\n  font-size: 12px;\n}\n\n.user-img-dashbord-icon {\n  background: url(../images/user-dashboard-image.svg);\n  width: 80px;\n  height: 80px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.chats-img-dashbord-icon {\n  background: url(../images/chat-dashboard-image.svg);\n  width: 80px;\n  height: 80px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.session-img-dashbord-icon {\n  background: url(../images/session-dashboard-image.svg);\n  width: 80px;\n  height: 80px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.location-img-dashbord-icon {\n  background: url(../images/location-dashboard-image.svg);\n  width: 80px;\n  height: 80px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.overview-dash-wrap {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.overview-card {\n  width: 100%;\n  border: 1px solid #e5e5e5;\n  padding: 13px;\n  border-radius: 10px;\n  box-shadow: 2px 2px 10px #e5e5e5;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.large-font {\n  font-size: 43px;\n  font-weight: 600;\n  color: #053a64;\n  line-height: 45px;\n}\n\n.small-font {\n  font-size: 13px;\n  color: #666;\n}\n\n.overview-text {\n  display: flex;\n  flex-flow: column;\n  gap: 5px;\n}\n\n.chat-event-button:hover {\n  background-color: #467299;\n}\n\n.chat-event-button.stop-generate {\n  background-image: url(\"../images/mksapp/circle-stop-white.svg\");\n  background-position: 10px;\n  background-repeat: no-repeat;\n  background-size: auto;\n  padding-left: 36px;\n}\n\n.chat-event-button.regenarate {\n  background-color: var(--slate-gray);\n  background-image: url(\"../images/mksapp/regenerate-icon-white.svg\");\n  background-position: 16px;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  padding-left: 40px;\n}\n\n.chat-event-button.regenarate:hover {\n  background-color: #a4b4c2;\n  background-image: url(\"../images/mksapp/regenerate-icon-white.svg\"),\n    linear-gradient(#fff0 84%, #83909e);\n  background-position: 16px, 0 0;\n  background-repeat: no-repeat, repeat;\n  background-size: 14px, auto;\n}\n\n.chat-event-btn-wrapper {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  justify-content: center;\n  align-items: center;\n  padding: 7px;\n  display: flex;\n  position: fixed;\n  inset: auto auto 133px;\n}\n\n.prompt-skill {\n  position: relative;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.gap-3 {\n  gap: 1rem;\n}\n\n.prompt-skill:hover::after {\n  content: attr(data-title);\n  position: absolute;\n  left: 54px;\n  color: #000;\n  font-size: 11px;\n  line-height: 13px;\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n}\n\n.chatprompt-form {\n  background-color: var(--white);\n  border-radius: 10px;\n  justify-content: flex-start;\n  align-items: flex-end;\n  padding-left: 20px;\n  display: flex;\n  position: relative;\n}\n\n.chatprompt-button {\n  background-color: var(--mks-blue);\n  background-image: url(\"../images/mksapp/icon-send-white.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 17px;\n  border-radius: 7px;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  position: relative;\n}\n\n.chatprompt-button:hover {\n  background-color: #115fdd;\n}\n\n.chatprompt-field {\n  border: 1px solid #fff;\n  border-radius: 5px;\n  flex: 1;\n  min-height: 40px;\n  margin-bottom: 0;\n  margin-left: -12px;\n  margin-right: -12px;\n  padding-left: 29px;\n  padding-right: 29px;\n}\n\n.chatprompt-field:active {\n  background-color: #eee;\n  border-color: #fff;\n}\n\n.chatprompt-field:focus {\n  background-color: #dbdff5;\n  border-color: #fff;\n}\n\n.chatprompt-field-label {\n  background-color: var(--mks-primary-dark);\n  color: #fff;\n  border-radius: 5px;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  margin-bottom: 0;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  display: flex;\n  position: relative;\n  width: 120px;\n  cursor: pointer;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.full-height.auto {\n  height: auto;\n}\n\n.skill-info-wrapper {\n  position: absolute;\n  bottom: 52px;\n  width: 250px;\n  background: #f6f6f6;\n  color: #000;\n  padding: 10px;\n  border-radius: 10px;\n  left: 112px;\n  z-index: 4;\n\n  transition: 0.3s;\n}\n\n.skill-info-wrapper.top-position {\n  top: 60px;\n  bottom: auto;\n}\n\n.skill-mention {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n.chat-down-triangle {\n  width: 0;\n  height: 0;\n  border-right: 11px solid transparent;\n  border-left: 11px solid transparent;\n  border-top: 11px solid #f6f6f6;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  /* top: 4px; */\n  bottom: -11px;\n}\n\n.skill-info-wrapper.top-position .chat-down-triangle {\n  width: 0;\n  height: 0;\n  border-right: 11px solid transparent;\n  border-left: 11px solid transparent;\n  border-bottom: 11px solid #f6f6f6;\n  border-top: 0;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  top: -10px;\n  bottom: auto;\n}\n\n.hoverteaxt {\n  width: 100%;\n  display: flex;\n}\n\n.skill-desc-popup {\n  font-size: 11px;\n  line-height: 15px;\n}\n\n.chat-icon-link {\n  opacity: 0.45;\n  background-image: url(\"../images/mksapp/copy-icon-line-dark.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 13px;\n  width: 20px;\n  min-width: 10px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.home-chat-field {\n  margin-left: -10px;\n  border-radius: 0 6px 6px 0;\n  height: 40px;\n}\n\n.chat-icon-link:hover {\n  opacity: 1;\n}\n\n.chat-icon-link.thumbs-up {\n  background-image: url(\"../images/mksapp/thumbs-up-line-dark.svg\");\n}\n\n.chat-icon-link.thumbs-dwn {\n  background-image: url(\"../images/mksapp/thumbs-down-line-dark.svg\");\n}\n\n.chat-icon-link.edit {\n  background-image: url(\"../images/mksapp/edit-outline-icon-dark.svg\");\n}\n\n.expand-history-btn {\n  cursor: pointer;\n  background-color: #e2e9f0;\n  background-image: url(\"../images/rightpannel.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 18px;\n  border-radius: 3px;\n  width: 25px;\n  height: 25px;\n  margin-bottom: 5px;\n}\n\n.expand-history-btn.rotate {\n  transform: rotate(180deg);\n}\n\n.expand-checklist-btn {\n  cursor: pointer;\n  background-color: #e2e9f0;\n  background-image: url(\"../images/checklist.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 18px;\n  border-radius: 3px;\n  width: 25px;\n  height: 25px;\n  margin-bottom: 5px;\n}\n\n.control-section {\n  height: 75vh;\n  overflow: auto;\n}\n\n.pdf-expand {\n  cursor: pointer;\n  background-color: #e2e9f0;\n  background-image: url(\"../images/mksapp/left-expand-icon-dark.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  border-radius: 3px;\n  width: 25px;\n  height: 30px;\n  position: absolute;\n  left: -25px;\n  transform: rotate(180deg);\n}\n\n.pdf-error-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  /* Ensures some space even if container is small */\n  background-color: #fff4f4;\n  border: 1px solid #f5c2c7;\n  border-radius: 8px;\n  color: #842029;\n  font-size: 15px;\n  font-weight: 500;\n  text-align: center;\n  padding: 16px 24px;\n  margin: 12px 0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.pdf-error-message p {\n  margin: 0;\n  line-height: 1.5;\n}\n\n.pdf-full-expand {\n  width: 737px;\n  position: fixed;\n  right: 20px;\n  transition: 0.3s;\n  top: 22px;\n  background: #fff;\n  height: calc(100vh - 57px);\n  box-shadow: 2px 2px 10px #b5b2b2;\n}\n\n.pdf-full-expand.hide .pdfview.overlap {\n  display: none;\n}\n\n.pdf-full-expand.hide {\n  width: auto;\n  position: static;\n  height: auto;\n}\n\n.pdf-full-expand.hide .pdf-expand {\n  position: absolute;\n  background-image: url(\"../images/pdf.png\");\n  box-shadow: none;\n  transform: rotate(0deg);\n  top: 61px;\n  right: 0;\n  left: auto;\n}\n\n.expand-history-btn.hide {\n  display: none;\n}\n\n.chat-history.pdfhide {\n  display: none;\n}\n\n.expand-checklist-btn.hide {\n  display: none;\n}\n\n.expand-history-btn.left-shift {\n  left: -30px;\n  transform: rotate(0);\n}\n\n.chat-section {\n  position: relative;\n  padding: 7px 0 0 0;\n  width: 53px;\n}\n\n.userchat {\n  font-size: 12px;\n  padding: 10px 0;\n}\n\n.chat-section .chat-history-sec {\n  display: none;\n}\n\n.chat-section.auto .chat-history-sec {\n  display: block;\n}\n\n.recent-history {\n  padding: 10px 0;\n  margin-bottom: 10px;\n  max-height: calc(100vh - 210px);\n  overflow: auto;\n}\n\n.limit-skill-display {\n  grid-area: 1 / span 4;\n}\n\n.checkbox-list {\n  display: none;\n}\n\n.checkbox-list.show {\n  width: 310px;\n  padding: 17px;\n  height: 100%;\n  box-shadow: 2px 2px 10px #d7cccc;\n  display: block;\n}\n\n.checkrow {\n  display: flex;\n  gap: 10px;\n}\n\n.toggle-areas {\n  display: flex;\n  justify-content: flex-end;\n  flex-flow: column;\n  align-items: flex-end;\n  margin: 5px;\n  position: absolute;\n  left: -41px;\n}\n\n.chat-right {\n  position: absolute;\n  right: 0;\n  height: 100%;\n  background: #fff;\n  top: 0;\n}\n\n.chat-history-sec {\n  padding: 20px;\n  height: 100%;\n  box-shadow: 2px 2px 10px #d7cccc;\n\n  display: none;\n}\n\n.chat-history-sec.show {\n  display: block;\n  width: 284px;\n}\n\n.pdfview.overlap {\n  position: absolute;\n  width: 733px;\n  right: 0px;\n  height: calc(100vh - 300px);\n  max-height: calc(100vh - 300px);\n  transition: 0.3s;\n  z-index: 1;\n}\n\n.inner-tab-content {\n  padding: 10px 30px 20px 30px;\n  max-height: calc(100vh - 131px);\n  overflow-y: auto;\n}\n\n.prompt-tabs.w-tabs.hide {\n  display: none;\n}\n\n.text-wrap h3 {\n  margin: 0;\n  font-size: 14px;\n}\n\n.text-wrap p {\n  font-size: 12px;\n}\n\n.pdfview.hide {\n  display: none;\n}\n\n.inner-tab-content .text-wrap {\n  word-wrap: break-word;\n}\n\n.chat-section.auto {\n  width: 25%;\n}\n\n.chat-history.hide {\n  display: none;\n}\n\n.expand-history-btn:hover {\n  background-color: var(--mks-primary);\n  background-image: url(\"../images/rightpanel-white.svg\");\n}\n\n.userintro {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.userintro p {\n  margin-bottom: 0;\n}\n\n.wavy-hand {\n  background-image: url(../images/common/waving-hand-emoji.png);\n  width: 25px;\n  background-size: 100%;\n  height: 30px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.bookmark-icon {\n  background: url(../images/bookmark.svg);\n  width: 25px;\n  background-size: 100%;\n  height: 25px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.flex-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start {\n  display: flex;\n  gap: 8px;\n}\n\n.flex-start .down-arrow {\n  cursor: pointer;\n}\n\n.down-arrow.rotate {\n  transform: rotate(180deg);\n}\n\n.history-box {\n  text-align: center;\n  display: none;\n}\n\n.history-box.show {\n  display: block;\n  padding-left: 21px;\n}\n\n.recent-history-title {\n  border-radius: 5px;\n  padding: 5px 8px;\n  text-align: left;\n}\n\n.font-bold {\n  font-weight: 600;\n  font-size: 11px;\n  margin-left: 7px;\n}\n\n.recent-history-title:hover {\n  background: #f5f5f5;\n  cursor: pointer;\n}\n\n.history-box p {\n  margin-bottom: 0;\n}\n\n.button-newchat-disabled img {\n  filter: invert(0.3);\n}\n\n.collapse-div {\n  font-size: 12px;\n  margin-bottom: 15px;\n}\n\n.h4 {\n  color: var(--mks-primary-dark);\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.button-wrapper {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n}\n\n.canvas-wrap canvas {\n  width: 100%;\n}\n\n.icon-button {\n  grid-column-gap: 12px;\n  grid-row-gap: 12px;\n  background-color: var(--mks-blue);\n  color: var(--white);\n  background-image: url(\"../images/mksapp/background-image.svg\");\n  background-position: 15%;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  border-radius: 40px;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  padding: 0.6rem 0 0.6rem 20px;\n  font-size: 10px;\n  font-weight: 500;\n  text-decoration: none;\n  display: flex;\n}\n\n.button:hover,\n.icon-button.add:hover {\n  background-color: #0d4eb7;\n}\n\n.prompt-action-icon:hover {\n  filter: drop-shadow(2px 2px 4px #226194);\n}\n\n.icon-button.light {\n  color: var(--darkbg);\n  background-color: #e7f4ff;\n}\n\n.ai-collection-link-block:hover {\n  box-shadow: 2px 2px 23px #b9b2b2;\n}\n\n.icon-button.light.add-folder {\n  background-color: var(--mks-blue-light);\n  color: var(--mks-primary-dark);\n  background-image: url(\"../images/mksapp/folder-plus-icon-dark.svg\");\n}\n\n.icon-button.light.add-folder:hover {\n  background-color: #e3effa;\n}\n\n.icon-button.add {\n  background-image: url(\"../images/mksapp/plus-icon-white.svg\");\n  background-size: 12px;\n}\n\n.btn-icon {\n  width: 12px;\n  height: 12px;\n}\n\n.search-history {\n  margin-bottom: 0;\n  display: flex;\n}\n\n.search-btn {\n  background-color: var(--white);\n  background-image: url(\"../images/mksapp/search-icon-dark.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 15px;\n  border-radius: 5px;\n  width: 30px;\n  height: 30px;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: -35px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.search-btn:hover {\n  background-color: var(--border-grey);\n}\n\n.search-input-field {\n  color: var(--dark-bg-2);\n  border: 1px solid #d4d4d4;\n  border-radius: 5px;\n  margin-bottom: 0;\n  padding-right: 35px;\n}\n\n.search-input-field::placeholder {\n  font-size: 11px;\n}\n\n.history-block-wrapper {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  flex-flow: column;\n  display: flex;\n}\n\n.chat-history-link-block {\n  opacity: 0.45;\n  color: var(--mks-primary-dark);\n  background-color: #fff;\n  background-image: url(\"../images/mksapp/chatbubble-dark.svg\");\n  background-position: 9px;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  border-radius: 5px;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 11px 10px 11px 30px;\n  text-decoration: none;\n  display: flex;\n}\n\n.chat-history-link-block:hover {\n  background-color: #f2f4f8;\n}\n\n.chat-history-link-block.w--current {\n  opacity: 1;\n  background-color: #f2f4f8;\n  background-image: url(\"../images/mksapp/chatbubble-active.svg\");\n}\n\n.chat-history-link-block.is-active {\n  background-color: #f2f4f8;\n}\n\n.left-user-settings {\n  position: relative;\n  justify-content: end;\n  display: flex;\n}\n\n.left-user-settings {\n  padding-bottom: 0;\n}\n\n.user-profile-menu {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  color: #000;\n  border-top: 1px solid #fff3;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  font-size: 12px;\n  text-decoration: none;\n  display: flex;\n}\n\n.dash-header h1 span {\n  color: #0063ff;\n}\n\n.user-profile-initial {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #80ce1a;\n  border-radius: 50%;\n  width: 37px;\n  height: 37px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  cursor: pointer;\n}\n\n.user-profile-initial:hover {\n  background-color: #80ce1a;\n}\n\n.user-update-prompt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0665ff;\n  border-radius: 50%;\n  width: 37px;\n  height: 37px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  cursor: pointer;\n}\n\n.user-update-prompt:hover {\n  background-color: #0665ff;\n}\n\n.left-bottom-menu-nav {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  border-bottom: 1.3px solid #000;\n  flex-flow: column;\n  padding-bottom: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  display: flex;\n}\n\n.custom-example.search-input-field {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  padding-left: 10px;\n}\n\n.user-dot-menu {\n  grid-column-gap: 3px;\n  grid-row-gap: 3px;\n  opacity: 0.5;\n  flex-flow: column;\n  margin-left: auto;\n  padding: 12px 15px;\n  display: flex;\n  cursor: pointer;\n}\n\n.user-menu-dot {\n  background-color: #000;\n  border-radius: 100px;\n  width: 4px;\n  height: 4px;\n}\n\n.welcome-wrapper {\n  grid-column-gap: 6px;\n  grid-row-gap: 6px;\n  text-align: center;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: 15px 33px;\n  display: flex;\n}\n\n.hi-icon {\n  width: 20px;\n}\n\n.check-contain.font-display-streaming {\n  font-weight: 400;\n  font-size: 17px;\n}\n\n.check-contain.font-display-streaming .checkmark-check {\n  top: 0;\n}\n\n.check-contain.font-display-streaming p {\n  font-size: 17px;\n  margin-left: 8px;\n  font-weight: 500;\n}\n\n.welcome-h-flex {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  justify-content: center;\n  align-items: center;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.prompt-sample-wrapper {\n  grid-column-gap: 11px;\n  grid-row-gap: 11px;\n  flex-flow: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  display: flex;\n}\n\n.sample-prompts {\n  color: var(--mks-primary-dark);\n  background-color: #eaedf09e;\n  background-image: linear-gradient(#0000 88%, #dce2e7);\n  border: 1px solid #e8ebec;\n  border-top-color: #fff;\n  border-radius: 100px;\n  padding: 8px 20px;\n  font-size: 12px;\n  text-decoration: none;\n}\n\n.sample-prompts:hover {\n  background-color: #dae4ec9e;\n}\n\n.section-wrapper {\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  flex-flow: column;\n  padding: 20px 40px;\n  display: flex;\n}\n\n.skill-icon-block .ai-block-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.skill-filter-wrapper {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  border-bottom: 1.5px solid var(--border-grey);\n  background-color: var(--white);\n  margin-bottom: 0;\n  padding: 17px 0px;\n  display: flex;\n  border-radius: 10px;\n}\n\n.prompts-tabs-content .skill-filter-wrapper {\n  padding: 17px 0;\n}\n\n.skill-filter-field {\n  border: 1px solid var(--border-color);\n  color: #7a7a7a;\n  background-color: #f5f7f8;\n  border-radius: 5px;\n  flex: 1;\n  min-height: 35px;\n  margin-bottom: 0;\n  padding: 10px 30px 10px 10px;\n  font-size: 11px;\n  display: flex;\n}\n\n.skill-filter-field::placeholder {\n  color: #7a7a7a;\n}\n\n.skill-filter-form {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  flex: 1;\n  display: flex;\n  /* display: grid;\n    grid-template-columns: 21% 20% 25% 30%; */\n}\n\n.prompts-tabs-content .search-cross-icon-common {\n  width: 290px;\n}\n\n.tabs-menu.h-flex.head-wrapper {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.input-search-box {\n  margin-right: 12px;\n  position: relative;\n}\n\n.search-tile-icon {\n  background: url(\"../images/common/mks_search_icon.svg\");\n  position: absolute;\n  right: 5px;\n  top: 0;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  width: 18px;\n  height: 37px;\n  background-position: center;\n}\n\n.search-tile-icon-common {\n  background: url(\"../images/common/mks_search_icon.svg\");\n  position: absolute;\n  top: 0;\n  right: 8px;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  width: 18px;\n  height: 37px;\n  background-position: center;\n}\n\n.search-cross-icon-common {\n  position: relative;\n}\n\n.search-tile-box {\n  background-repeat: no-repeat;\n  background-position: 99% 50%;\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  padding: 7px 30px 7px 10px;\n  width: 100%;\n  outline: none;\n}\n\n.cross-tile-box {\n  background-image: url(\"../images/common/close-circle-outline.svg\");\n  background-repeat: no-repeat;\n  background-position: 99% 50%;\n  border-radius: 5px;\n  padding: 7px 10px;\n  width: 100%;\n  outline: none;\n  position: absolute;\n  right: 4px;\n  top: 11px;\n  cursor: pointer;\n  top: 0;\n  height: 37px;\n}\n\n.cross-tile-box-workspace {\n  background-image: url(\"../images/common/close-circle-outline.svg\");\n  background-repeat: no-repeat;\n  background-position: 98% 50%;\n  border-radius: 5px;\n  padding: 7px 10px;\n  /* width: 100%; */\n  outline: none;\n  position: absolute;\n  right: 4px;\n  top: 11px;\n  cursor: pointer;\n  top: 0;\n  height: 37px;\n}\n\n.cross-tile-box-common {\n  background-image: url(\"../images/common/close-circle-outline.svg\");\n  background-repeat: no-repeat;\n  background-position: 99% 50%;\n  border-radius: 5px;\n  padding: 7px 10px;\n  outline: none;\n  position: absolute;\n  right: 4px;\n  top: 11px;\n  cursor: pointer;\n  top: 0;\n  height: 37px;\n}\n\n.flex-col .pagination-container .pagination-wrapper {\n  padding-bottom: 0;\n}\n\n.prompt-tabs-link {\n  color: var(--slate-gray);\n  background-color: #ddd0;\n  border-bottom: 2px solid #0000;\n  padding-bottom: 6px;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 30px;\n}\n\n.prompt-tabs-link.w--current {\n  border-bottom-color: var(--mks-primary-dark);\n  color: var(--mks-primary-dark);\n  background-color: #fff0;\n}\n\n.prompts-tabs-content {\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  flex-flow: column;\n  display: flex;\n}\n\n.user-tabs-content {\n  grid-column-gap: 20px;\n  grid-row-gap: 10px;\n  margin-top: 10px;\n  flex-flow: column;\n  display: flex;\n}\n\n.prompt-creator-block {\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  display: flex;\n  font-size: 12px;\n}\n\n.custom-div-table {\n  border-radius: 0;\n}\n\n.prompt-user-block {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  display: flex;\n}\n\n.prompt-user-img {\n  background-color: #0665ff;\n  border-radius: 100px;\n  width: 24px;\n  height: 24px;\n  overflow: hidden;\n}\n\n.prompt-user-name {\n  color: var(--mks-primary-dark);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n}\n\n.collection-views-block {\n  grid-column-gap: 2px;\n  grid-row-gap: 2px;\n  color: var(--mks-primary-dark);\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 2px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 14px;\n  display: flex;\n}\n\n.views-icon {\n  background-image: url(\"../images/mksapp/eye-icon-2.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 18px;\n  height: 18px;\n}\n\n.share-icon {\n  background-image: url(\"../images/share-icon.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 18px;\n  height: 18px;\n}\n\n.thumbs-up-icon {\n  background-image: url(\"../images/mksapp/thumbs-up-line-dark.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 15px;\n  height: 15px;\n}\n\n.comment-icon {\n  background-image: url(\"../images/mkspropmanagment/comments-icon.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 18px;\n  height: 18px;\n}\n\n.view-active-background .views-icon {\n  background-image: url(\"../images/mkspropmanagment/eyewhite.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 18px;\n  height: 18px;\n}\n\n.prompt-grid-row {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 65% 1fr 1fr 1fr;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 6px;\n  font-size: 12px;\n}\n\n.view-prompt-col {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.thumbs-up-col {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.view-active-background {\n  background-color: #053a64;\n  border-radius: 30px;\n}\n\n.prompts-action-wrapper {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  display: flex;\n}\n\n.share-action-wrapper {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  display: flex;\n}\n\n.favourite-button {\n  background-image: url(\"../images/mksapp/favourite-icon-inactive.svg\");\n  background-position: 50% 0;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 20px;\n  height: 25px;\n  margin-right: 5px;\n  position: absolute;\n  inset: 0% 5px auto auto;\n  top: -11px;\n}\n\n/* .favourite-button:hover,\n.favourite-button:active,\n.favourite-button:focus,\n.favourite-button:visited {\n  background-image: url(\"../images/mksapp/favourite-icon-active.svg\");\n} */\n\n.favourite-button-active {\n  background-image: url(\"../images/mksapp/favourite-icon-active.svg\");\n  background-position: 50% 0;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 20px;\n  height: 25px;\n  margin-right: 5px;\n  position: absolute;\n  inset: 0% 5px auto auto;\n  top: -11px;\n}\n\n.prompt-action-link {\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  color: var(--mks-primary-dark);\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 11px;\n  line-height: 12px;\n  text-decoration: none;\n  display: flex;\n  cursor: pointer;\n}\n\n.prompt-action-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.appdash-wrapper {\n  flex-flow: column;\n  flex: 1;\n  padding-bottom: 15px;\n  display: flex;\n}\n\n.accordian-body {\n  flex-flow: column;\n  display: flex;\n}\n\n.service-list-wrapper {\n  grid-column-gap: 2px;\n  grid-row-gap: 2px;\n  flex-flow: column;\n  padding: 5px;\n  display: flex;\n}\n\n.draggable-button {\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  width: 25px;\n  height: 25px;\n  padding: 3px;\n  display: flex;\n}\n\n.app-group-heading {\n  color: #000;\n  border-bottom: 1px solid #ddd;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 53px;\n  display: flex;\n  gap: 10px;\n}\n\n.custom-application {\n  cursor: pointer;\n  line-height: normal;\n}\n\n.custom-application img {\n  filter: invert(1);\n}\n\n.wrkspace-section-wrap .dash-section.p20 {\n  padding-top: 0;\n}\n\n.task-block {\n  background-color: #f7f7f7;\n  border: 1px solid #fff0;\n  border-radius: 0;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: -5px;\n  padding-right: 3px;\n  display: flex;\n}\n\n.task-block:hover {\n  z-index: 1;\n  background-color: #f9fcff;\n  border: 1px solid #c1d0e2;\n  border-radius: 4px;\n  position: relative;\n}\n\n.servicenow-list-block {\n  grid-column-gap: 2px;\n  grid-row-gap: 2px;\n  border: 1px solid #fff;\n  border-radius: 4px;\n  flex-flow: column;\n  padding-bottom: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 9px;\n  line-height: 12px;\n  text-decoration: none;\n  display: flex;\n}\n\n.servicenow-list-block:hover {\n  background-color: #f9fcff;\n  border: 1px solid #dfdfdf;\n  text-decoration: none;\n}\n\n.app-grid-wrap-block {\n  border-radius: 10px;\n  flex-flow: column;\n  display: flex;\n  overflow: hidden;\n}\n\n.servicenow-text {\n  color: #000;\n  font-weight: 600;\n}\n\n.report-label {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-weight: 700;\n  line-height: 12px;\n}\n\n.report-label.head {\n  font-weight: 600;\n}\n\n.reports-list-wrapper {\n  grid-column-gap: 4px;\n  grid-row-gap: 4px;\n  background-color: #fff;\n  flex-flow: column;\n  flex: 1;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  width: 100%;\n  padding: 5px;\n  display: flex;\n}\n\n.accordian-arrow-icon {\n  opacity: 0.55;\n  background-color: #e4eaf0;\n  background-image: url(\"../images/mksapp/down-arrow_154710.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  border-radius: 3px;\n  width: 22px;\n  height: 22px;\n}\n\n.accordian-arrow-icon:hover {\n  opacity: 1;\n  background-color: #e0e6ec;\n}\n\n.right-list-block {\n  flex-flow: column;\n  display: flex;\n  overflow: auto;\n}\n\n.task-day {\n  color: #891a1c;\n  font-size: 8px;\n  font-weight: 600;\n  line-height: 14px;\n}\n\n.task-day.tomorrow,\n.task-day.today {\n  color: #008a20;\n}\n\n.servcnow-status {\n  justify-content: space-between;\n  align-items: flex-end;\n  display: flex;\n}\n\n.task-label {\n  white-space: normal;\n  flex: 1;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 12px;\n}\n\n.text-link-2 {\n  color: #006aff;\n  padding-left: 7px;\n  padding-right: 7px;\n  font-size: 9px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.my-workspace-wrapper {\n  grid-column-gap: 2px;\n  grid-row-gap: 2px;\n  justify-content: flex-start;\n  align-items: stretch;\n  width: 100%;\n  height: 82%;\n  overflow-y: auto;\n}\n\n.add-btn {\n  opacity: 0.55;\n  background-color: #e4eaf0;\n  background-image: url(\"../images/mksapp/solid-plus-icon.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: 12px;\n  border-radius: 3px;\n  width: 22px;\n  height: 22px;\n}\n\n.add-btn:hover {\n  opacity: 1;\n  background-color: #e0e6ec;\n}\n\n.dragbutton-inactive {\n  display: none;\n}\n\n.app-right-heading {\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 12px;\n  display: flex;\n}\n\n.servnow-head-row {\n  grid-column-gap: 4px;\n  grid-row-gap: 4px;\n  border-bottom: 1px solid #d6d6d6;\n  grid-template-rows: auto;\n  grid-template-columns: 2fr auto auto;\n  align-content: center;\n  place-items: center stretch;\n}\n\n.app-left-col {\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  border-radius: 15px;\n  flex-flow: column;\n  flex: 1;\n  padding: 20px 40px;\n  display: flex;\n  overflow: auto;\n}\n\n.accordian-label-icon {\n  background-image: url(\"../images/mksapp/background-image.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 30px;\n  height: 30px;\n}\n\n.accordian-label-icon.reports {\n  background-image: url(\"../images/mksapp/reports-icon.svg\");\n  background-size: contain;\n}\n\n.accordian-label-icon.service {\n  background-image: url(\"../images/mksapp/service-icon.svg\");\n  border-radius: 5px;\n}\n\n.accordian-label-icon.to-do {\n  background-image: url(\"../images/mksapp/to-do-list-icon.svg\");\n}\n\n.servnow-status {\n  color: #000;\n  border-radius: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-weight: 600;\n  line-height: 15px;\n}\n\n.servnow-status.in-progress {\n  color: #eea300;\n  background-color: #ffeed4;\n}\n\n.servnow-status.closed {\n  color: #891a1c;\n  background-color: #ffdfdf;\n}\n\n.servnow-status.open {\n  color: #008a20;\n  background-color: #c4ffd0;\n  border-radius: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 8px;\n  line-height: 15px;\n}\n\n.app-link-tile {\n  z-index: 1;\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  color: #000;\n  text-align: center;\n  cursor: grab;\n  background-color: #fff;\n  border: 1px solid #d2deed;\n  border-radius: 8px;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  padding: 19px 6px;\n  text-decoration: none;\n  transition: box-shadow 0.4s;\n  display: flex;\n  position: relative;\n}\n\n.app-link-tile:hover {\n  z-index: 1;\n  border-style: dashed;\n  border-color: #333f4e59;\n  text-decoration: none;\n  position: relative;\n  box-shadow: 0 0 50px 20px #0d2f4e1c;\n}\n\n.taskchkbox {\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0;\n  padding-left: 4px;\n  padding-right: 4px;\n  display: flex;\n}\n\n.right-list-wrapper {\n  flex-flow: column;\n  display: flex;\n  overflow: hidden;\n}\n\n.app-right-col {\n  background-color: var(--white);\n  border-radius: 0 15px 15px 0;\n  flex-flow: column;\n  flex: 0 auto;\n  width: 32%;\n  min-width: 32%;\n  height: 100%;\n  padding: 20px 5px;\n  display: flex;\n  overflow: hidden;\n}\n\n.app-right-col.hide {\n  display: none;\n}\n\n.app-logo-icon {\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  min-width: 50px;\n  height: 50px;\n  min-height: 50px;\n  margin-bottom: 5px;\n  padding: 3px;\n  display: flex;\n}\n\n.app-logo-icon.wide {\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  display: flex;\n}\n\n.tasks-wrapper {\n  flex-flow: column;\n  flex: 1;\n  width: 100%;\n  margin-bottom: 0;\n  padding: 7px 5px;\n  display: flex;\n  overflow: hidden;\n}\n\n.view-link-block {\n  grid-column-gap: 3px;\n  grid-row-gap: 3px;\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n}\n\n.w-layout-grid:has(.app-group-norecordfound) {\n  grid-template-columns: 1fr;\n  text-align: center;\n}\n\n.list-wrapper {\n  background-color: #fff;\n  flex-flow: column;\n  flex: 0 auto;\n  display: flex;\n}\n\n.app-links-grid {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n\n  padding-bottom: 20px;\n}\n\n.applist-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.applist-row .app-logo-icon {\n  min-height: auto;\n  height: auto;\n  width: 27px;\n  min-width: 26px;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.paragraph.small {\n  display: -webkit-box;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 90px;\n  word-break: break-word;\n}\n\n.applist-view {\n  display: flex;\n  flex-flow: column;\n  gap: 8px;\n  max-height: 290px;\n  overflow-y: auto;\n}\n\n.app-logo-icon img {\n  object-fit: contain;\n  width: 50px;\n  height: 50px;\n}\n\n.multifile-row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.applist-view .app-logo-icon img {\n  object-fit: contain;\n  width: 20px;\n  height: 20px;\n}\n\n.applist-view .check-contain {\n  padding-left: 15px;\n}\n\n.app-list .popup-btn-container {\n  justify-content: center;\n  margin-top: 34px;\n}\n\n.accordian-heading {\n  cursor: pointer;\n  border-top: 1px solid #7080dd3b;\n  border-bottom: 0.5px solid #7080dd3b;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 10px 10px 9px;\n  font-weight: 700;\n  display: flex;\n}\n\n.app-name-label {\n  color: #00567d;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.task-checkbox {\n  background-image: url(\"../images/mksapp/checkmark-circle-outline.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  border-color: #fff;\n  border-radius: 20px;\n  width: 20px;\n  max-width: 14px;\n  height: 20px;\n  max-height: 14px;\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 7px;\n  padding: 0;\n}\n\n.task-checkbox.w--redirected-checked {\n  background-color: #fff;\n  background-image: url(\"../images/mksapp/checkmark-circle.svg\");\n  background-size: contain;\n  border-color: #fff;\n}\n\n.task-checkbox.w--redirected-focus {\n  box-shadow: 0 0 3px 1px #00ff19;\n}\n\n.tasks-wrapper-form {\n  grid-column-gap: 8px;\n  grid-row-gap: 8px;\n  flex-flow: column;\n  display: flex;\n}\n\n.servnow-label {\n  color: var(--mks-primary-dark);\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 27px;\n}\n\n.reports-block {\n  grid-column-gap: 3px;\n  grid-row-gap: 3px;\n  cursor: pointer;\n  background-color: #fff;\n  border: 1px solid #fff;\n  border-radius: 4px;\n  flex-flow: column;\n  grid-template-rows: auto;\n  grid-template-columns: 0.9fr 0.7fr 0.4fr;\n  grid-auto-columns: 1fr;\n  justify-content: flex-start;\n  place-items: center stretch;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 17px;\n  display: grid;\n}\n\n.reports-block:hover {\n  background-color: #f9fcff;\n  border: 1px solid #e7e3e3;\n}\n\n.reports-block.head-row {\n  color: #8a8a8a;\n  border-bottom: 1px solid #dfdfdf;\n  border-radius: 0;\n}\n\n.reports-block.head-row:hover {\n  background-color: #fff;\n  border: 1px solid #fff;\n  border-bottom-color: #dfdfdf;\n}\n\n.app-grid-wrapper {\n  background-color: #fff;\n  border-radius: 10px;\n  overflow: auto;\n}\n\n.servnow-icon {\n  background-image: url(\"../images/mksapp/statusnow-msngr.svg\");\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 17px;\n  height: 18px;\n}\n\n.servnow-icon.info {\n  background-image: url(\"../images/mksapp/statusnow-info.svg\");\n}\n\n.accordiian-heading-block {\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  display: flex;\n}\n\n.app-category-label {\n  cursor: pointer;\n  font-size: 10px;\n  line-height: 14px;\n}\n\n.wrkspace-section-wrap {\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  flex-flow: column;\n  display: flex;\n}\n\n/* Logout Popup code Start here*/\n.popup-menu {\n  position: absolute;\n  background-color: white;\n  border-radius: 4px;\n  padding: 5px;\n  z-index: 1000;\n  min-width: 150px;\n  width: 100%;\n  right: 0;\n  box-shadow: 2px 2px 10px #d5d1d1;\n  top: 54px;\n}\n\n.full-name-row {\n  background: #053a64;\n  color: #fff;\n  font-size: 12px;\n  padding: 3px 5px;\n  border-radius: 5px;\n}\n\n.left-user-settings .popup-row:hover {\n  background: #053a64;\n  color: #fff;\n}\n\n.popup-row {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  padding: 0 8px;\n}\n\n.left-user-settings .popup-row {\n  padding: 3px 5px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.left-user-settings .popup-row:hover a {\n  color: #fff;\n}\n\n.left-user-settings .popup-row:hover .logout-icon {\n  filter: invert(1);\n}\n\n.popup-menu a {\n  background-color: transparent;\n  text-decoration: none;\n  color: #041f35;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.full-name-text {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.full-name-text::before {\n  content: \"\";\n  background: url(../images/user.svg);\n  width: 18px;\n  height: 18px;\n  background-size: cover;\n  display: block;\n}\n\n.add-prompt-text {\n  background: url(../images/mksapp/solid-plus-icon.svg);\n  width: 12px;\n  height: 12px;\n  background-size: cover;\n  display: block;\n  margin-right: 10px;\n}\n\n.skill-create-tags .suggestions.mks-suggestion-prompt {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.popup-row {\n  margin-top: 10px;\n}\n\n.prompt-popup-menu .popup-row {\n  font-size: 12px;\n  margin: 0;\n  padding: 4px 7px;\n}\n\n.prompt-popup-menu .popup-row:hover {\n  background-color: #e5e5e5;\n}\n\n.prompt-popup-menu .popup-row a {\n  color: #000;\n  text-decoration: none;\n}\n\n/* .popup-arrow {\n  border-bottom: 10px solid #e5e5e5;\n  border-left: 10px solid #0000;\n  border-right: 10px solid #0000;\n  height: 0;\n  top: 44px;\n  position: absolute;\n  right: 11%;\n  width: 0;\n} */\n\n.popup-arrow {\n  background: url(../images/tr.png);\n  background-size: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 22px;\n  top: 37px;\n  position: absolute;\n  right: 0;\n  width: 33px;\n}\n\n.popup-menu button:hover {\n  background-color: #0056b3;\n}\n\n.medium-font {\n  font-size: 27px;\n  margin-bottom: 0;\n}\n\n.subtext {\n  font-size: 12px;\n}\n\n.prompt-popup-menu {\n  position: absolute;\n  background-color: white;\n  border-radius: 4px;\n  z-index: 1000;\n  width: 100%;\n  top: 35px;\n  padding: 0;\n  width: 100%;\n  right: 0;\n  box-shadow: 2px 2px 10px #d5d1d1;\n}\n\nuser-profile-menu w-inline-block {\n  position: relative;\n}\n\n.ai-collection-grid {\n  padding-bottom: 10px;\n}\n\n.prompt-user-img {\n  color: #fff;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  font-size: 12px;\n}\n\n/* .w-dropdown-list.w--open {\n  display: block;\n}\n\n.user-dd-list.w--open {\n  align-items: flex-end;\n  background-color: #0000;\n  display: flex;\n  flex-direction: column;\n  padding-top: 19px;\n  right: 0;\n}\n\n.w-dropdown-list {\n  background: #ddd;\n  display: none;\n  min-width: 100%;\n  position: absolute;\n}\n\n.dd-triangle {\n  border-bottom: 10px solid #fff;\n  border-left: 10px solid #0000;\n  border-right: 10px solid #0000;\n  height: 0;\n  margin-top: -10px;\n  position: absolute;\n  right: 7px;\n  width: 0;\n}\n\n.dd-link-wrapper {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 2px 2px 10px #bfbaba;\n  padding: 6px;\n}\n\n.user--dd-link.w-inline-block {\n  display: flex;\n}\n\n.w-inline-block {\n  display: inline-block;\n  max-width: 100%;\n}\n\n.user--dd-link {\n  border-radius: 4px;\n  color: #000;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 10px 15px;\n  text-align: right;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.main-menu, .user--dd-link {\n  align-items: center;\n  display: flex;\n}\n\na {\n  background-color: initial;\n}\n\n.dd-link-seperator {\n  background-color: #ececec;\n  height: 1px;\n  margin-bottom: 3px;\n  margin-top: 3px;\n}\n\n.user--dd-link.w-inline-block {\n  display: flex;\n}\n\n.w-inline-block {\n  display: inline-block;\n  max-width: 100%;\n}\n\n.user--dd-link {\n  border-radius: 4px;\n  color: #000;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 10px 15px;\n  text-align: right;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.dd-link-icon.logout {\n  background-image: url(https://cdn.prod.website-files.com/66438c9…/667ca37…_logout-icon.svg);\n}\n.dd-link-icon {\n  background-image: url(https://cdn.prod.website-files.com/66438c9…/667ca37…_reset-password-icon.svg);\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 15px;\n  margin-right: 10px;\n  width: 15px;\n} */\n\n.resource-add {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n}\n\n.loader-map {\n  text-align: center;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column;\n  height: 300px;\n  gap: 17px;\n}\n\n.loader-text.loader-map-text-display {\n  width: 200px;\n  text-align: center;\n  right: 18px;\n}\n\n.loader-map-text {\n  color: #053a64;\n  font-weight: 500;\n}\n\n.loader2 {\n  width: 35px;\n  aspect-ratio: 1;\n  --_g: no-repeat radial-gradient(circle closest-side, #1680d3 90%, #0000);\n  background: var(--_g) 0 0, var(--_g) 0 100%, var(--_g) 100% 100%;\n  background-size: 40% 40%;\n  animation: l11 1s infinite linear;\n}\n\n@keyframes l11 {\n  25% {\n    background-position: 100% 0, 0 100%, 100% 100%;\n  }\n\n  50% {\n    background-position: 100% 0, 0 0, 100% 100%;\n  }\n\n  75% {\n    background-position: 100% 0, 0 0, 0 100%;\n  }\n\n  100% {\n    background-position: 100% 100%, 0 0, 0 100%;\n  }\n}\n\n.logout-icon {\n  background-image: url(../images/logout-icon.svg);\n  background-position: 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 15px;\n  margin-right: 10px;\n  width: 15px;\n}\n\n/* Logout Popup code End here*/\n\n/********breadcrumb***********/\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  padding: 20px 40px 0;\n  gap: 4px;\n}\n\n.breadcrumb a {\n  display: flex;\n  text-decoration: none;\n\n  align-items: center;\n}\n\n.home-link::before {\n  content: \"\";\n  background: url(../images/mkspropmanagment/home.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n  margin-top: -5px;\n}\n\n.home-link::after {\n  content: \"\";\n  background: url(../images/mkspropmanagment/chevron-right.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n}\n\n/* .normal-link::after {\n  content: '';\n  background: url(../images/mkspropmanagment/chevron-right.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n} */\n\n.breadcrumb .normal-link {\n  color: #565151;\n  font-size: 13px;\n}\n\n/* .breadcrumb a.normal-link:last-child::after {\n  display: none;\n} */\n\n.breadcrumb a.visited {\n  color: #4a63ff;\n  font-size: 13px;\n  gap: 4px;\n}\n\n.breadcrumb a.visited:hover {\n  color: #3147d3;\n}\n\n.linkclass {\n  color: #3147d3;\n  line-height: 19px;\n  /* text-decoration: underline; */\n  cursor: pointer;\n  margin-top: 3px;\n  /* list-style-type: decimal; */\n}\n\n.linkclassText {\n  color: #3147d3;\n  /* text-decoration: underline; */\n  cursor: pointer;\n  margin-top: 3px;\n  list-style-type: decimal;\n  cursor: pointer;\n}\n\n.linkclassTextLast {\n  color: #3147d3;\n  /* text-decoration: underline; */\n  cursor: pointer;\n  margin-top: 3px;\n  list-style-type: decimal;\n  cursor: pointer;\n}\n\n.linkclassTextLast.linkbox {\n  border: 1px solid #a7a7a7;\n  padding: 1px 4px;\n  display: inline;\n  margin-right: 5px;\n}\n\n.linkclassText.linkbox {\n  border: 1px solid #a7a7a7;\n  padding: 1px 4px;\n  display: inline;\n  margin-right: 5px;\n}\n\n.location-info {\n  background-color: #e8f4fd;\n  border: 1px solid #61dafb;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 15px;\n  position: relative;\n  color: #282c34;\n  font-size: 16px;\n  animation: slideIn 0.3s ease-out;\n}\n\n.location-info strong {\n  color: #1976d2;\n}\n\n.close-btn {\n  position: absolute;\n  top: 8px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.close-btn:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.instruction-text {\n  text-align: center;\n  color: #666;\n  font-style: italic;\n  margin-top: 15px;\n  font-size: 14px;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.error-block-display {\n  width: 100%;\n  height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.error-block-button-display {\n  margin-top: 16px;\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.fallback-display {\n  width: 100%;\n  height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f5f5;\n}\n\n.trash-button-icon.light-gray-button.disabled-element .trash-icon {\n  filter: none !important;\n}\n\n.right-buttons .trash-button-icon.light-gray-button .trash-icon {\n  filter: brightness(0);\n}\n\n.dark-theme .chathead {\n  color: #000;\n}\n\n.dark-theme .skills-tabs .ai-collection-grid {\n  background: transparent;\n  padding: 0;\n}\n\n.dark-theme .overview-card {\n  background: #fff;\n  box-shadow: 2px 2px 10px #3b3b3b;\n}\n\n.dark-theme .chart-active-button {\n  background: #fff;\n  color: #053a64;\n}\n\n.dark-theme .e-control.e-chart {\n  background: #fff;\n}\n\n.dark-theme .container-no-records {\n  color: #000;\n}\n\n.dark-theme .light-gray-button .trash-icon {\n  filter: invert(1);\n}\n\n/***********breadcrumbs end**********/\n\n/*******feedback page start********/\n.feedabck-wrapper {\n  gap: 20px;\n  padding: 20px 40px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.feedback-left-section,\n.feedback-right-section {\n  width: 100%;\n}\n\n.feedback-textarea {\n  width: 100%;\n  min-height: 300px;\n  resize: none;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.feedback-left-section {\n  display: flex;\n  flex-flow: column;\n  gap: 20px;\n  max-height: calc(100vh - 148px);\n  overflow-y: auto;\n}\n\n.feedbacktext {\n  background: #f9f9f9;\n  font-size: 12px;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.feedback-flex-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.check-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.check-wrap label {\n  font-weight: 500;\n  margin: 0;\n  font-size: 12px;\n}\n\n.feedback-right-section h2 {\n  margin: 0;\n}\n\n.count-word {\n  text-align: right;\n}\n\n.read-more-text {\n  color: #0063ff;\n  cursor: pointer;\n}\n\n.feedback-right-section {\n  background: #f3f3f3;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.feedback-btn-submit {\n  padding: 7px;\n  background-color: #053a64;\n  color: white;\n  border-radius: 5px;\n}\n\n/*********prompt page start************/\n\n.prompt-steps {\n  display: flex;\n  padding: 20px 0;\n  background: #ffffff;\n  position: relative;\n}\n\n.prompt-step {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.p-dot {\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  background-color: #fff;\n  border: 1px solid #b3b7bd;\n}\n\n.p-done .p-dot {\n  background: #005fff;\n}\n\n.p-current::after {\n  content: \"\";\n  background-color: #e5e5e5;\n  width: 100%;\n  height: 1px;\n  display: block;\n  position: absolute;\n  bottom: 6px;\n}\n\n.p-current .p-dot {\n  border: 1px solid #005fff;\n  background: #e5e5e5;\n}\n\n.prompt-selects select,\n.prompt-selects .dropdown-button {\n  background: #fff;\n}\n\n.prompt-selects .custom-dropdown .dropdown-menu-custom {\n  background: #fff;\n}\n\n.suggestions {\n  position: absolute;\n  background: #fff;\n  z-index: 1;\n  font-size: 12px;\n  padding: 9px;\n  border-radius: 0 0 10px 10px;\n  border: 1px solid #e5e5e5;\n  /* cursor: pointer; */\n}\n\n.suggestions.mks-suggestion {\n  top: 47px;\n  border-radius: 5px 5px 0 0;\n  width: 46%;\n  left: 0;\n}\n\n.mks-suggestion .suggestion-item {\n  padding: 3px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f5f5;\n  font-size: 11px;\n}\n\n.mks-suggestion-prompt .suggestion-item {\n  padding: 3px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f5f5;\n  font-size: 11.5px;\n}\n\n.suggestions.prompt-suggestions {\n  bottom: 40px;\n  border-radius: 5px 5px 0 0;\n  width: 46%;\n  left: 0;\n  max-height: 56vh;\n  overflow-y: auto;\n}\n\n.prompt-suggestions .suggestion-item {\n  padding: 3px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f5f5;\n  font-size: 11px;\n}\n\n.dark-theme .suggestions.prompt-suggestions {\n  border-top: 2px solid #5a7b9d;\n}\n\n.suggestion-item {\n  cursor: pointer;\n}\n\n.addtag-input button {\n  background: #226194;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 5px;\n  margin-left: 7px;\n}\n\n.p-dot-wrapper {\n  margin-top: 6px;\n}\n\n.prompt-steps .prompt-step:last-child .p-done::after {\n  display: none;\n}\n\n.prompt-step-desc {\n  font-size: 12px;\n  color: #a39e9e;\n}\n\n.p-done::after {\n  content: \"\";\n  background-color: #005fff;\n  width: 100%;\n  height: 1px;\n  display: block;\n  position: absolute;\n  bottom: 6px;\n}\n\n.check-ackn {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  justify-content: flex-start;\n}\n\n.help-section {\n  display: grid;\n  grid-template-columns: 70% 30%;\n  gap: 26px;\n}\n\n.help-video-boxes {\n  max-height: calc(100vh - 170px);\n  overflow-y: auto;\n  display: flex;\n  flex-flow: column;\n  gap: 21px;\n  padding: 13px 15px;\n}\n\n.check-ackn p {\n  margin-bottom: 0;\n  font-size: 12px;\n}\n\n.help-video-desc {\n  color: #053a64;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.p-checkbox {\n  margin-top: 2px;\n  width: 20px;\n  height: 20px;\n}\n\n.prompt-title {\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0;\n  line-height: 14px;\n  margin-bottom: 10px;\n}\n\n.prompt-img {\n  max-width: 60px;\n  height: 60px;\n  border: 6px solid #e5e5e5;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border-radius: 100%;\n}\n\n.prompt-img-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.prompt-title-small {\n  font-size: 12px;\n  margin: 0;\n  line-height: 14px;\n  margin-bottom: 10px;\n}\n\n.prompt-title-wrap {\n  width: 100%;\n  position: relative;\n}\n\n.prompt-title-wrap .suggestions {\n  width: 100%;\n}\n\n.prompt-textarea {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  min-height: 130px;\n  resize: none;\n  overflow-y: auto;\n  font-size: 12px;\n}\n\n.prompt-pii {\n  padding: 10px;\n  min-height: 100px;\n  overflow-y: auto;\n  max-height: 100px;\n  width: 100%;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  background-color: white;\n  outline: none;\n}\n\n.disabled-element .prompt-pii {\n  background-color: #f2f2f2;\n}\n\n.disabled-parent .prompt-pii {\n  background-color: #f2f2f2;\n}\n\n.disabled-element select {\n  background-color: #f2f2f2;\n}\n\nselect.prompt-skill.disabled-element {\n  background-color: #f2f2f2;\n}\n\n.pref-block {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pref-block select,\n.word-count-field {\n  border: 1px solid #e5e5e5;\n  font-size: 12px;\n  padding: 6px 11px;\n  border-radius: 5px;\n  height: 33px;\n}\n\n.preference-wrapper {\n  background: #f1f1f1;\n  width: max-content;\n  padding: 16px;\n  border-radius: 5px;\n}\n\n.prompt-text {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  background: #fff;\n}\n\ninput:focus-visible,\ntextarea:focus-visible,\nselect:focus-visible {\n  outline: 0;\n}\n\n.border-red {\n  border: 1px solid red !important;\n}\n\n.prompt-desc {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n}\n\n.add-prompt-btn {\n  position: absolute;\n  right: 0;\n  z-index: 2;\n  top: 8px;\n}\n\n.prompt-tabs .ai-collection-grid.light-bg {\n  background: #f5f5f5;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.prompt-tag-select {\n  display: flex;\n  gap: 10px;\n}\n\n.prompt-skill {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n}\n\n.prompt-modal select {\n  width: 150px;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n}\n\n.prompt-explanaion {\n  display: grid;\n  gap: 15px;\n  grid-template-columns: 50% 50%;\n}\n\n.prompt-step-two .prompt-explanaion {\n  display: grid;\n  gap: 15px;\n  grid-template-columns: 33% 33% 33%;\n}\n\n.prompt-text {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n}\n\n.genrate-btn {\n  background: #226194;\n  color: #ffffff;\n  padding: 10px 24px;\n  border-radius: 40px;\n}\n\n.add-user {\n  float: right;\n  cursor: pointer;\n}\n\n.add-user-button {\n  text-align: right;\n}\n\n.cancel-btn {\n  background: #fff;\n  color: #0c2a42;\n  padding: 10px 24px;\n  border-radius: 40px;\n  text-decoration: none;\n  border: 1px solid #d5cece;\n}\n\n.cancel-btn.small-size-bn {\n  padding: 4px 15px;\n  font-size: 10px;\n}\n\n.cancel-btn:hover {\n  border: 0.5px solid;\n}\n\n.close-icon:hover {\n  filter: brightness(0.5);\n  cursor: pointer;\n}\n\n.addtag-input button:hover {\n  background: #164e7a;\n}\n\n.genrate-btn:hover {\n  background: #164e7a;\n}\n\n.backbtn:hover {\n  background: #dddddd;\n}\n\n.saveprompt .genrate-btn {\n  padding: 10px 20px;\n}\n\n.prompt-button-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.flex-end {\n  justify-content: flex-end;\n}\n\n.prompt-review {\n  text-align: center;\n}\n\n.selected-tag {\n  display: inline-block;\n  background: #c6e1f7;\n  padding: 4px 18px;\n  border-radius: 30px;\n  margin-top: 6px;\n}\n\n.prompt-review-box {\n  display: flex;\n  background: #fff;\n  padding: 10px;\n  gap: 10px;\n  width: 100%;\n}\n\n.prompted-text {\n  width: 100%;\n  border: 0;\n  font-size: 12px;\n}\n\n.prompted-text:focus-visible {\n  outline: 0;\n}\n\n.new-reply-comment {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.user-profile-initial.auto-cursor {\n  cursor: default;\n}\n\n.new-reply-comment textarea {\n  border: 1px solid #e5e5e5;\n  font-size: 12px;\n  max-height: 50px;\n  overflow-y: auto;\n  font-size: 11px;\n  line-height: normal;\n  resize: none;\n}\n\n.comment-reply-btn {\n  background: #226194;\n  color: #ffffff;\n  font-size: 11px;\n  padding: 1px 10px;\n  border-radius: 5px;\n}\n\n.cancel-comment {\n  background: #e5e5e5;\n  color: #226194;\n  font-size: 11px;\n  padding: 1px 10px;\n  border-radius: 5px;\n}\n\n.g-10 {\n  gap: 10px;\n}\n\n.prompt-review-wrap {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.backbtn {\n  display: flex;\n  align-items: center;\n  background: #efefef;\n  color: #0c2a42;\n  padding: 10px 24px 10px 14px;\n  text-decoration: none;\n}\n\n.flex-block {\n  display: flex;\n  align-items: center;\n}\n\n.backbtn::before {\n  content: \"\";\n  background: url(../images/mkspropmanagment/chevron-left.svg);\n  width: 18px;\n  height: 18px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  display: inline-block;\n}\n\n.close-icon {\n  background: url(../images/mkspropmanagment/close-icon.svg);\n  width: 15px;\n  height: 15px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n}\n\n.prompt-tags-wrap {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.all-comment {\n  max-height: 400px;\n  overflow-y: auto;\n  display: flex;\n  flex-flow: column-reverse;\n}\n\n.p-tag {\n  display: flex;\n  align-items: center;\n  background: #c6e1f7;\n  border-radius: 24px;\n  padding: 4px 10px;\n  font-size: 8px;\n  font-weight: 500;\n  line-height: 12px;\n}\n\n.prompt-selects {\n  display: flex;\n  gap: 20px;\n}\n\n.h-line {\n  display: block;\n  width: 100%;\n  border-top: 1px solid #e5e5e5;\n}\n\n.tag-flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n.add-tag-btn {\n  border: 1px solid #0063ff;\n  background: #fff;\n  padding: 1px 9px;\n  border-radius: 5px;\n  color: #0063ff;\n  cursor: pointer;\n  display: none;\n}\n\n.input-tag {\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  padding: 3px;\n}\n\n.input-numeric-tag {\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  padding: 6px;\n}\n\n.input-tag:focus-visible {\n  outline: 0;\n}\n\n.input-numeric-tag:focus-visible {\n  outline: 0;\n}\n\n.mt20 {\n  margin-top: 20px;\n}\n\n.all-selected-item {\n  display: flex;\n  gap: 5px;\n}\n\nspan.close-icon {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n}\n\nspan.selected-val {\n  background: #efefef;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  padding: 0 6px;\n  font-size: 10px;\n  gap: 3px;\n}\n\n.edit-common-icons.star-end {\n  border: 0;\n  padding: 0;\n}\n\n.star-end .favourite-button-active {\n  position: static;\n  cursor: pointer;\n}\n\n.no-pointer {\n  cursor: context-menu !important;\n}\n\n.star-end .favourite-button {\n  position: static;\n  cursor: pointer;\n}\n\n.skill-detaill-right .prompt-selects {\n  flex-flow: column;\n}\n\n.skill-fullwidth {\n  padding: 0 40px 20px;\n  display: flex;\n  flex-flow: column;\n  gap: 15px;\n}\n\n.skill-update-box {\n  position: relative;\n}\n\n.custom-dropset {\n  position: absolute;\n  top: 53px;\n  left: 0;\n}\n\n.create-skill-window .custom-dropset {\n  bottom: 40px;\n  top: auto;\n}\n\n.create-skill-window .ownerdrodown {\n  box-shadow: 1px -11px 10px #e5e5e5;\n}\n\n.dark-theme .create-skill-window .ownerdrodown {\n  box-shadow: 1px -11px 10px #042947;\n}\n\n.max-width-row {\n  width: 100%;\n  display: flex;\n  gap: 20px;\n  /* max-width: 60%; */\n}\n\n.securitygroup-text {\n  padding: 8px;\n  border: 0;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.owner-box .custom-dropdown {\n  width: 100%;\n}\n\n.skill-detaill-right .custom-dropdown {\n  width: 100%;\n}\n\n.skill-detaill-right.autowidth .custom-dropdown {\n  width: 100%;\n  min-width: 100%;\n}\n\n.skill-one-row .check-ackn {\n  width: 100%;\n  max-width: 150px;\n}\n\n.skill-one-row .wrapper-api-url {\n  width: 250px;\n}\n\n.skill-one-row .check-contain {\n  top: -9px;\n}\n\n.check-ackn.hide-skill {\n  max-width: 100px;\n}\n\n.skill-detaill-right .skill-subtitle,\n.skill-detaill-right-full .skill-subtitle {\n  margin-bottom: 5px;\n}\n\n.skill-one-row .check-ackn {\n  align-items: center;\n}\n\n.publish-date-wrap .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.ownerdrodown {\n  width: 100%;\n  padding: 10px;\n  background: #fff;\n  box-shadow: 1px 14px 10px #e5e5e5;\n  z-index: 1;\n}\n\n.owner-box .custom-dropdown .dropdown-button {\n  background-color: #fff;\n}\n\n.skill-one-row {\n  display: flex;\n  width: 100%;\n  min-height: 35px;\n}\n\n.skill-filter-field.w-select {\n  padding: 5px;\n}\n\n/*********prompt page end************/\n\n.dropchat-wrap {\n  border: 1px solid #e5e5e5;\n  margin: 0 20px 0 20px;\n  background-color: #fff;\n}\n\n.multifile-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.chatprompt-form {\n  padding-left: 0;\n}\n\n.pdf-icon-list {\n  background: url(\"../images/pdf.png\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n}\n\n.chat-file-dowbload {\n  display: flex;\n  width: 100%;\n  padding-left: 30px;\n  color: #0063ff;\n  cursor: pointer;\n}\n\n.pdf-icon-list.chat-file-dowbload {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.img-icon-list {\n  background: url(\"../images/img-icon.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.excel-icon-list {\n  background: url(\"../images/xls.png\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.html-icon-list {\n  background: url(\"../images/html-icon.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.tiff-icon-list {\n  background: url(\"../images/tiff-icon.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.ppt-icon-list {\n  background: url(\"../images/ppt-icon.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.word-icon-list {\n  background: url(\"../images/word-icon.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block !important;\n}\n\n.chat-file-dowbload {\n  display: flex;\n  width: 100%;\n  padding-left: 30px;\n  color: #0063ff;\n  cursor: pointer;\n}\n\n.absolute-icon {\n  position: absolute;\n  right: -34px;\n  top: -5px;\n  cursor: pointer;\n}\n\n.file-icon-list {\n  background: url(\"../images/des-file.svg\");\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  background-size: 25px;\n}\n\n.upload-drag {\n  display: flex;\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  padding: 10px;\n  border-radius: 6px;\n  gap: 10px;\n  align-items: center;\n  max-width: 270px;\n\n  margin: 10px;\n}\n\n.upload-drag p {\n  width: 214px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-bottom: 0;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n/* Prompt Managment Card image Start */\n.card-img {\n  max-width: 30px;\n  margin-bottom: 7px;\n  width: 100%;\n}\n\n/* Prompt Managment Card image End */\n\n/* Add Comment Modal in Prompt Management Start here */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  position: relative;\n}\n\n.send-icon {\n  width: 20px;\n}\n\n.error-message {\n  color: red;\n}\n\n.modal-content h2 {\n  margin-bottom: 20px;\n}\n\n.prompt-user-img {\n  /* width: 100%; */\n  max-width: 24px;\n  height: 24px;\n  min-width: 24px;\n}\n\n/* Add Comment Modal in Prompt Management End Here */\n.flexible-icon {\n  display: flex;\n  align-items: center;\n}\n\n.flexible-icon img {\n  cursor: pointer;\n}\n\n.edit-prompt-info .flex-row {\n  gap: 10px;\n}\n\n.edit-prompt-info {\n  margin-bottom: 10px;\n}\n\n/********modal css*************/\n\n.modal-wrapper {\n  position: fixed;\n  left: 0%;\n  top: 0%;\n  right: 0%;\n  bottom: 0%;\n  z-index: 200;\n  display: none;\n  width: 100vw;\n  height: 100vh;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.39);\n  opacity: 0;\n  font-family: Poppins, sans-serif;\n}\n\n.popup-btn-container {\n  text-align: center;\n  display: flex;\n  gap: 10px;\n}\n\n.popup-btn-container-skill {\n  text-align: right;\n  gap: 10px;\n}\n\n.modal-header h2 {\n  width: 100%;\n  text-align: left;\n}\n\n.modal-popup-header h3 {\n  width: 100%;\n  text-align: left;\n}\n\n.modal-body {\n  text-align: left;\n}\n\n.modal-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  width: 80%;\n  max-width: 500px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-radius: 11px;\n  background-color: #fff;\n}\n\n.modal-header label {\n  font-weight: 700;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 22px;\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 17px;\n  padding-bottom: 11px;\n}\n\n.modal-popup-header h3 {\n  margin: 0;\n  font-size: 22px;\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 17px;\n  padding-bottom: 11px;\n  color: #ea384c;\n}\n\n.flex-block-modal {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 21px;\n}\n\n.modal-header p {\n  font-size: 13px;\n}\n\n.flex-block-modal label {\n  display: flex;\n  gap: 10px;\n}\n\n.image-control .modal-content {\n  min-height: 200px;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.crop-img-wrap {\n  width: 100%;\n}\n\n.image-control .modal-body {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 20px;\n}\n\n.image-control .popup-btn-container {\n  display: flex;\n  gap: 20px;\n}\n\n.image-control img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.confirmation-content-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 20px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 15px;\n  line-height: 26px;\n  font-weight: 400;\n}\n\n.confirmation-button-block {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  /*    align-items: center;*/\n  font-size: small;\n  align-items: stretch;\n}\n\n.confirmation-button {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  background-color: #e7e8e9;\n  color: #691c33;\n  font-size: 16px;\n  text-align: center;\n}\n\n.modal-body p {\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 26px;\n}\n\n.modal-wrapper.show-modal-wrapper {\n  display: flex !important;\n  opacity: 1 !important;\n}\n\n.popup-btn-container button {\n  line-height: 16px;\n  font-size: 13px;\n}\n\n.app-list .modal-content {\n  padding: 0;\n}\n\n.app-list .modal-block {\n  max-width: 350px;\n}\n\n.prompt-share-header {\n  margin-bottom: 12px;\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 14px;\n}\n\n.prompt-share-header h3 {\n  margin: 0;\n  width: 100%;\n  text-align: left;\n}\n\n.prompt-share-header .search-cross-icon-common {\n  width: 100%;\n}\n\n.app-list.prompt-share-modal .modal-block {\n  max-width: 475px;\n}\n\n.chathead {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.result-tab-content {\n  font-size: 13px;\n  padding: 10px;\n}\n\n.input-tab-content {\n  background-color: #e5e5e5;\n  padding: 10px;\n  margin: 8px;\n}\n\n.input-tab-content p {\n  margin: 0;\n  color: #7e7878;\n  font-size: 12px;\n}\n\n.edit-prompt-info {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.semibold-text {\n  font-weight: 500;\n}\n\n.action-btn-wrapper {\n  display: flex;\n  gap: 5px;\n}\n\n.private-icon {\n  background: url(../images/private-icon.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.public-icon {\n  background: url(../images/public-icon.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.star-icon {\n  background: url(../images/star-border.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n\n.edit-common-icons {\n  display: flex;\n  /* width: 100%; */\n  border: 1px solid #cfd4d8;\n  padding: 2px 11px;\n  font-size: 12px;\n  gap: 5px;\n  align-items: center;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.prompt-test-heading h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.edit-prompt-buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.edit-col {\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.prompt-badge {\n  background: #e0effb;\n  font-size: 11px;\n  border-radius: 18px;\n  padding: 2px 9px;\n}\n\n.white-space {\n  white-space: nowrap;\n}\n\ndiv#container_mainContainer {\n  min-height: 80vh !important;\n}\n\n@media (max-width: 1440px) {\n  .prompt-step-desc {\n    font-size: 10px;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .dash-menu {\n    width: 15%;\n  }\n\n  textarea.scrollinput {\n    max-height: 14vh !important;\n  }\n\n  .pdfview.overlap {\n    height: 92vh;\n    max-height: 92vh;\n  }\n\n  .dash-body {\n    flex: 1;\n    width: 85%;\n  }\n\n  .app-right-col {\n    width: 25%;\n    min-width: 25%;\n  }\n\n  .app-links-grid {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n}\n\n@media (min-width: 1600px) {\n  .pdfview.overlap {\n    height: 93vh;\n    max-height: 93vh;\n  }\n}\n\n@media (min-width: 1800px) {\n  .ai-collection-grid {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n\n  .pdfview.overlap {\n    height: 94vh;\n    max-height: 94vh;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .pdfview.overlap {\n    height: 94vh;\n    max-height: 94vh;\n  }\n\n  .dash-body {\n    grid-column-gap: 20px;\n    /* grid-row-gap: 20px; */\n  }\n\n  .menu-logo {\n    width: 120px;\n  }\n\n  .left-menu-link {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    font-size: 14px;\n  }\n\n  .menu-icon {\n    width: 30px;\n  }\n\n  .h1 {\n    font-size: 42px;\n  }\n\n  .paragraph {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n  }\n\n  .paragraph.small {\n    font-size: 0.8rem;\n  }\n\n  .chat-tablink {\n    padding-top: 13px;\n    padding-bottom: 13px;\n    font-size: 14px;\n  }\n\n  .chat-button {\n    padding-top: 13px;\n    padding-bottom: 13px;\n  }\n\n  .chat-input-field {\n    min-height: 50px;\n  }\n\n  .h2 {\n    font-size: 22px;\n    line-height: 40px;\n  }\n\n  .ai-collection-grid {\n    grid-column-gap: 22px;\n    grid-row-gap: 22px;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n\n  .h3 {\n    font-size: 20px;\n    line-height: 39px;\n  }\n\n  .h3.small {\n    font-size: 1rem;\n    line-height: 1.4rem;\n  }\n\n  .skill-keyword {\n    font-size: 10px;\n    line-height: 12px;\n  }\n\n  .button.text {\n    font-size: 13px;\n  }\n\n  .dashboard-wrapper {\n    padding-top: 20px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .chat-box-wrapper {\n    padding-top: 20px;\n  }\n\n  .chat-history {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n  }\n\n  .chatbox {\n    padding-left: 5%;\n    padding-right: 5%;\n  }\n\n  .chat-msg {\n    border-radius: 9px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n\n  .chat-msg.reply {\n    align-items: flex-start;\n  }\n\n  .chat-user-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .msg-text {\n    grid-column-gap: 9px;\n    grid-row-gap: 9px;\n  }\n\n  .chat-text {\n    font-size: 13px;\n  }\n\n  .msg-time {\n    font-size: 12px;\n  }\n\n  .expand-history-btn {\n    background-size: 25px;\n  }\n\n  .h4 {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .icon-button {\n    background-size: 17px;\n    padding-top: 0.8rem;\n    padding-bottom: 0.8rem;\n    font-size: 13px;\n  }\n\n  .appdash-wrapper {\n    padding-left: 65px;\n    padding-right: 65px;\n  }\n\n  .task-label {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .app-left-col {\n    padding-left: 5%;\n    padding-right: 5%;\n  }\n\n  .app-links-grid {\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .appdash-wrapper {\n    margin-top: 0;\n  }\n\n  .accordian-body {\n    display: none;\n  }\n\n  .my-workspace-wrapper {\n    flex-flow: column-reverse;\n  }\n\n  .app-right-col {\n    z-index: 999;\n    width: 100%;\n  }\n\n  .app-links-grid {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n}\n\n@media (max-width: 1080px) {\n  .left-menu-link {\n    padding: 4px;\n  }\n}\n\n/* Skill Library Filter Multi Check Box */\n.custom-dropdown {\n  position: relative;\n  display: inline-block;\n  min-width: 250px;\n}\n\n.custom-dropdown.max-dropdown {\n  min-width: 260px;\n}\n\n.dropdown-button {\n  padding: 10px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.dropdown-menu-custom {\n  display: none;\n  position: absolute;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  list-style: none;\n  padding: 10px;\n  z-index: 1000;\n  width: 100%;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n/* .prompt-step-two .dropdown-menu-custom{\nbottom: 30px;\n} */\n.prompt-step-two .dropdown-menu-custom {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.custom-dropdown:hover .dropdown-menu-custom {\n  display: block;\n}\n\n.dropdown-menu-custom li {\n  margin: 5px 0;\n}\n\ninput::file-selector-button {\n  background-image: linear-gradient(to right,\n      #0062ff,\n      #0062ff,\n      #0062ff 100%,\n      #0062ff 200%);\n  background-position-x: 0%;\n  background-size: 200%;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  padding: 7px 10px;\n  cursor: pointer;\n}\n\ninput::file-selector-button:hover {\n  background-color: #0d4eb7;\n}\n\n.prompt-box {\n  display: flex;\n  flex-flow: column;\n  /* align-items: end; */\n  justify-content: space-between;\n}\n\n.feedbackmodal {\n  position: relative;\n}\n\n.feedbackmodal .cross-icon {\n  position: absolute;\n  right: 5px;\n  top: 7px;\n  background: url(../images/cancel-icon.svg);\n  width: 18px;\n  height: 18px;\n  background-size: 18px;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.light-theme .feedbackmodal .cross-icon {\n  filter: invert(1);\n}\n\n/* The container */\n.check-contain {\n  display: block;\n  position: relative;\n  padding-left: 25px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.check-contain input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.checkmark-check {\n  position: absolute;\n  top: 4px;\n  left: 0;\n  height: 21px;\n  width: 21px;\n\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n}\n\n/* On mouse-over, add a grey background color */\n.check-contain:hover input~.checkmark-check {\n  background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n.check-contain input:checked~.checkmark-check {\n  background-color: #2196f3;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark-check:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.check-contain input:checked~.checkmark-check:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.check-contain .checkmark-check:after {\n  left: 7px;\n  top: 1px;\n  width: 7px;\n  height: 14px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.chat-event-btn-wrapper.dropchat {\n  inset: auto auto 210px;\n}\n\n/* The container */\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 0px;\n  cursor: pointer;\n  font-size: 17px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-weight: 500;\n}\n\n/* Hide the browser's default radio button */\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Create a custom radio button */\n.custom-check {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 22px;\n  width: 22px;\n  background-color: #eee;\n  border-radius: 50%;\n}\n\n/* On mouse-over, add a grey background color */\n.checkbox-container:hover input~.custom-check {\n  background-color: #ccc;\n}\n\n/* When the radio button is checked, add a blue background */\n.checkbox-container input:checked~.custom-check {\n  background-color: #2196f3;\n}\n\n/* Create the indicator (the dot/circle - hidden when not checked) */\n.custom-check:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the indicator (dot/circle) when checked */\n.checkbox-container input:checked~.custom-check:after {\n  display: block;\n}\n\n/* Style the indicator (dot/circle) */\n.checkbox-container .custom-check:after {\n  top: 7px;\n  left: 7px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: white;\n}\n\n.allcheck {\n  width: 19px;\n  height: 18px;\n}\n\n.applist-row .checkmark-check {\n  top: -2px;\n  width: 19px;\n  height: 19px;\n  border: 1px solid #e5e5e5;\n}\n\n.view-btn {\n  background: #3a83ff;\n  color: #fff;\n  font-size: 10px;\n  padding: 1px 5px;\n  border-radius: 5px;\n}\n\n.check-contain .checkmark-check:after {\n  left: 6px;\n  top: 0px;\n  width: 6px;\n  height: 13px;\n}\n\n.toggle-menu-mobile {\n  background: url(../images/menuwhite.svg);\n  width: 40px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.toggle-menu-desk {\n  background: url(../images/menu_open.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n  position: absolute;\n  right: -20px;\n  background-color: #7fb0ff;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n}\n\ninput[disabled] {\n  cursor: not-allowed !important;\n}\n\n.toggle-menu-desk:hover {\n  background-color: #5c8cdb;\n}\n\n.dark-theme .toggle-menu-mobile {\n  background: url(../images/menu-blue.svg);\n  background-repeat: no-repeat;\n}\n\n.paragraph.small.mb0 {\n  margin-bottom: 0;\n}\n\n.checklist-row .checkmark-check {\n  top: 0;\n  height: 17px;\n  width: 17px;\n}\n\n.checklist-row .check-contain {\n  padding-left: 30px;\n  margin-bottom: 7px;\n  cursor: pointer;\n  font-size: 12px;\n  -webkit-user-select: none;\n  user-select: none;\n  font-weight: 500;\n}\n\n.checklist-row .check-contain .checkmark-check:after {\n  left: 5px;\n  top: 0px;\n  width: 6px;\n  height: 12px;\n}\n\ntextarea.scrollinput {\n  overflow-y: auto;\n  resize: none;\n  margin: 0 10px;\n  width: 100%;\n  padding: 10px 5px;\n  font-size: 12px;\n  height: 40px;\n  max-height: 12vh;\n}\n\n.dark-theme .ownerdrodown .applist-row .app-name-label {\n  color: #00567d;\n}\n\n.linklists {\n  padding-left: 10px;\n  list-style: decimal;\n}\n\n.attach-file {\n  background: url(../images/attach-file.svg);\n  width: 24px;\n  height: 40px;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n}\n\n/********* toggle button *******/\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 53px;\n  height: 25px;\n  margin-bottom: 0;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 17px;\n  width: 17px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked+.slider {\n  background-color: #2196f3;\n}\n\ninput:focus+.slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked+.slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.switchrow {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  align-items: center;\n  font-size: 15px;\n  margin-top: 15px;\n}\n\n.switchrow.disable {\n  cursor: not-allowed;\n}\n\n.switch.toggle-button-additives {\n  pointer-events: none;\n}\n\n.chart-text-display {\n  text-align: center;\n  margin-top: 10px;\n  color: #7fb0ff;\n}\n\n.slider.round.disable {\n  cursor: not-allowed;\n}\n\n.new-check-row .check-contain {\n  font-size: 15px;\n}\n\n.checklist-row.disable {\n  cursor: not-allowed;\n}\n\n.check-contain.disable {\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.disable .checkmark-check {\n  cursor: not-allowed;\n}\n\n.flex-content {\n  display: flex;\n  gap: 10px;\n}\n\n.left-info-section {\n  display: flex;\n  flex-flow: column;\n  gap: 10px;\n}\n\n.notif-right-section {\n  width: 60%;\n}\n\n.user-set {\n  display: flex;\n  justify-content: space-between;\n}\n\n.user-dec-info {\n  background: #f8f8f8;\n  padding: 20px;\n  display: flex;\n  flex-flow: column;\n  gap: 8px;\n}\n\n.prompt-desc-style {\n  font-size: 12px;\n}\n\n.prompt-desc-style h3 {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n\n.more-details {\n  margin-top: 12px;\n}\n\n.user-prompt-desc {\n  display: flex;\n  flex-flow: column;\n  gap: 5px;\n}\n\n.left-info-section {\n  width: 40%;\n  max-height: calc(100vh - 163px);\n  overflow-y: auto;\n}\n\n.user-breif {\n  display: flex;\n  gap: 10px;\n  border: 1px solid #e5e5e5;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.clear-chatbtn {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-right: 10px;\n  position: absolute;\n  right: 53px;\n  top: 7px;\n}\n\n.show-followup-btn {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n\n  position: absolute;\n  right: 39px;\n  top: 7px;\n}\n\n.follow-up-icon-blur {\n  opacity: 0.5;\n}\n\n.suggest-line-wrapper {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.suggest-line {\n  background: #053a64;\n  border-radius: 10px;\n  padding: 1px 14px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.suggest-line-disabled {\n  background: #dee5ea;\n  border-radius: 10px;\n  padding: 1px 14px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.follow-up-section {\n  border-top: 1px solid #e5e5e5;\n  width: 100%;\n  padding: 6px 0;\n  margin-top: 9px;\n}\n\n.follow-up-section {\n  border-top: 1px solid #e5e5e5;\n  width: 100%;\n  padding: 6px 0;\n  margin-top: 9px;\n}\n\n.clear-chatbtn.disabled-div .trash-icon {\n  cursor: not-allowed;\n}\n\n.trash-icon:hover::after {\n  content: attr(data-title);\n  position: absolute;\n  right: 24px;\n  color: #000;\n  font-size: 10px;\n  line-height: 13px;\n  background: #f6f6f6;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n  width: 74px;\n}\n\n.follow-up-icon:hover::after {\n  content: attr(data-follow);\n  position: absolute;\n  right: 24px;\n  color: #000;\n  font-size: 10px;\n  line-height: 13px;\n  background: #f6f6f6;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n  width: 74px;\n}\n\n.copy-clipboard:hover::after {\n  content: attr(data-title);\n  position: absolute;\n  left: 23px;\n  top: 0;\n  color: #000;\n  font-size: 10px;\n  line-height: 13px;\n  background: #f6f6f6;\n  padding: 3px 9px;\n  border-radius: 5px;\n  z-index: 2;\n  width: 52px;\n}\n\n.copy-clipboard:hover::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 6px solid #f6f6f6;\n  left: 17px;\n  position: absolute;\n  top: 4px;\n}\n\n.dark-theme .copy-clipboard:hover::after {\n  background: transparent;\n  border: 1px solid;\n  color: #fff;\n}\n\n.dark-theme .copy-clipboard:hover::before {\n  display: none;\n}\n\n.pagination-container .paginate-link {\n  background-color: transparent !important;\n}\n\n.excel-box-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: 12px;\n  margin-top: 10px;\n  border: 1px solid #e5e5e5;\n\n  border-radius: 0 0 10px 10px;\n  padding-bottom: 10px;\n}\n\n.flex-col {\n  width: 100%;\n  margin-right: 74px;\n}\n\n.w-80 {\n  width: 80%;\n}\n\n.heading-gray {\n  padding: 6px 10px;\n  background: #e5e5e5;\n}\n\n.dark-theme .heading-gray {\n  color: #000;\n}\n\n.dark-theme .excel-box-wrapper .close-icon {\n  filter: brightness(20);\n}\n\n.desc-row {\n  padding: 5px 10px;\n  align-items: flex-start;\n  border-bottom: 1px solid #e5e5e5;\n  display: grid;\n  grid-template-columns: 20% 54% 20% 40px;\n}\n\n.visibilty-hidden {\n  visibility: hidden;\n}\n\n.trash-icon:hover::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #f6f6f6;\n  right: 19px;\n  position: absolute;\n  top: 4px;\n}\n\n.follow-up-icon:hover::before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #f6f6f6;\n  right: 19px;\n  position: absolute;\n  top: 4px;\n}\n\n.dark-theme .trash-icon {\n  background: url(../images/trashicon-white.svg);\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.dark-theme .follow-up-icon {\n  background: url(../images/follow-up-white.svg);\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.trash-icon {\n  background: url(../images/trashicon.svg);\n  width: 20px;\n  height: 20px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  position: relative;\n}\n\n.follow-up-icon {\n  background: url(../images/follow-up.svg);\n  width: 20px;\n  height: 20px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  position: relative;\n}\n\n.msg-text p {\n  margin-bottom: 0;\n}\n\n/********dark theme*****/\n.dark-theme .skill-icon-block .ai-block-icon {\n  filter: brightness(45.5);\n}\n\n/* .dark-theme .prompt-action-count {\n  color: #fff;\n} */\n\n.dark-theme .msg-text {\n  color: #000;\n}\n\n.dark-theme .applist-view .app-logo-icon img {\n  background-color: #fff;\n}\n\n.dark-theme .private-icon {\n  filter: brightness(11.5);\n}\n\n.dark-theme .public-icon {\n  filter: brightness(11.5);\n}\n\n.dark-theme .chat-right {\n  color: #000;\n}\n\n.dark-theme .upload-drag p {\n  color: #000;\n}\n\n.dark-theme .dash-menu.open .menu-logo {\n  background: url(\"../images/mks_logo-blue-icon.png\");\n  width: 32px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.dark-theme .chat-history-sec,\n.dark-theme .checkbox-list.show {\n  box-shadow: 2px 2px 10px #000000;\n}\n\n.dark-theme .version-link .col-text {\n  background-color: #6f94bb;\n}\n\n.dark-theme .version-link .col-text:hover {\n  background-color: #005488;\n}\n\n.dark-theme .check-class {\n  accent-color: #6f94bb;\n}\n\nbutton[disabled] {\n  cursor: not-allowed;\n}\n\n.dark-theme .allcheck {\n  accent-color: #6f94bb;\n}\n\n.dark-theme .prompt-user-img {\n  background-color: #80ce1a;\n}\n\n.dark-theme .dash-body {\n  background-color: #053a64;\n  color: #fff;\n}\n\n.dark-theme .suggestion-item {\n  color: #000;\n  padding: 3px;\n  border-bottom: 1px solid #f3f3f3;\n  font-size: 11px;\n}\n\n.suggestion-item-heading {\n  color: #000;\n  padding: 3px;\n  border-bottom: 1px solid #f3f3f3;\n  font-size: 14px;\n}\n\n.suggestion-item.selected {\n  background-color: #d3d3d3;\n  /* Highlight color */\n}\n\n.dark-theme .workspace-dashboard {\n  background-color: #ffffff;\n}\n\n.dark-theme .left-menu-link {\n  color: #053a64;\n}\n\n.dark-theme .menu-icon {\n  filter: invert(1);\n}\n\n.dark-theme .dash-header h1 {\n  color: #fff;\n}\n\n.dark-theme .paragraph {\n  color: #fff;\n}\n\n.dark-theme .flexbox {\n  background-color: #053a64;\n}\n\n.dark-theme .menu-logo {\n  background-image: url(\"../images/mks_logo-blue.png\");\n  background-position: 0%;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.dark-theme .skill-detail-left {\n  background-color: transparent;\n}\n\n.dark-theme .upperchartbox {\n  box-shadow: 2px 2px 10px #000000;\n  color: #000;\n}\n\n.dark-theme .upperchartbox .prompt-tabs-link.w--current {\n  border-bottom-color: #053a64;\n  color: #053a64;\n}\n\n.dark-theme .left-menu-link:hover {\n  background-color: #053a64;\n  color: #fff;\n}\n\n.dark-theme .left-menu-link:hover .menu-icon {\n  filter: invert(0);\n}\n\n.dark-theme .contact-detail {\n  color: #000;\n}\n\n.dark-theme .infotext {\n  color: #000;\n}\n\n.dark-theme .skill-detaill-right h3 {\n  color: #000;\n}\n\n.dark-theme .skill-detaill-right-full h3 {\n  color: #000;\n}\n\n.dark-theme .skill-subtitle-info {\n  color: #000;\n}\n\n.skill-tags h3 {\n  color: #000;\n}\n\n.dark-theme .button.light {\n  color: #fff;\n}\n\n.dark-theme .dash-section {\n  background-color: transparent;\n}\n\n.dark-theme .ai-collection-link-block {\n  box-shadow: none;\n}\n\n.dark-theme .ai-collection-link-block:hover {\n  box-shadow: 2px 2px 30px #373737;\n}\n\n.selected-Video-hover {\n  box-shadow: 2px 2px 30px #999898;\n}\n\n.input-search-videos {\n  margin-bottom: 5px;\n}\n\n.light-grey {\n  background-color: #ebebeb;\n  padding: 22px;\n  border-radius: 5px;\n  justify-content: center;\n  gap: 0;\n}\n\n.dark-theme .h2 {\n  color: #fff;\n}\n\npopup-heading {\n  color: #ea384c;\n}\n\n.dark-theme .button.text:hover {\n  background-color: #fff;\n}\n\n.dark-theme .app-group-heading {\n  color: #fff;\n}\n\n.dark-theme .custom-application img {\n  filter: invert(0);\n}\n\n.dark-theme .draggable-button {\n  filter: invert(1);\n}\n\n.dark-theme .prompt-tabs-link.w--current {\n  border-bottom-color: #fff;\n  color: #fff;\n}\n\n.dark-theme .skill-filter-wrapper {\n  background-color: transparent;\n  border: 0;\n}\n\n.dark-theme .edit-button-icon {\n  filter: brightness(63.5);\n}\n\n.dark-theme .trash-button-icon a {\n  color: #fff;\n}\n\n.dark-theme .trash-button-icon .trash-icon::before {\n  display: none;\n}\n\n.dark-theme .prompt-tabs .ai-collection-grid.light-bg {\n  background: transparent;\n  padding: 0;\n}\n\n.dark-theme .prompts-tabs-content .skill-filter-wrapper {\n  padding: 17px 0;\n}\n\n.dark-theme .prompt-steps {\n  background-color: transparent;\n}\n\n.dark-theme .preference-wrapper {\n  background-color: transparent;\n  padding: 0;\n}\n\n.dark-theme .breadcrumb .normal-link {\n  color: #fff;\n}\n\n.dark-theme .normal-link::after,\n.dark-theme .home-link::after {\n  opacity: 1;\n  filter: invert(1);\n}\n\n.dark-theme .normal-link.long-title:hover::after {\n  filter: invert(0);\n}\n\n.dark-theme .prompt-pii {\n  color: #000;\n}\n\n.dark-theme select,\n.dark-theme input,\n.dark-theme textarea {\n  color: #000;\n}\n\n.dark-theme .ai-collection-info-block .paragraph.small {\n  color: #000;\n}\n\n.dark-theme .prompt-gen .selected-tag {\n  background: #818181;\n}\n\n.dark-theme .modal-content {\n  background-color: #053a64;\n}\n\n.dark-theme .confirmation-content-wrapper {\n  background-color: #053a64;\n}\n\n.dark-theme .p-tag {\n  background: #6f94bb;\n  gap: 5px;\n}\n\n.dark-theme .close-icon {\n  filter: brightness(0.1);\n  width: 12px;\n  height: 12px;\n}\n\n.dark-theme .backbtn {\n  border-radius: 29px;\n}\n\n.dark-theme .user-profile-menu {\n  border: 0;\n}\n\n.dark-theme .chatprompt-form {\n  padding: 0;\n}\n\n.dark-theme .chatprompt-field-label {\n  background: #6f94bb;\n  cursor: pointer;\n}\n\n.dark-theme .chatprompt-field-label:hover {\n  background-color: #005488;\n}\n\n.dark-theme .sample-prompts {\n  background-color: #fff;\n}\n\n.dark-theme .feedbacktext {\n  background-color: #092f4d;\n}\n\n.chat-button:hover {\n  background-color: #20457f;\n}\n\ninput[disabled].chat-button:hover {\n  background-color: #0062ff;\n}\n\n.dark-theme input.chat-button.w-button {\n  color: #fff;\n}\n\n.dark-theme .edit-prompt-header .prompt-action-count {\n  color: #fff;\n}\n\n.dark-theme input.chat-button.w-button:hover {\n  background-color: #37618c;\n}\n\n.dark-theme input[disabled].chat-button.w-button:hover {\n  background-color: #6f94bb;\n}\n\n.dark-theme .feedback-right-section {\n  background: #86919b;\n}\n\n.dark-theme .copy-clipboard {\n  filter: brightness(62.5);\n}\n\n.dark-theme .dash-section.p20 {\n  padding: 0;\n}\n\n.dark-theme .applist-row .app-name-label {\n  color: #fff;\n  font-weight: 500;\n}\n\n.dark-theme .left-menu-link.w--current {\n  background-color: #053a64;\n  color: #fff;\n}\n\n.dark-theme .left-menu-link.w--current .menu-icon {\n  filter: invert(0);\n}\n\n.dark-theme .chat-tablink {\n  color: #dddddd;\n}\n\n.dark-theme .dash-header h1 span {\n  color: #80ce1a;\n}\n\n.dark-theme .chat-tablink.w--current {\n  background-color: #ffffff;\n  color: #6f94bb;\n}\n\n.dark-theme .chat-button {\n  background-color: #6f94bb;\n}\n\n.dark-theme .button {\n  background-color: #6f94bb;\n}\n\n.dark-theme .button:hover,\n.dark-theme .icon-button.add:hover {\n  background-color: #005488;\n}\n\n.dark-theme .skill-keyword {\n  background-color: #6f94bb;\n  color: #fff;\n}\n\n.dark-theme .button.text {\n  background: transparent;\n  color: #6f94bb;\n}\n\n.dark-theme .read-more-text {\n  color: #6f94bb;\n}\n\n.dark-theme .icon-button {\n  background-color: #6f94bb;\n}\n\n.dark-theme .p-done .p-dot {\n  background-color: #6f94bb;\n}\n\n.dark-theme .p-done::after {\n  background-color: #6f94bb;\n}\n\n.dark-theme .p-current .p-dot {\n  border: 1px solid #6f94bb;\n}\n\n.dark-theme .breadcrumb a.visited:hover {\n  color: #6f94bb;\n}\n\n.dark-theme .home-link::before {\n  background: url(../images/mkspropmanagment/homegreen.svg);\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n}\n\n.dark-theme .check-contain input:checked~.checkmark-check {\n  background-color: #6f94bb;\n}\n\n.dark-theme .chatprompt-button {\n  background-color: #6f94bb;\n}\n\n.dark-theme .terminal-button {\n  background-color: transparent;\n}\n\n.dark-theme .terminal-button.w--current {\n  background-color: #fff;\n  color: #6f94bb;\n}\n\n.dark-theme .chat-event-button {\n  background-color: #6f94bb;\n  color: #fff;\n}\n\n.dark-theme .like-icon {\n  filter: brightness(56.5);\n}\n\n.dark-theme .chat-event-button:hover {\n  background-color: #005488;\n}\n\n.dark-theme .chatprompt-button:hover {\n  background-color: #005488;\n}\n\n.dark-theme .div-table-header {\n  background-color: #6f94bb;\n}\n\n.dark-theme .upperchartbox .skill-filter-wrapper {\n  padding: 17px 20px;\n}\n\n.dark-theme .checkbox-container input:checked~.custom-check {\n  background-color: #6f94bb;\n}\n\n.dark-theme input::file-selector-button {\n  background-image: linear-gradient(to right,\n      #6f94bb,\n      #6f94bb,\n      #6f94bb 100%,\n      #6f94bb 200%);\n  background-position-x: 0%;\n  background-size: 200%;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  padding: 7px 10px;\n  cursor: pointer;\n}\n\n.dark-theme input[type=\"file\"] {\n  color: #fff;\n}\n\n.dark-theme input::file-selector-button:hover {\n  background-color: #74bd15;\n}\n\n.dark-theme .prompt-creator-block {\n  color: #000;\n}\n\n.dark-theme .coment-section {\n  background: #053a64;\n}\n\n.dark-theme .light-coment-bg {\n  color: #000;\n}\n\n.dark-theme .coment-section .close-icon {\n  filter: invert(1);\n}\n\n.dark-theme .submit-btn {\n  background: #6f94bb;\n}\n\n.mb-10 {\n  margin-bottom: 10px;\n}\n\n.chat-text .linkclass.mb-10:nth-child(1) {\n  margin-top: 10px;\n}\n\n.dark-theme .user-dec-info {\n  color: #000;\n}\n\n.dark-theme .pagination-container .pagination-wrapper {\n  color: #fff;\n}\n\n.dark-theme .pagination-container .padding-right-5,\n.dark-theme .pagination-container .paginate-highlight {\n  color: #fff;\n}\n\n.dark-theme .user-table-list .pagination-container .pagination-wrapper {\n  color: #000;\n}\n\n.dark-theme .user-table-list .pagination-container .padding-right-5,\n.dark-theme .user-table-list .pagination-container .paginate-highlight {\n  color: #000;\n}\n\n.dark-theme .pagination-container .no-border {\n  filter: invert(1);\n  color: #000;\n}\n\n.dark-theme .user-table-list .pagination-container .no-border {\n  filter: invert(0);\n  color: #000;\n}\n\n.dark-theme .user-table-list .pagination-container .paginate-link {\n  filter: invert(0);\n}\n\n.dark-theme .user-breif {\n  background-color: #fff;\n  color: #474444;\n}\n\n.dark-theme .unread-notif {\n  background: #f7f7f7;\n  color: #0092ff;\n}\n\n.dark-theme .user-breif.selected {\n  border: 3px solid #80ce1a;\n}\n\n.dark-theme .prompt-badge {\n  color: #000;\n}\n\n.dark-theme .edit-common-icons .private-icon,\n.dark-theme .edit-common-icons .thumbs-up-icon,\n.dark-theme .edit-common-icons .views-icon,\n.dark-theme .edit-common-icons .share-icon,\n.dark-theme .edit-common-icons .comment-icon {\n  filter: brightness(7.5);\n}\n\n.dark-theme input[disabled].prompt-text {\n  color: #fff;\n}\n\n.dark-theme .medium-font {\n  color: #fff;\n}\n\n.dark-theme .pagination-container .paginate-link {\n  background-color: transparent;\n  filter: invert(1);\n}\n\n.dark-theme .pdf-full-expand .prompt-tabs-link.w--current {\n  border-bottom-color: #053a64;\n  color: #053a64;\n}\n\n.dropdown-with-button.disabled-parent {\n  cursor: not-allowed;\n}\n\n.dropdown-with-button.disabled-parent .genrate-btn {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.not-clickable {\n  cursor: not-allowed;\n}\n\n.custom-dropdown.disabled-parent,\nselect.skill-filter-field.w-select.disabled-element {\n  pointer-events: none;\n  background-color: #f2f2f2;\n}\n\n.dropdown-button.disabled-element {\n  background-color: #f2f2f2;\n}\n\n.applist-row.border-line {\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 9px;\n}\n\n.instruction-lines {\n  padding: 0 0 0 14px;\n  margin: 0;\n}\n\n.line-height-normal {\n  line-height: 12px;\n}\n\n.mobile-absolute-icon .close-icon {\n  margin-top: 10px;\n  width: 18px;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n@media screen and (max-width: 767px) {\n\n  .chart-div-display,\n  .chart-row-view {\n    flex-direction: column;\n  }\n\n  .chart-button-display {\n    padding: 6px 11px;\n    font-size: 12px;\n  }\n\n  .chart-display-width {\n    width: 100%;\n  }\n\n  .user-role-row {\n    grid-template-columns: 1fr;\n    position: relative;\n    gap: 0;\n    border: 1px solid #ccc;\n  }\n\n  .add-user-modal .modal-content {\n    width: 90%;\n  }\n\n  div#container_mainContainer {\n    min-height: 68vh !important;\n  }\n\n  .suggestions.prompt-suggestions {\n    width: 100%;\n  }\n\n  .dash-menu .dropdown-label .down-arrow {\n    filter: invert(1);\n  }\n\n  .top-bar {\n    flex-flow: column-reverse;\n    gap: 10px;\n    align-items: flex-end;\n  }\n\n  .top-bar .search-cross-icon-common {\n    max-width: 100%;\n  }\n\n  .modal-header h2 {\n    word-break: break-word;\n  }\n\n  .modal-popup-header h3 {\n    word-break: break-word;\n  }\n\n  .height-100 {\n    min-height: calc(100vh - 100px);\n  }\n\n  /* a.visited.normal-link {\n    width: 280px;\n  } */\n  .chat-event-button.stop-generate.w-button {\n    padding-left: 37px;\n  }\n\n  .cancel-btn {\n    margin-bottom: 2px;\n  }\n\n  .copy-clipboard:hover::after {\n    left: 19px;\n    padding: 3px 4px;\n  }\n\n  .trash-icon {\n    top: -49px;\n    z-index: 1;\n  }\n\n  .trash-button-icon .trash-icon {\n    top: 0px;\n  }\n\n  .trash-button-icon .trash-icon::after {\n    display: none;\n  }\n\n  .medium-font {\n    font-size: 16px;\n    line-height: 20px;\n    text-align: center;\n  }\n\n  .chat-box-wrapper .w-button {\n    padding: 7px 15px;\n  }\n\n  .description-rows {\n    gap: 10px;\n  }\n\n  .desc-row {\n    grid-template-columns: 1fr;\n    border: 1px solid #e5e5e5;\n    position: relative;\n  }\n\n  .excel-title::before {\n    content: \"Title : \";\n    font-weight: 600;\n  }\n\n  .user-role-row .excel-title::before {\n    content: \"User Name : \";\n    font-weight: 600;\n  }\n\n  .excel-title {\n    padding-right: 40px;\n  }\n\n  .excel-skill::before {\n    content: \"Skill : \";\n    font-weight: 600;\n  }\n\n  .excel-dec::before {\n    content: \"Description : \";\n    font-weight: 600;\n  }\n\n  .user-role-row .excel-dec::before {\n    content: \"Role Type : \";\n    font-weight: 600;\n  }\n\n  .mobile-absolute-icon {\n    position: absolute;\n    right: 10px;\n    top: 5px;\n  }\n\n  .excel-box-wrapper {\n    border: 0;\n  }\n\n  .desc-row.heading-gray {\n    display: none;\n  }\n\n  .skill-info-wrapper {\n    left: 0;\n  }\n\n  .ai-block-header .h3.small {\n    max-width: 195px;\n  }\n\n  .dash-menu.hide-on-mobile {\n    display: none;\n  }\n\n  textarea.chat-input-field.w-input.home-chat-field.scrollinput {\n    padding: 2px 5px 6px 5px;\n  }\n\n  .prompt-share-header h3 {\n    font-size: 18px;\n  }\n\n  textarea.scrollinput {\n    padding: 2px 6px;\n    margin: 0;\n  }\n\n  .tabs-menu.h-flex.head-wrapper.w-tab-menu.test-tab {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  .custom-dropdown {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .prompt-icon span {\n    display: none;\n  }\n\n  .chatprompt-field-label {\n    width: auto;\n  }\n\n  .auto-chat-row {\n    display: none;\n  }\n\n  .chat-table-lis-row {\n    grid-template-columns: 1fr;\n    gap: 5px;\n  }\n\n  .chem-addit::before {\n    content: \"Chemical Additives :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .count-name::before {\n    content: \"Count :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .type-name::before {\n    content: \"Type :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .compound-name::before {\n    content: \"Compound :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .original-name::before {\n    content: \"Chemical Additives in Original Language :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .percent-name::before {\n    content: \"Occurrence in Percentage :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .patent-name::before {\n    content: \"Patent Numbers :\";\n    margin-right: 10px;\n    font-weight: 600;\n  }\n\n  .pagination-custom {\n    justify-content: center;\n  }\n\n  .absolute-icon {\n    top: -6px;\n  }\n\n  .pagination-container .pagination-block {\n    padding: 0 !important;\n    gap: 2px;\n  }\n\n  .pagination-container .pagination-wrapper {\n    font-size: 10px !important;\n    gap: 2px;\n  }\n\n  .pagination-container .paginate-link.next-page,\n  .pagination-container .paginate-link.last-page,\n  .pagination-container .paginate-link.previous-page,\n  .pagination-container .paginate-link {\n    width: 11px !important;\n  }\n\n  .clear-chatbtn {\n    right: 0;\n    top: 56px;\n  }\n\n  .chattab-wrap {\n    display: flex;\n    justify-content: flex-start !important;\n  }\n\n  .user-set {\n    flex-flow: column;\n  }\n\n  .user-time-detail {\n    font-size: 12px;\n  }\n\n  .left-info-section.mobile-hide {\n    display: none;\n  }\n\n  .notif-right-section {\n    width: 100%;\n  }\n\n  .notif-right-section.hide-mobile {\n    display: none;\n  }\n\n  .gridlisticon {\n    background: url(../images/gridlist.svg);\n    width: 23px;\n    height: 23px;\n    background-size: 100%;\n    background-repeat: no-repeat;\n  }\n\n  .dark-theme .gridlisticon {\n    background: url(../images/gridlist-white.svg);\n    background-size: 100%;\n    background-repeat: no-repeat;\n  }\n\n  .left-info-section {\n    width: 100%;\n    max-height: calc(100vh - 205px);\n  }\n\n  .flex-content {\n    flex-flow: column;\n  }\n\n  .loader-text.login-text-loader {\n    background: transparent;\n    color: #00558a;\n  }\n\n  .dropbox-wrapper-main {\n    padding: 6px 10px;\n  }\n\n  .import-prompt-box {\n    padding: 20px 20px 0 20px;\n    font-size: 12px;\n  }\n\n  .dropbox-wrapper-main {\n    padding-bottom: 46px;\n  }\n\n  .hide-on-mobile {\n    display: none;\n  }\n\n  .breadcrumb .normal-link {\n    font-size: 11px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .breadcrumb a.visited {\n    font-size: 11px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .pdfview.overlap {\n    width: 85%;\n    height: 70vh;\n    max-height: 70vh;\n    bottom: 41px;\n    top: 0;\n\n    right: 14px;\n  }\n\n  .pdf-full-expand {\n    width: 89%;\n    top: auto;\n    bottom: 44px;\n    right: 5px;\n    height: calc(100vh - 136px);\n  }\n\n  .pdf-full-expand.hide {\n    height: auto;\n  }\n\n  .inner-tab-content {\n    max-height: calc(100vh - 251px);\n  }\n\n  .pdf-full-expand.hide .pdf-expand {\n    top: 0;\n    right: 34%;\n    height: 25px;\n    background-color: transparent;\n  }\n\n  .modal-content.comment-modal {\n    width: 93%;\n  }\n\n  .feedabck-wrapper {\n    flex-direction: column;\n    overflow-y: auto;\n    padding: 10px;\n  }\n\n  .prompts-tabs-content .search-cross-icon-common {\n    width: 100%;\n  }\n\n  .modal-header {\n    width: 100%;\n    word-break: break-all;\n    overflow: hidden;\n  }\n\n  .popup-btn-container {\n    flex-flow: column;\n  }\n\n\n\n  .image-control .popup-btn-container {\n    flex-direction: column;\n  }\n\n  .btn-add-promt {\n    width: 100px;\n  }\n\n  .dark-theme .left-menu-link {\n    color: #fff;\n  }\n\n  .dark-theme .menu-icon {\n    filter: invert(0);\n  }\n\n  .skill-full-wrap {\n    padding: 10px;\n  }\n\n  .chat-msg {\n    padding: 0;\n  }\n\n  .prompt-steps {\n    padding: 0;\n  }\n\n  .left-menu-link {\n    padding: 6px;\n  }\n\n  .dash-body {\n    width: 100%;\n  }\n\n  .workspace-dashboard {\n    flex-direction: column;\n    padding: 10px;\n  }\n\n  .dash-menu.open {\n    display: none;\n  }\n\n  .toggle-areas {\n    flex-direction: row;\n    gap: 10px;\n    justify-content: center;\n    display: flex;\n    position: fixed;\n    bottom: 0px;\n    left: 0;\n    right: 0;\n  }\n\n  .checkbox-list.show {\n    width: 100%;\n  }\n\n  .chat-right {\n    position: absolute;\n    bottom: 0px;\n    background: #fff;\n    width: 100%;\n    height: auto;\n    top: auto;\n  }\n\n  .chat-box-wrapper {\n    position: relative;\n  }\n\n  .chat-history-sec.show {\n    width: 100%;\n  }\n\n  .dash-menu {\n    width: 67%;\n    display: flex;\n    background-image: linear-gradient(#041f35f5, #041f35f5),\n      url(../images/mksapp/dot-bg-1.svg);\n    background-position: 0 0, 50%;\n    position: absolute;\n    left: 9px;\n    margin: 0 auto;\n    top: 61px;\n    z-index: 3;\n    height: calc(100vh - 68px);\n  }\n\n  .dash-page-header.light-bg {\n    padding: 15px 20px;\n  }\n\n  .prompt-selects {\n    flex-direction: column;\n  }\n\n  .section-wrapper {\n    padding: 20px;\n  }\n\n  .ai-collection-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dash-section.p20 {\n    padding: 12px;\n  }\n\n  .left-menu-header {\n    display: none;\n  }\n\n  .mobile-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n  }\n\n  .my-workspace-wrapper {\n    flex-flow: column-reverse;\n  }\n\n  .upperchartbox {\n    margin-left: 0;\n    max-height: 33vh;\n    overflow: auto;\n    width: 89%;\n    margin-left: 20px;\n  }\n\n  .div-table-row {\n    grid-template-columns: 1fr 1fr 1fr;\n    word-break: break-all;\n  }\n\n  .dropchat-wrap {\n    margin: 0 20px 0 0px;\n  }\n\n  .custom-div-table {\n    overflow: visible;\n  }\n\n  .welcome-wrapper {\n    padding: 15px 9px;\n  }\n\n  .app-right-col {\n    width: 100%;\n  }\n\n  .h-flex.head-wrapper.input-workspace {\n    position: relative;\n    padding-left: 0;\n    width: 100%;\n  }\n\n  .app-group-heading {\n    line-height: normal;\n    padding-bottom: 10px;\n  }\n\n  .app-link-tile {\n    height: 100%;\n  }\n\n  .chat-terminal-wrapper {\n    flex-flow: column;\n    overflow: auto;\n    min-height: calc(88vh - 89px);\n    max-height: calc(88vh - 89px);\n  }\n\n  .chatbox {\n    padding: 0 10px 5px 10px;\n    max-height: calc(70vh - 55px);\n    overflow: auto;\n  }\n\n  .skill-filter-form {\n    display: grid;\n  }\n\n  .chatprompt-block {\n    padding: 35px 0 0 20px;\n  }\n\n  .skill-filter-wrapper {\n    padding: 20px;\n  }\n\n  .chat-tab-menu.w-tab-menu {\n    display: flex;\n    width: 100%;\n  }\n\n  .chat-tablink {\n    padding: 6px 15px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .view-link-block {\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .app-links-grid {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .w-nav-brand {\n    padding-left: 10px;\n  }\n\n  .w-nav[data-collapse=\"small\"] .w-nav-menu {\n    display: none;\n  }\n\n  .w-nav[data-collapse=\"small\"] .w-nav-button {\n    display: block;\n  }\n\n  .w-nav-brand {\n    padding-left: 10px;\n  }\n\n  .dark-theme .login-form-logo {\n    margin-left: 0px;\n  }\n\n  .prompt-step-desc {\n    display: none;\n  }\n\n  .prompt-step-name {\n    text-align: center;\n    font-size: 12px;\n    line-height: 16px;\n    height: 33px;\n    max-height: 27px;\n  }\n\n  .prompt-img-title {\n    flex-direction: column;\n  }\n\n  .prompt-explanaion {\n    grid-template-columns: 100%;\n  }\n\n  .prompt-step-two .prompt-explanaion {\n    grid-template-columns: 100%;\n  }\n\n  .prompt-button-wrapper {\n    flex-direction: column-reverse;\n    text-align: center;\n    gap: 10px;\n  }\n\n  .prompt-review-wrap {\n    flex-direction: column;\n    grid-template-columns: 1fr;\n  }\n\n  .genrate-btn {\n    padding: 10px 13px;\n  }\n\n  .workspace-dashboard.flex-end {\n    flex-direction: column;\n    padding-left: 10px;\n  }\n\n  .left-user-settings.hide-on-mobile {\n    display: none;\n  }\n\n  .dash-header {\n    padding: 11px 20px;\n  }\n\n  .dash-header h1 {\n    font-size: 18px;\n    line-height: 27px;\n  }\n\n  .dash-header .paragraph {\n    font-size: 9px;\n    line-height: 12px;\n  }\n\n  .skill-detail-wrapper {\n    flex-direction: column;\n    padding: 10px;\n  }\n\n  .skill-detail-left {\n    width: 100%;\n  }\n\n  .create-skill-left {\n    padding: 0 7px;\n  }\n\n  .description-wrap {\n    flex-flow: column;\n  }\n\n  .skill-fullwidth {\n    padding: 0 10px;\n    margin-bottom: 10px;\n  }\n\n  .max-width-row {\n    width: 100%;\n    flex-flow: column;\n    max-width: 100%;\n  }\n\n  .skill-detaill-right {\n    width: 100%;\n  }\n\n  .skill-detaill-right-full {\n    width: 100%;\n  }\n\n  .skill-one-row {\n    flex-flow: column;\n    gap: 10px;\n    margin-bottom: 15px;\n    min-height: auto;\n  }\n\n  .skill-heading h2 {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .skill-block-header {\n    gap: 10px;\n  }\n\n  .skill-flex-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .skill-update-box {\n    flex-direction: column;\n  }\n\n  .login-form-logo {\n    width: 100%;\n    height: 41%;\n  }\n\n  .skill-contact-person {\n    flex-direction: column;\n  }\n\n  .breadcrumb {\n    padding: 20px 16px 0;\n    flex-wrap: nowrap;\n  }\n\n  .login-form-wrapper {\n    width: 100%;\n    border-radius: 0 0 20px 20px;\n    justify-content: flex-start;\n  }\n\n  .login-logo-img {\n    margin-top: 50px;\n  }\n\n  .login-bg-video {\n    border-radius: 20px 20px 0 0;\n  }\n\n  .login-logo {\n    width: 120px;\n    height: 120px;\n  }\n\n  .w-hidden-main,\n  .w-hidden-medium {\n    display: inherit !important;\n  }\n\n  .w-hidden-small {\n    display: none !important;\n  }\n\n  .w-row,\n  .w-container .w-row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .w-col {\n    width: 100%;\n    left: auto;\n    right: auto;\n  }\n\n  .w-col-small-1 {\n    width: 8.33333%;\n  }\n\n  .w-col-small-2 {\n    width: 16.6667%;\n  }\n\n  .w-col-small-3 {\n    width: 25%;\n  }\n\n  .w-col-small-4 {\n    width: 33.3333%;\n  }\n\n  .w-col-small-5 {\n    width: 41.6667%;\n  }\n\n  .w-col-small-6 {\n    width: 50%;\n  }\n\n  .w-col-small-7 {\n    width: 58.3333%;\n  }\n\n  .w-col-small-8 {\n    width: 66.6667%;\n  }\n\n  .w-col-small-9 {\n    width: 75%;\n  }\n\n  .w-col-small-10 {\n    width: 83.3333%;\n  }\n\n  .w-col-small-11 {\n    width: 91.6667%;\n  }\n\n  .w-col-small-12 {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .w-container {\n    max-width: none;\n  }\n\n  .edit-prompt-info .flex-row {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    column-gap: 8px;\n    row-gap: 5px;\n  }\n\n  .verticleline {\n    display: none;\n  }\n\n  .button-use-promp {\n    margin-bottom: 17px;\n    margin-top: 11px;\n    margin-left: auto;\n  }\n\n  .edit-common-icons {\n    padding: 2px 6px;\n  }\n\n  .edit-prompt-info {\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0;\n    margin-bottom: 0;\n  }\n\n  .dropdown-with-button {\n    flex-flow: column;\n  }\n\n  .dropdown-with-button .prompt-title-wrap {\n    width: 100%;\n  }\n\n  .w-hidden-main,\n  .w-hidden-medium,\n  .w-hidden-small {\n    display: inherit !important;\n  }\n\n  .w-hidden-tiny {\n    display: none !important;\n  }\n\n  .w-col {\n    width: 100%;\n  }\n\n  .w-col-tiny-1 {\n    width: 8.33333%;\n  }\n\n  .w-col-tiny-2 {\n    width: 16.6667%;\n  }\n\n  .w-col-tiny-3 {\n    width: 25%;\n  }\n\n  .w-col-tiny-4 {\n    width: 33.3333%;\n  }\n\n  .w-col-tiny-5 {\n    width: 41.6667%;\n  }\n\n  .w-col-tiny-6 {\n    width: 50%;\n  }\n\n  .w-col-tiny-7 {\n    width: 58.3333%;\n  }\n\n  .w-col-tiny-8 {\n    width: 66.6667%;\n  }\n\n  .w-col-tiny-9 {\n    width: 75%;\n  }\n\n  .w-col-tiny-10 {\n    width: 83.3333%;\n  }\n\n  .w-col-tiny-11 {\n    width: 91.6667%;\n  }\n\n  .w-col-tiny-12 {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .edit-col {\n    font-size: 10px;\n  }\n\n  .appdash-wrapper {\n    height: auto;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  .my-workspace-wrapper {\n    padding: 7px;\n  }\n\n  .app-group {\n    flex-flow: column;\n    padding-left: 18px;\n    padding-right: 18px;\n    display: flex;\n  }\n\n  .app-left-col {\n    padding: 6px;\n  }\n\n  .app-link-tile {\n    border-style: solid;\n    width: 100%;\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n\n  .app-right-col {\n    width: 100%;\n    margin-top: 0;\n    padding: 6px;\n  }\n\n  .app-logo-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .app-logo-icon.wide {\n    width: 60px;\n    height: 30px;\n    margin-bottom: 1px;\n  }\n\n  .app-links-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .accordian-heading {\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n\n  .app-name-label {\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .app-category-label {\n    font-size: 8px;\n    font-weight: 600;\n    line-height: 8px;\n  }\n}\n\n@media (max-width: 360px) {\n  .edit-common-icons {\n    gap: 2px;\n  }\n\n  .prompt-tabs-link {\n    font-size: 13px;\n    line-height: 27px;\n  }\n}\n\n#w-node-f324eca9-b2d0-c27d-e0cc-05fe1ee153cc-32048603,\n#w-node-_783c6719-fc73-f8ba-c852-c01966d16bf5-32048603 {\n  grid-area: span 1 / span 1 / span 1 / span 1;\n}\n\n@media screen and (max-width: 479px) {\n  #w-node-f324eca9-b2d0-c27d-e0cc-05fe1ee153be-32048603 {\n    grid-area: span 1 / span 1 / span 1 / span 1;\n  }\n}\n\n@media (max-width: 390px) {\n  .chat-event-btn-wrapper {\n    inset: auto auto 114px !important;\n  }\n}\n\n@media (max-width: 385px) {\n  .pagination-container .padding-right-5 {\n    padding-right: 0 !important;\n  }\n\n  .chat-event-btn-wrapper {\n    inset: auto auto 111px !important;\n  }\n\n  .chat-terminal-wrapper {\n    min-height: calc(82vh - 80px);\n    max-height: calc(82vh - 80px);\n  }\n\n  .chatbox {\n    max-height: calc(59vh - 57px);\n    overflow: auto;\n  }\n}\n\n@media (max-width: 360px) {\n  .chat-event-btn-wrapper {\n    inset: auto auto 138px !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .linkclass-clicked {\n    width: calc(100vw - 832px);\n  }\n\n  .chat-sidebar {\n    width: calc(100vw - 375px);\n  }\n\n  .dark-theme .dash-menu .dropdown-item {\n    color: #053a64;\n  }\n\n  .dark-theme .dash-menu .dropdown-item .menu-icon-nested {\n    filter: invert(1);\n  }\n\n  .dark-theme .dash-menu .dropdown-item:hover {\n    color: #fff;\n    background-color: #053a64;\n  }\n\n  .dark-theme .dash-menu .dropdown-item:hover .menu-icon-nested {\n    filter: invert(0);\n  }\n\n  .dark-theme .dash-menu.open .dropdown-item {\n    color: #fff;\n  }\n\n  .dark-theme .dash-menu.open .dropdown-item .menu-icon-nested {\n    filter: invert(0);\n  }\n\n  .dark-theme .dash-menu.open .dropdown-item:hover {\n    color: #053a64;\n    background-color: #fff;\n  }\n\n  .dark-theme .dash-menu.open .dropdown-item:hover .menu-icon-nested {\n    filter: invert(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
